import React, { useEffect } from 'react';
import svgpanzoom from 'svg-pan-zoom';
import './Alpha2Ver3DeviceStyle.css';
import { getSequenceName } from '../../utils';
let schematicDiagram = null;
const DeviceSchematicAlpha2SvgVer3 = sensorData => {
  //Ball valves
  //===========
  let { ShowSensors, unitComponentParts, siteAssociations, unitId, resetDiagram } = sensorData;

  let clsshow_sensor = ShowSensors ? 'show-sensor' : 'hide-sensor';
  const svgElement = document.querySelector('#dv-schematics');
  var options = {
    zoomEnabled: true,
    mouseWheelZoomEnabled: sensorData.enableMouseZoom,
    controlIconsEnabled: true,

    fit: true,
    center: true,
    contain: true
  };

  if (svgElement) {
    schematicDiagram = svgpanzoom(svgElement, options);

    if (sensorData.enableMouseZoom) {
      schematicDiagram.enableMouseWheelZoom();
    } else {
      schematicDiagram.disableMouseWheelZoom();
    }
  }

  const onResize = () => {
    if (schematicDiagram) {
      // schematicDiagram.reset();
      schematicDiagram.resize();
    }
  };

  useEffect(() => {
    window.addEventListener('resize', onResize);
  }, [onResize]); // Only initialize listener on initial render

  useEffect(() => {
    if (resetDiagram && schematicDiagram) {
      schematicDiagram.reset();
    }
  }, [resetDiagram]);

  // Current State
  let sequenceState = sensorData && sensorData.SensorData && sensorData.SensorData && sensorData.SensorData.current_state;
  let lblCurrent_sequence = getSequenceName([], sequenceState).Name;

  //Legends

  let clslegend_line1 = 'legend-brown_dark';
  let legend_line_1 = 'INPUT WATER';

  let legend_line_2 = 'TANK 1 WATER';
  let clslegend_line2 = 'legend-brown_light';

  let legend_line_3 = 'PRE-FILTERED WATER';
  let clslegend_line3 = 'legend-blue_dark';

  let legend_line_4 = 'CLEAN WATER';
  let clslegend_line4 = 'legend-blue_light';

  let legend_line_5 = 'CHLORINE';
  let clslegend_line5 = 'legend-yellow';

  let legend_line_6 = 'CHLORINATED WATER';
  let clslegend_line6 = 'legend-orange';

  let legend_line_7 = 'AIR';
  let clslegend_line7 = 'legend-purple';

  // valve state data
  let vbl101 = sensorData && sensorData.SensorData && sensorData.SensorData.state && sensorData.SensorData.state.vbl101_position;
  let vbl102 = sensorData && sensorData.SensorData && sensorData.SensorData.state && sensorData.SensorData.state.vbl102_position;
  let vbl105 = sensorData && sensorData.SensorData && sensorData.SensorData.state && sensorData.SensorData.state.vbl105_position;
  let vbl106 = sensorData && sensorData.SensorData && sensorData.SensorData.state && sensorData.SensorData.state.vbl106_position;
  let vbl107 = sensorData && sensorData.SensorData && sensorData.SensorData.state && sensorData.SensorData.state.vbl107_position;
  let vbl108 = sensorData && sensorData.SensorData && sensorData.SensorData.state && sensorData.SensorData.state.vbl108_position;
  let vbl109 = sensorData && sensorData.SensorData && sensorData.SensorData.state && sensorData.SensorData.state.vbl109_position;
  let vbl110 = sensorData && sensorData.SensorData && sensorData.SensorData.state && sensorData.SensorData.state.vbl110_position;
  let vbl111 = sensorData && sensorData.SensorData && sensorData.SensorData.state && sensorData.SensorData.state.vbl111_position;
  let vbl112 = sensorData && sensorData.SensorData && sensorData.SensorData.state && sensorData.SensorData.state.vbl112_position;
  let vbl113 = sensorData && sensorData.SensorData && sensorData.SensorData.state && sensorData.SensorData.state.vbl113_position;
  let vbl114 = sensorData && sensorData.SensorData && sensorData.SensorData.state && sensorData.SensorData.state.vbl114_position;
  let vbl115 = sensorData && sensorData.SensorData && sensorData.SensorData.state && sensorData.SensorData.state.vbl115_position;
  let vbl116 = sensorData && sensorData.SensorData && sensorData.SensorData.state && sensorData.SensorData.state.vbl116_position;
  let vbl118 = sensorData && sensorData.SensorData && sensorData.SensorData.state && sensorData.SensorData.state.vbl118_position;
  let vbl119 = sensorData && sensorData.SensorData && sensorData.SensorData.state && sensorData.SensorData.state.vbl119_position;
  let vbl120 = sensorData && sensorData.SensorData && sensorData.SensorData.state && sensorData.SensorData.state.vbl120_position;
  let dsw101 = sensorData && sensorData.SensorData && sensorData.SensorData.state && sensorData.SensorData.state.dsw101_position;

  // pump sensor data
  let ppf101 = sensorData && sensorData.SensorData && sensorData.SensorData.state && sensorData.SensorData.state.ppf101_state;
  let ppf101_speedpercentage = sensorData && sensorData.SensorData && sensorData.SensorData.ppf101_speedpercentage;
  let ppf101_value = ShowSensors
    ? ppf101_speedpercentage != null && ppf101_speedpercentage.toFixed
      ? ppf101_speedpercentage.toFixed(2) + '%'
      : 'N/A'
    : 'PPF101';
  let ppa102 = sensorData && sensorData.SensorData && sensorData.SensorData.state && sensorData.SensorData.state.ppa102_state;
  let ppa102_speed = sensorData && sensorData.SensorData && sensorData.SensorData.ppa102_speed;
  let ppa102_value = ShowSensors ? (ppa102_speed != null ? ppa102_speed : 'N/A') : 'PPA102';
  let ppa101 = sensorData && sensorData.SensorData && sensorData.SensorData.state && sensorData.SensorData.state.ppa101_state;
  let ppa101_speed = sensorData && sensorData.SensorData && sensorData.SensorData.ppa101_speed;
  let ppa101_value = ShowSensors ? (ppa101_speed != null ? ppa101_speed : 'N/A') : 'PPA101';
  let ppc101 = sensorData && sensorData.SensorData && sensorData.SensorData.state && sensorData.SensorData.state.ppc101_state;
  let ppc101_rpm = sensorData && sensorData.SensorData && sensorData.SensorData.ppc101_rpm;
  let ppc101_value = ShowSensors ? (ppc101_rpm != null ? ppc101_rpm : 'N/A') : 'PPC101';

  // prressure sensor data
  let ptc101 = sensorData && sensorData.SensorData && sensorData.SensorData.ptc101_pressure;
  let ptc101_value = ShowSensors ? (ptc101 != null ? ptc101 : 'N/A') : 'PTC101';
  let ptc10y = sensorData && sensorData.SensorData && sensorData.SensorData.ptc10y_pressure;
  let ptc10y_value = ShowSensors ? (ptc10y != null ? ptc10y : 'N/A') : 'PTC10Y';
  let ptc103 = sensorData && sensorData.SensorData && sensorData.SensorData.ptc103_pressure;
  let ptc103_value = ShowSensors ? (ptc103 != null ? ptc103 : 'N/A') : 'PTC103';
  let ptc104 = sensorData && sensorData.SensorData && sensorData.SensorData.ptc104_pressure;
  let ptc104_value = ShowSensors ? (ptc104 != null ? ptc104 : 'N/A') : 'PTC104';
  let ptc105 = sensorData && sensorData.SensorData && sensorData.SensorData.ptc105_pressure;
  let ptc105_value = ShowSensors ? (ptc105 != null ? ptc105 : 'N/A') : 'PTC105';
  let ptc106 = sensorData && sensorData.SensorData && sensorData.SensorData.ptc106_pressure;
  let ptc106_value = ShowSensors ? (ptc106 != null ? ptc106 : 'N/A') : 'PTC106';
  let ptc107 = sensorData && sensorData.SensorData && sensorData.SensorData.ptc107_pressure;
  let ptc107_value = ShowSensors ? (ptc107 != null ? ptc107 : 'N/A') : 'PTC107';
  let ptc108 = sensorData && sensorData.SensorData && sensorData.SensorData.ptc108_pressure;
  let ptc108_value = ShowSensors ? (ptc108 != null ? ptc108 : 'N/A') : 'PTC108';
  let ptc109 = sensorData && sensorData.SensorData && sensorData.SensorData.ptc109_pressure;
  let ptc109_value = ShowSensors ? (ptc109 != null ? ptc109 : 'N/A') : 'PTC109';
  let ptc110 = sensorData && sensorData.SensorData && sensorData.SensorData.ptc110_pressure;
  let ptc110_value = ShowSensors ? (ptc110 != null ? ptc110 : 'N/A') : 'PTC110';
  let ptc111 = sensorData && sensorData.SensorData && sensorData.SensorData.ptc111_pressure;
  let ptc111_value = ShowSensors ? (ptc111 != null ? ptc111 : 'N/A') : 'PTC111';
  let ptc112 = sensorData && sensorData.SensorData && sensorData.SensorData.ptc112_pressure;
  let ptc112_value = ShowSensors ? (ptc112 != null ? ptc112 : 'N/A') : 'PTC112';
  let ptc113 = sensorData && sensorData.SensorData && sensorData.SensorData.ptc113_pressure;
  let ptc113_value = ShowSensors ? (ptc113 != null ? ptc113 : 'N/A') : 'PTC113';
  let ptc102 = sensorData && sensorData.SensorData && sensorData.SensorData.ptc102_pressure;
  let ptc102_value = ShowSensors ? (ptc102 != null ? ptc102 : 'N/A') : 'PTC102';
  let ptc114 = sensorData && sensorData.SensorData && sensorData.SensorData.ptc114_pressure;
  let ptc114_value = ShowSensors ? (ptc114 != null ? ptc114 : 'N/A') : 'PTC114';

  // tank sensor data
  let tnk101_capacity = 20;
  let tnk101_schematic_overlay_height = 25;
  let tnk101 = sensorData && sensorData.SensorData && sensorData.SensorData.tnk101_volume;
  let tnk101_value = ShowSensors ? (tnk101 != null ? tnk101 : 'N/A') : 'TNK101';
  let tnk101_fill_value = !isNaN(tnk101) ? (tnk101_schematic_overlay_height / tnk101_capacity) * tnk101 : 0;
  if (tnk101_fill_value > tnk101_schematic_overlay_height) tnk101_fill_value = tnk101_schematic_overlay_height;
  if (tnk101_fill_value < 0) tnk101_fill_value = 0;

  let tnk102_capacity = 60;
  let tnk102_schematic_overlay_height = 30;
  let tnk102 = sensorData && sensorData.SensorData && sensorData.SensorData.tnk102_volume;
  let tnk102_value = ShowSensors ? (tnk102 != null ? tnk102 : 'N/A') : 'TNK102';
  let tnk102_fill_value = !isNaN(tnk102) ? (tnk102_schematic_overlay_height / tnk102_capacity) * tnk102 : 0;
  if (tnk102_fill_value > tnk102_schematic_overlay_height) tnk102_fill_value = tnk102_schematic_overlay_height;
  if (tnk102_fill_value < 0) tnk102_fill_value = 0;

  let tnk104_capacity = 20;
  let tnk104_schematic_overlay_height = 11;
  let tnk104 = sensorData && sensorData.SensorData && sensorData.SensorData.tnk104_volume;
  let tnk104_value = ShowSensors ? (tnk104 != null ? tnk104 : '') : 'TNK104';
  let tnk104_fill_value = !isNaN(tnk104) ? (tnk104_schematic_overlay_height / tnk104_capacity) * tnk104 : 0;
  if (tnk104_fill_value > tnk104_schematic_overlay_height) tnk104_fill_value = tnk104_schematic_overlay_height;
  if (tnk104_fill_value < 0) tnk104_fill_value = 0;

  // turbidity sensor data
  let trb101 = sensorData && sensorData.SensorData && sensorData.SensorData.trb101_turbidity;
  let trb101_value = ShowSensors ? (trb101 != null ? trb101 : 'N/A') : 'TRB101';
  let trb102 = sensorData && sensorData.SensorData && sensorData.SensorData.trb102_turbidity;
  let trb102_value = ShowSensors ? (trb102 != null ? trb102 : 'N/A') : 'TRB102';

  // flow sensor data
  let ftr101 = sensorData && sensorData.SensorData && sensorData.SensorData.ftr101_flowrate;
  let ftr101_value = ShowSensors ? (ftr101 != null ? ftr101 : 'N/A') : 'FTR101';
  let ftr102 = sensorData && sensorData.SensorData && sensorData.SensorData.ftr102_flowrate;
  let ftr102_value = ShowSensors ? (ftr102 != null ? ftr102 : 'N/A') : 'FTR102';
  let ftr103 = sensorData && sensorData.SensorData && sensorData.SensorData.ftr103_flowrate;
  let ftr103_value = ShowSensors ? (ftr103 != null ? ftr103 : 'N/A') : 'FTR103';

  // uv sensor data
  let uvm101 = sensorData && sensorData.SensorData && sensorData.SensorData.state && sensorData.SensorData.state.uvm101_state;
  let uvi101 = sensorData && sensorData.SensorData && sensorData.SensorData.uvi101_intensity;
  let uvi101_value = ShowSensors ? (uvi101 != null ? uvi101 : 'N/A') : 'UVI101';
  let uvd101 = sensorData && sensorData.SensorData && sensorData.SensorData.uvd101_dosage;
  let uvd101_value = ShowSensors ? (uvd101 != null ? uvd101 : 'N/A') : 'UVD101';

  // load cell sensor data
  let lcl101 = sensorData && sensorData.SensorData && sensorData.SensorData.lcl101_weight;
  let lcl101_value = ShowSensors ? (lcl101 != null ? lcl101 : 'N/A') : 'LCL101';

  //Conductivity
  // load cell sensor data
  let ctr101 = sensorData && sensorData.SensorData && sensorData.SensorData.ctr101_tds;
  let ctr101_value = ShowSensors ? (ctr101 != null ? ctr101 : 'N/A') : 'CTR101';

  let ctr102 = sensorData && sensorData.SensorData && sensorData.SensorData.ctr102_tds;
  let ctr102_value = ShowSensors ? (ctr102 != null ? ctr102 : 'N/A') : 'CTR102';

  let acp101 = sensorData && sensorData.SensorData && sensorData.SensorData.acp101_power;
  let acp101_value = ShowSensors ? (acp101 != null ? acp101 : 'N/A') : 'ACP101';

  let ttr101 = sensorData && sensorData.SensorData && sensorData.SensorData.ttr101_temperature;
  let ttr101_value = ShowSensors ? (ttr101 != null ? ttr101 : 'N/A') : 'TTR101';

  // BMS
  let bms101_volts = (sensorData && sensorData.SensorData && sensorData.SensorData.bms101_voltage) || '-';
  let bms101_grid1 = (sensorData && sensorData.SensorData && sensorData.SensorData.bms101_gridl1) || '-';
  let bms101_percentage = (sensorData && sensorData.SensorData && sensorData.SensorData.bms101_percentage) || '-';
  let bms101_percentage_value = (sensorData && sensorData.SensorData && sensorData.SensorData.bms101_percentage) || 0;
  let bms101_acco = (sensorData && sensorData.SensorData && sensorData.SensorData.bms101_accomsumption) || '-';

  let clsbms101_body = 'bms-body-empty';
  let clsbms101_25 = 'bms-empty ';
  let clsbms101_50 = 'bms-empty ';
  let clsbms101_75 = 'bms-empty ';
  let clsbms101_100 = 'bms-empty ';

  if (bms101_volts !== '-') bms101_volts += ' volts dc';
  if (bms101_grid1 !== '-') bms101_grid1 += ' watts';
  if (bms101_acco !== '-') bms101_acco += ' watts';
  if (bms101_percentage !== '-') bms101_percentage += ' %';

  // coloring BMS
  if (bms101_percentage_value) {
    if (bms101_percentage_value > 95) {
      clsbms101_body = 'bms-body-100';
      clsbms101_100 = 'bms-100';
      clsbms101_75 = clsbms101_100;
      clsbms101_50 = clsbms101_100;
      clsbms101_25 = clsbms101_100;
    } else if (bms101_percentage_value > 75) {
      clsbms101_body = 'bms-body-75';
      clsbms101_75 = 'bms-75';
      clsbms101_50 = clsbms101_75;
      clsbms101_25 = clsbms101_75;
    } else if (bms101_percentage_value > 50) {
      clsbms101_body = 'bms-body-50';
      clsbms101_50 = 'bms-50';
      clsbms101_25 = clsbms101_50;
    } else if (bms101_percentage_value > 0) {
      clsbms101_body = 'bms-body-25';
      clsbms101_25 = 'bms-25';
    } else {
    }
  } else {
    clsbms101_body = 'bms-body-empty';
    clsbms101_100 = 'bms-cell-empty';
    clsbms101_75 = clsbms101_100;
    clsbms101_50 = clsbms101_100;
    clsbms101_25 = clsbms101_100;
  }

  // colour the valves
  let clsvbl101_body =
    vbl101 === undefined
      ? 'ver1-sen-amber'
      : vbl101 === 'closed'
        ? 'ver1-sen-none'
        : vbl101 === 'open'
          ? 'ver1-sen-green_dark'
          : 'ver1-sen-amber';
  let vbl101_value = vbl101 === undefined ? 'N/A' : vbl101;

  let clsvbl102_body =
    vbl102 === undefined
      ? 'ver1-sen-amber'
      : vbl102 === 'closed'
        ? 'ver1-sen-none'
        : vbl102 === 'open'
          ? 'ver1-sen-green_dark'
          : 'ver1-sen-amber';
  let vbl102_value = vbl102 === undefined ? 'N/A' : vbl102;

  let clsvbl105_body =
    vbl105 === undefined
      ? 'ver1-sen-amber'
      : vbl105 === 'closed'
        ? 'ver1-sen-none'
        : vbl105 === 'open'
          ? 'ver1-sen-green_dark'
          : 'ver1-sen-amber';
  let vbl105_value = vbl105 === undefined ? 'N/A' : vbl105;

  let clsvbl106_body =
    vbl106 === undefined
      ? 'ver1-sen-amber'
      : vbl106 === 'closed'
        ? 'ver1-sen-none'
        : vbl106 === 'open'
          ? 'ver1-sen-green_dark'
          : 'ver1-sen-amber';
  let vbl106_value = vbl106 === undefined ? 'N/A' : vbl106;

  let clsvbl107_body =
    vbl107 === undefined
      ? 'ver1-sen-amber'
      : vbl107 === 'closed'
        ? 'ver1-sen-none'
        : vbl107 === 'open'
          ? 'ver1-sen-green_dark'
          : 'ver1-sen-amber';
  let vbl107_value = vbl107 === undefined ? 'N/A' : vbl107;

  let clsvbl108_body =
    vbl108 === undefined
      ? 'ver1-sen-amber'
      : vbl108 === 'closed'
        ? 'ver1-sen-none'
        : vbl108 === 'open'
          ? 'ver1-sen-green_dark'
          : 'ver1-sen-amber';
  let vbl108_value = vbl108 === undefined ? 'N/A' : vbl108;

  let clsvbl109_body =
    vbl109 === undefined
      ? 'ver1-sen-amber'
      : vbl109 === 'closed'
        ? 'ver1-sen-none'
        : vbl109 === 'open'
          ? 'ver1-sen-green_dark'
          : 'ver1-sen-amber';
  let vbl109_value = vbl109 === undefined ? 'N/A' : vbl109;

  let clsvbl110_body =
    vbl110 === undefined
      ? 'ver1-sen-amber'
      : vbl110 === 'closed'
        ? 'ver1-sen-none'
        : vbl110 === 'open'
          ? 'ver1-sen-green_dark'
          : 'ver1-sen-amber';
  let vbl110_value = vbl110 === undefined ? 'N/A' : vbl110;

  let clsvbl111_body =
    vbl111 === undefined
      ? 'ver1-sen-amber'
      : vbl111 === 'closed'
        ? 'ver1-sen-none'
        : vbl111 === 'open'
          ? 'ver1-sen-green_dark'
          : 'ver1-sen-amber';
  let vbl111_value = vbl111 === undefined ? 'N/A' : vbl111;

  let clsvbl112_body =
    vbl112 === undefined
      ? 'ver1-sen-amber'
      : vbl112 === 'closed'
        ? 'ver1-sen-none'
        : vbl112 === 'open'
          ? 'ver1-sen-green_dark'
          : 'ver1-sen-amber';
  let vbl112_value = vbl112 === undefined ? 'N/A' : vbl112;

  let clsvbl113_body =
    vbl113 === undefined
      ? 'ver1-sen-amber'
      : vbl113 === 'closed'
        ? 'ver1-sen-none'
        : vbl113 === 'open'
          ? 'ver1-sen-green_dark'
          : 'ver1-sen-amber';
  let vbl113_value = vbl113 === undefined ? 'N/A' : vbl113;

  let clsvbl114_body =
    vbl114 === undefined
      ? 'ver1-sen-amber'
      : vbl114 === 'closed'
        ? 'ver1-sen-none'
        : vbl114 === 'open'
          ? 'ver1-sen-green_dark'
          : 'ver1-sen-amber';
  let vbl114_value = vbl114 === undefined ? 'N/A' : vbl114;

  let clsvbl115_body =
    vbl115 === undefined
      ? 'ver1-sen-amber'
      : vbl115 === 'closed'
        ? 'ver1-sen-none'
        : vbl115 === 'open'
          ? 'ver1-sen-green_dark'
          : 'ver1-sen-amber';
  let vbl115_value = vbl115 === undefined ? 'N/A' : vbl115;

  let clsvbl116_body =
    vbl116 === undefined
      ? 'ver1-sen-amber'
      : vbl116 === 'closed'
        ? 'ver1-sen-none'
        : vbl116 === 'open'
          ? 'ver1-sen-green_dark'
          : 'ver1-sen-amber';
  let vbl116_value = vbl116 === undefined ? 'N/A' : vbl116;

  let clsvbl118_body =
    vbl118 === undefined
      ? 'ver1-sen-amber'
      : vbl118 === 'closed'
        ? 'ver1-sen-none'
        : vbl118 === 'open'
          ? 'ver1-sen-green_dark'
          : 'ver1-sen-amber';
  let vbl118_value = vbl118 === undefined ? 'N/A' : vbl118;

  let clsvbl119_body =
    vbl119 === undefined
      ? 'ver1-sen-amber'
      : vbl119 === 'closed'
        ? 'ver1-sen-none'
        : vbl119 === 'open'
          ? 'ver1-sen-green_dark'
          : 'ver1-sen-amber';
  let vbl119_value = vbl119 === undefined ? 'N/A' : vbl119;

  let clsvbl120_body =
    vbl120 === undefined
      ? 'ver1-sen-amber'
      : vbl120 === 'closed'
        ? 'ver1-sen-none'
        : vbl120 === 'open'
          ? 'ver1-sen-green_dark'
          : 'ver1-sen-amber';
  let vbl120_value = vbl120 === undefined ? 'N/A' : vbl120;
  let clsdsw101_body =
    dsw101 === undefined
      ? 'ver1-sen-amber'
      : dsw101 === 'closed'
        ? 'ver1-sen-none'
        : dsw101 === 'open'
          ? 'ver1-sen-green_dark'
          : 'ver1-sen-amber';
  let dsw101_value = dsw101 === undefined ? 'N/A' : dsw101;

  // colour the sensors
  let clsppf101_body =
    ppf101 === undefined
      ? 'ver1-sen-amber'
      : ppf101 === 'off'
        ? 'ver1-sen-none'
        : ppf101 === 'on'
          ? 'ver1-sen-green_dark'
          : 'ver1-sen-white';
  let clsppa102_body =
    ppa102 === undefined
      ? 'ver1-sen-amber'
      : ppa102 === 'off'
        ? 'ver1-sen-none'
        : ppa102 === 'on'
          ? 'ver1-sen-green_dark'
          : 'ver1-sen-white';
  let clsppa101_body =
    ppa101 === undefined
      ? 'ver1-sen-amber'
      : ppa101 === 'off'
        ? 'ver1-sen-none'
        : ppa101 === 'on'
          ? 'ver1-sen-green_dark'
          : 'ver1-sen-white';
  let clsppc101_body =
    ppc101 === undefined
      ? 'ver1-sen-amber'
      : ppc101 === 'off'
        ? 'ver1-sen-none'
        : ppc101 === 'on'
          ? 'ver1-sen-green_dark'
          : 'ver1-sen-white';
  let clsptc101_body = ptc101 === undefined ? 'ver1-sen-amber' : 'ver1-sen-green_light';
  let clsptc10y_body = ptc10y === undefined ? 'ver1-sen-amber' : 'ver1-sen-green_light';
  let clsptc103_body = ptc103 === undefined ? 'ver1-sen-amber' : 'ver1-sen-green_light';
  let clsptc103_line = tnk101_value > 0 ? 'ver1-line-blue_dark' : '';
  let clsptc104_body = ptc104 === undefined ? 'ver1-sen-amber' : 'ver1-sen-green_light';

  let clsptc105_body = ptc105 === undefined ? 'ver1-sen-amber' : 'ver1-sen-green_light';
  let clsptc106_body = ptc106 === undefined ? 'ver1-sen-amber' : 'ver1-sen-green_light';
  let clsptc106_line = tnk102_value > 0 ? 'ver1-line-blue_dark' : '';
  let clsptc107_body = ptc107 === undefined ? 'ver1-sen-amber' : 'ver1-sen-green_light';
  let clsptc108_body = ptc108 === undefined ? 'ver1-sen-amber' : 'ver1-sen-green_light';
  let clsptc109_body = ptc109 === undefined ? 'ver1-sen-amber' : 'ver1-sen-green_light';
  let clsptc110_body = ptc110 === undefined ? 'ver1-sen-amber' : 'ver1-sen-green_light';
  let clsptc111_body = ptc111 === undefined ? 'ver1-sen-amber' : 'ver1-sen-green_light';
  let clsptc112_body = ptc112 === undefined ? 'ver1-sen-amber' : 'ver1-sen-green_light';
  let clsptc113_body = ptc113 === undefined ? 'ver1-sen-amber' : 'ver1-sen-green_light';
  let clsptc102_body = ptc102 === undefined ? 'ver1-sen-amber' : 'ver1-sen-green_light';
  let clsptc114_body = ptc114 === undefined ? 'ver1-sen-amber' : 'ver1-sen-green_light';

  let clstrb101_body = trb101 === undefined ? 'ver1-sen-amber' : 'ver1-sen-green_light';
  let clstrb102_body = trb102 === undefined ? 'ver1-sen-amber' : 'ver1-sen-green_light';
  let clsftr101_body = ftr101 === undefined ? 'ver1-sen-amber' : 'ver1-sen-green_light';
  let clsftr102_body = ftr102 === undefined ? 'ver1-sen-amber' : 'ver1-sen-green_light';
  let clsftr103_body = ftr103 === undefined ? 'ver1-sen-amber' : 'ver1-sen-green_light';
  let clsctr101_body = ctr101 === undefined ? 'ver1-sen-amber' : 'ver1-sen-green_light';
  let clsctr102_body = ctr102 === undefined ? 'ver1-sen-amber' : 'ver1-sen-green_light';
  let clsacp101_body = acp101 === undefined ? 'ver1-sen-amber' : 'ver1-sen-green_light';
  let clsttr101_body = ttr101 === undefined ? 'ver1-sen-amber' : 'ver1-sen-green_light';
  // uvi101 sensor - colour light green if the uvi has received data
  let clsuvi101_body = uvi101 === undefined ? 'ver1-sen-amber' : 'ver1-sen-green_light';

  // lcl101 - sensor - colour light green if there has been data
  let clslcl101_body = lcl101 === undefined ? 'ver1-sen-amber' : 'ver1-sen-green_light';

  // tank levels should be calcu;ated against a setpoint if possible
  // tank 1 is a 100 litre tank
  let clstnk101_overlay = 'ver1-sen-blue_dark';
  let clstnk101_overlay_bottom = tnk101_fill_value > 0 ? 'ver1-sen-blue_dark' : '';

  // tank 2 is a 100 litre tank
  let clstnk102_overlay = 'ver1-sen-blue_dark';
  let clstnk102_overlay_bottom = tnk102_fill_value > 0 ? 'ver1-sen-blue_dark' : '';

  // tank 4 is a 20 litre tank
  let clstnk104_overlay = 'ver1-sen-blue_dark';

  let clstnk104_body = '';
  let clstnk102_top = '';

  let clsoutput_arrow_body = '';

  let clsppf101_centre = '';
  let clsflu101_feed_body = '';
  let clsinpput_line_1 = 'ver1-line-blue_dark';
  let clswaste_line_5 = '';
  let clswaste_line_1 = '';
  let clssample_arrow_body = '';

  let clsdit_arrow_body = '';
  let clsaair_arrow3_body = '';

  // uvm body is coloured if uivm101 is on
  // if the lamp if on then colour the uv body
  let clsuvm101_body =
    uvm101 === undefined
      ? 'ver1-sen-amber'
      : uvm101 === 'off'
        ? 'ver1-sen-white'
        : uvm101 === 'on'
          ? 'ver1-sen-green_dark'
          : 'ver1-sen-white';
  // if the lamp is on and uv dosage is above 186 then colur violet, if lamp is on and less than 186 then colur dark green else lamp body is white
  let clsuvm101_lamp_body =
    uvi101 === undefined ? 'ver1-sen-amber' : uvm101 === 'off' ? 'sen_white' : uvi101 > 12 ? 'ver1-sen-violet' : 'ver1-sen-green_dark';

  // input line 1 - before vml101
  let clsinput_line_1 = 'ver1-line-blue_dark';
  let clsinput_arrow_body = 'ver1-sen-blue_dark';
  // input line 2 - before vbl101
  let clsinput_line_2 = 'ver1-line-blue_dark';
  // input line 3 - vbl101 to flm101
  let clsinput_line_3 = vbl101 === 'open' ? 'ver1-line-blue_dark' : 'ver1-line-default';
  // flm101_line - flm101 to vbl102
  let clsflm101_line = vbl101 === 'open' ? 'ver1-line-blue_dark' : 'ver1-line-default';
  let clsflm101_body = vbl101 === 'open' ? 'ver1-sen-blue_dark' : 'sen_white';
  // vbl102_line - vbl102 drain to waste
  let clsvbl102_line = vbl101 === 'open' && vbl102 === 'open' ? 'ver1-line-blue_dark' : 'hash-line-default';
  // input line 4 - flm101 to tnk101
  let clsinput_line_4 = vbl101 === 'open' ? 'ver1-line-blue_dark' : 'ver1-line-default';
  // input line 5 - tnk101 to vbl118
  let clsinput_line_5 = tnk101 > 0 ? 'ver1-line-blue_dark' : 'ver1-line-default';
  // tnk101_line - tank 101 drain to vbl120
  let clstnk101_line = tnk101 > 0 ? 'ver1-line-blue_dark' : 'ver1-line-default';
  let clsvbl120_line = vbl120 === 'open' ? clstnk101_line : 'hash-line-default';

  let clsoutput_line_11 =
    ppf101 === 'on' && vbl118 === 'open' && vbl108 === 'open'
      ? 'ver1-line-blue_dark'
      : ppf101 === 'on' && vbl108 === 'open' && vbl112 === 'open' && (vbl109 === 'open' || vbl113 === 'open')
        ? 'ver1-line-blue_dark'
        : ppf101 === 'on' && ppc101 === 'on' && vbl108 === 'open' && vbl112 === 'open' && (vbl109 === 'open' || vbl113 === 'open')
          ? 'ver1-line-orange'
          : 'ver1-line-default';

  // tnk102_line_1 - tank 2 drain line
  let clstnk102_line_1 = tnk102 > 0 ? 'ver1-line-blue_dark' : 'ver1-line-default';
  // tnk102_line_2 - vnr108 to vbl119
  let clstnk102_line_2 = clstnk102_line_1;

  let clsvnr108_body = clstnk102_line_2;

  // tnk104_Line_1 - tank 104 to ppc101
  let clstnk104_line_1 = ppc101 === 'on' ? 'ver1-line-blue_dark' : 'ver1-line-default';
  // tnk104_line_2 - ppc101 to vnr104
  let clstnk104_line_2 = clstnk104_line_1;
  let clsvnr104_body = clstnk104_line_2;
  // tnk104_line_3 - vnr104 to vbl119
  let clstnk104_line_3 = ppc101 === 'on' ? 'ver1-line-blue_dark' : clstnk102_line_2;
  // vbl119_line - vbl119 to ppf101
  let clsvbl119_line = 'ver1-line-default';
  if (vbl119 === 'open') {
    clsvbl119_line = clstnk104_line_3;
  } else if (vbl118 === 'open') {
    clsvbl119_line = 'ver1-line-blue_dark';
  }

  // input line 6 - vbl118 to ppf101
  let clsinput_line_6 = 'ver1-line-default';
  if (vbl119 === 'open') {
    clsinput_line_6 = clstnk104_line_3;
  } else if (vbl118 === 'open') {
    clsinput_line_6 = 'ver1-line-blue_dark';
  }

  // input line 7 - after ppf101
  let clsinput_line_7 = ppf101 === 'on' ? clsinput_line_6 : 'ver1-line-default';
  // input line 8 - down to flm102
  let clsinput_line_8 = clsinput_line_7;

  // input line 9 - between flm102 and flm103
  let clsinput_line_9 =
    clsinput_line_8 !== 'ver1-line-default'
      ? clsinput_line_8 === 'ver1-line-orange'
        ? clsinput_line_8
        : 'ver1-line-blue_dark'
      : 'ver1-line-default';

  let clsflm102_line = clsinput_line_9;

  // vbl105_line - from vbl105 to waste line 1
  let clsvbl105_line = vbl105 === 'open' ? clsflm102_line : 'hash-line-default';

  // input line 10 - after flm103 and vbl108
  let clsinput_line_10 =
    clsinput_line_9 !== 'ver1-line-default'
      ? clsinput_line_9 === 'ver1-line-orange'
        ? clsinput_line_9
        : 'ver1-line-blue_dark'
      : 'ver1-line-default';
  // flm103_line - drain from flm103 to vbl106
  let clsflm103_body =
    clsinput_line_9 !== 'ver1-line-default'
      ? clsinput_line_9 === 'ver1-line-orange'
        ? 'ver1-sen-orange'
        : 'ver1-sen-blue_dark'
      : 'ver1-sen-white';
  let clsflm103_line = clsinput_line_10;

  // vbl106_line - from vbl106 to waste line 1
  let clsvbl106_line = vbl106 === 'open' ? clsflm103_line : 'hash-line-default';
  // input line 11 - after vbl108
  let clsinput_line_11 = vbl108 === 'open' ? clsinput_line_10 : 'ver1-line-default';

  // input line 12 - up tp vml104
  let clsinput_line_12 = clsinput_line_11;

  // input line 13 - down to vbl 110
  let clsinput_line_13 = clsinput_line_12;

  // input line 14 - vml104 to flu101
  let clsinput_line_14 = clsinput_line_12;

  // recirc line 4 - vbl109
  let clsrecirc_line_4 = clsinput_line_7;

  // recirc line 3 - after vbl113
  let clsrecirc_line_3 = clsrecirc_line_4;

  // recirc line 2 - vnr102 to vbl113
  let clsrecirc_line_2 = vbl113 === 'open' ? clsrecirc_line_3 : 'ver1-line-default';

  // recirc line 1 - filtrate to vbl109
  let clsrecirc_line_1 = vbl109 === 'open' ? clsrecirc_line_4 : 'ver1-line-default';

  // flm102_line - drain from flm102 to vbl105
  let clsflm102_body =
    clsinput_line_8 !== 'ver1-line-default'
      ? clsinput_line_8 === 'ver1-line-orange'
        ? 'ver1-sen-orange'
        : 'ver1-sen-blue_dark'
      : 'ver1-sen-white';

  // aair_line_1 - ambient air to ppa101
  let clsaair_arrow = ppa101 === 'on' ? 'ver1-sen-purple' : 'ver1-sen-none';
  let clsaair_line_1 = ppa101 === 'on' ? 'ver1-line-purple' : 'ver1-line-default';
  // aair_line_2 - ppa101 to coil
  let clsaair_line_2 = ppa101 === 'on' ? 'ver1-line-purple' : 'ver1-line-default';
  // clp101_line_1 - coil
  let clsclp101_line_1 = ppa101 === 'on' ? 'ver1-line-purple' : 'ver1-line-default';
  // clp101_line_2 - coil
  // aair_line_3 - coil to aair_arrow1
  let clsaair_line_3 = ppa101 === 'on' ? 'ver1-line-purple' : 'ver1-line-default';
  // aair_line_4 - aair_arrow2 to vnr103
  let clsaair_line_4 = ppa101 === 'on' ? 'ver1-line-purple' : 'ver1-line-default';
  let clsaair_arrow2_body = ppa101 === 'on' ? 'ver1-sen-blue_dark' : 'ver1-sen-white';
  // aair_line_5 - vnr103 to flu101
  let clsaair_line_5 = ppa101 === 'on' || ppa102 === 'on' ? 'ver1-line-purple' : clsinput_line_14;
  let clsvnr107_body = clsaair_line_4;

  // output line 1 - first filtrate line
  let clsoutput_line_1 =
    clsinput_line_14 !== 'ver1-line-default'
      ? clsinput_line_14 === 'ver1-line-orange'
        ? clsinput_line_14
        : 'ver1-line-blue_dark'
      : vbl109 === 'open'
        ? clsrecirc_line_4
        : clsinput_line_14;
  // if there is no waterflow but air pump ppa102 is on then colour purple for outputline
  // clsoutput_line_1 = clsoutput_line_1 === 'ver1-line-default' && (ppa102 === 'on' || ppa101 === 'on') ? 'ver1-line-blue_dark' : clsoutput_line_1;
  if (vbl108 !== 'open') {
    clsinput_line_14 = clsoutput_line_1;
    clsinput_line_11 = clsoutput_line_1;
    clsinput_line_12 = clsoutput_line_1;
    clsinput_line_13 = clsoutput_line_1;
  }

  // uf is coloured if the ppf101 is on, vbl108 is open and vbl110 is closed then it is light browm
  // else it is white
  let clsflu101_body =
    clsoutput_line_1 !== 'ver1-line-default'
      ? clsoutput_line_1 === 'ver1-line-orange'
        ? 'ver1-sen-orange'
        : clsoutput_line_1 === 'ver1-line-blue_dark'
          ? 'ver1-sen-blue_dark'
          : 'ver1-sen-blue_light'
      : 'ver1-sen-white';

  // output line 2 - before vbl112
  // flu101_line - concerntrate from uf filter
  let clsflu101_line = clsoutput_line_1;

  let clsoutput_line_2 = clsoutput_line_1;

  // output line 3 - filtrate near vml105
  let clsoutput_line_3 = clsoutput_line_1;

  // putput line 4 - down to vbl111
  let clsoutput_line_4 = clsoutput_line_1;

  // vbl111_line - from vbl111 to waste line 2
  let clsvbl111_line = vbl111 === 'open' ? clsoutput_line_4 : 'hash-line-default';

  // output line 5 - vbl112 to flm105
  let clsoutput_line_5 = vbl112 === 'open' ? clsoutput_line_2 : 'ver1-line-default';
  // output line 6 - flm105 to vnr102
  let clsoutput_line_6 = clsoutput_line_5;
  let clsflm105_body = clsoutput_line_5;
  let clsvnr102_body = clsflm105_body;
  let clstrb102_body3 = '';
  // output line 7 - vnr102 to uv
  let clsoutput_line_7 = clsrecirc_line_2 !== 'ver1-line-default' ? clsrecirc_line_2 : clsoutput_line_6;

  // output line 8 - uv to vnr105
  let clsoutput_line_8 =
    clsoutput_line_7 === 'ver1-line-orange' || clsoutput_line_7 === 'ver1-line-blue_dark' || clsoutput_line_7 === 'ver1-line-blue_dark'
      ? clsoutput_line_7
      : clsoutput_line_7 !== 'ver1-line-default'
        ? 'ver1-line-blue_dark'
        : 'ver1-line-default';

  let clsvnr105_body = clsoutput_line_8;

  // output line 9 - vnr105 to vbl116
  let clsoutput_line_9 = clsoutput_line_8;
  let clsvbl116_line = vbl116 === 'open' ? clsoutput_line_8 : 'ver1-line-default';

  // output line 10 - down to vml102

  let clsoutput_line_10 = clsoutput_line_9;

  // refill line 1 - before vbl114
  let clsrefill_line_1 = vbl114 === 'open' ? clsoutput_line_8 : 'ver1-line-default';

  // refill line 2 - vbl114 to tnk102
  let clsrefill_line_2 = clsrefill_line_1;

  // dit_line_1 - from dit_arrow to ppa102
  let clsdit_arrow = ppa102 === 'on' ? 'ver1-sen-blue_dark' : 'ver1-sen-white';
  let clsdit_line_1 = ppa102 === 'on' ? 'ver1-line-purple' : 'ver1-line-default';
  // dit_line_2 - from ppa102 to vnr106
  let clsdit_line_2 = ppa102 === 'on' ? 'ver1-line-purple' : 'ver1-line-default';
  // dit_line_3 - from vnr106 to filtrate
  let clsdit_line_3 = ppa102 === 'on' ? 'ver1-line-purple' : 'ver1-line-default';

  let clsvnr106_body = ppa102 === 'on' ? 'ver1-line-purple' : clsdit_line_3;

  // waste1_line_1 - first part of waste line 1
  let clswaste1_line_1 = vbl102 === 'open' ? clsvbl102_line : vbl120 === 'open' ? clsvbl120_line : 'hash-line-default';

  // vbl102 === 'open' || vbl120 === 'open' then clswaste1_line_1 will not be 'hash-line-default'
  let clswaste1_line_2 =
    clswaste1_line_1 !== 'hash-line-default' ? clswaste1_line_1 : vbl105 === 'open' ? clsvbl105_line : 'hash-line-default';
  // waste1_line_3 - third part of waste line 1
  let clswaste1_line_3 =
    clswaste1_line_2 !== 'hash-line-default' ? clswaste1_line_2 : vbl106 === 'open' ? clsvbl106_line : 'hash-line-default';

  // vbl110_line - from vbl110 to waste line 1
  let clsvbl110_line = vbl110 === 'open' ? clsinput_line_13 : 'hash-line-default';
  let clsvbl107_line = clsflu101_line !== 'ver1-line-default' && vbl107 === 'open' ? clsflu101_line : 'hash-line-default';

  // waste1_line_4 - fourth part of waste line 1
  let clswaste1_line_4 =
    clswaste1_line_3 !== 'hash-line-default' ? clswaste1_line_3 : vbl110 === 'open' ? clsvbl110_line : 'hash-line-default';

  // waste1_line_5 - last part of waste line 1
  let clswaste1_line_5 =
    clswaste1_line_4 !== 'hash-line-default' ? clswaste1_line_4 : vbl107 === 'open' ? clsvbl107_line : 'hash-line-default';

  let clsvnr101_body = clswaste1_line_4;
  let clsvsn101_head = clswaste1_line_4;

  // vbl107_line - from vbl107 to waste line 2

  // waste2_line_1 - first part of waste line 2
  let clswaste2_line_1 = clsvbl107_line !== 'ver1-line-default' && vbl107 === 'open' ? clsvbl107_line : 'hash-line-default';
  // waste2_line_2 - second part of waste line 2
  let clswaste2_line_2 = vbl111 === 'open' ? clsvbl111_line : 'hash-line-default';
  // waste2_line_3 - third part of waste line 2

  // vbl115_line - from vbl115 to waste line 2
  let clsoutput_line_12 = clsoutput_line_8;

  let clsvbl115_line = vbl115 === 'open' ? clsoutput_line_12 : 'hash-line-default';
  let clswaste2_line_3 =
    clswaste2_line_2 !== 'hash-line-default' ? clswaste2_line_2 : vbl115 === 'open' ? clsvbl115_line : 'hash-line-default';
  let clsvnr103_body = clswaste2_line_3;

  // waste2_line_4 - last part of waste line 2
  let clswaste2_line_4 = clswaste2_line_3;
  let clsvnr03_body = clswaste2_line_3;
  let clsvsn103_head = clswaste2_line_3;
  let clsvsn101_body = clswaste1_line_5;
  let clswaste1_line_6 = clswaste1_line_5;
  let clswaste1_line_7 = clswaste1_line_6 !== 'hash-line-default' ? clswaste1_line_6 : clswaste2_line_4;
  let clsdrain_arrow_body = 'ver1-line-default'; //clswaste1_line_7 === 'ver1-line-blue_dark' ? 'ver1-sen-blue_dark' : 'ver1-line-default';

  /*
   ********************************************* SVG TO SVGR CONVERSION***************************************
    Following online SVG to SVGR Converter Tool is used 
      https://www.fetoolkit.io/widget/svg-converter  

    Step  1: Copy SVG to INPUT section
    Step  2: Disable Clean Up Ids and Remove Unknowns and Defaults from Settings
    Step  3: Select Option JSX
    Step  4: Copy the converted SVG and paste it in notepad++
    Step  5: Remove JSX code, xmlns tag and ...props attribute
    Step  6: Replace {"{# with {
    Step  7: Replace #}"} with }
    Step  8: Replace "{# with {
    Step  9: Replace #}" with }
    Step  10: Set SVG tag properties as given below
          width="100%"
          height="100%"
          viewBox="20 20 450 250"
          id="dv-schematics"
    Step  11: Copy the SVG from notepad+ and replace SVG section below
    Step 12 : add the  <g>  {gatewayUnit}  </g> just before the last group of the svg 

  */

  const gatewayInfo = (siteAssociations && siteAssociations.find(x => x.UnitId == unitId)) || null;
  let gatewaylink = gatewayInfo && gatewayInfo.GatewayId ? `/unit/process-flow/${gatewayInfo.GatewaySerialNumber}` : '';
  let gatewayUnit =
    gatewayInfo && gatewayInfo.GatewayId ? (
      <a id="gatewaylinkid" xlinkHref={gatewaylink}>
        <g
          id="g2-8"
          style={{
            fontSize: 12,
            overflow: 'visible',
            fill: 'none',
            fillRule: 'evenodd',
            strokeLinecap: 'square',
            strokeMiterlimit: 3
          }}
          transform="matrix(.2633 0 0 .28218 7.425 -64.396)"
        >
          <g id="deviceid" transform="matrix(1.2687 0 0 1.38668 -29.208 -311.231)">
            <g id="shape1280-25" transform="translate(112.188 -4.505)">
              <path
                d="M26.3 840.57v-21.12c0-.35-.16-.69-.43-.94s-.64-.38-1.03-.38H1.46c-.39 0-.76.13-1.03.38-.28.25-.43.59-.43.94v21.12c0 .35.15.69.43.93.27.25.64.39 1.03.39h23.38c.39 0 .76-.14 1.03-.39s.43-.58.43-.93zm-23.38-1.33v-3.62h9.99c.35.93 1.05 1.71 1.97 2.21a4.9 4.9 0 0 0 3.08.53c1.06-.16 2.03-.65 2.72-1.4.7-.74 1.08-1.69 1.08-2.66 0-.98-.39-1.92-1.08-2.67-.7-.74-1.66-1.24-2.72-1.4-1.07-.16-2.16.03-3.08.53-.92.5-1.62 1.29-1.97 2.21H2.92v-12.2h20.45v3.62H13.34c-.35-.93-1.05-1.71-1.97-2.21-.92-.5-2.01-.69-3.07-.53-1.07.16-2.03.65-2.73 1.4a3.9 3.9 0 0 0-1.07 2.66c0 .98.38 1.92 1.07 2.67.7.74 1.67 1.24 2.73 1.4 1.06.16 2.15-.03 3.07-.53.92-.5 1.62-1.29 1.97-2.21h10.03v12.2zm12.67-4.89c0-.29.09-.57.27-.81.18-.25.43-.43.73-.55.3-.11.62-.13.94-.08.31.06.6.2.83.4.22.21.38.47.44.76.06.28.03.58-.09.85s-.33.49-.6.66c-.27.16-.58.24-.9.24-.42-.01-.82-.17-1.12-.44a1.4 1.4 0 0 1-.46-1.03zm-4.97-8.69c0 .29-.09.58-.27.82-.18.24-.43.43-.73.54-.3.11-.62.14-.94.09-.31-.06-.6-.2-.83-.41-.23-.2-.38-.46-.44-.75-.07-.28-.03-.58.09-.85s.33-.5.6-.66c.27-.16.58-.25.9-.25.21 0 .43.03.63.1.21.07.39.18.54.32.16.14.28.3.37.48.08.18.12.38.12.57z"
                className="st10"
                id="path12-9"
                style={{
                  fill: 'none',
                  stroke: '#0a5487',
                  strokeWidth: 1.5,
                  strokeLinecap: 'butt'
                }}
              />
            </g>
            <g id="shape1281-27" transform="translate(18.262 1.264)">
              <path
                d="M90.348 805.595h4.38v-2.64h-4.38v-5.94c0-.26-.09-.51-.25-.73-.16-.22-.38-.39-.65-.49-.26-.1-.55-.12-.84-.07-.28.04-.54.17-.74.35l-14.39 13.02c-.27.26-.42.59-.43.94v33.21c0 .23.06.46.19.66.12.19.3.36.51.48l14.34 7.76c.22.12.47.18.73.18.25 0 .51-.06.73-.18.22-.12.4-.28.53-.49.13-.2.2-.43.2-.66v-5.7h4.38v-2.65h-4.38zm-2.92 43.09-11.47-6.13v-31.9l11.47-10.49z"
                className="st10"
                id="path13-1"
                style={{
                  fill: 'none',
                  stroke: '#0a5487',
                  strokeWidth: 1.5,
                  strokeLinecap: 'butt'
                }}
              />
            </g>
            <g id="shape1282-29" transform="translate(137.827 11.74)">
              <path
                d="M21.11 798.66 6.72 785.6a1.45 1.45 0 0 0-.75-.35c-.28-.05-.57-.03-.84.07-.26.1-.49.27-.65.49-.16.22-.24.47-.24.73v5.94H0v2.64h4.24v37.09H0v2.65h4.24v5.7c0 .23.06.46.19.66.13.21.31.37.54.49.22.12.47.18.73.18.25 0 .51-.06.73-.18l14.36-7.72c.22-.12.39-.29.52-.49.13-.19.19-.42.19-.65v-33.21c.01-.18-.02-.36-.08-.52a1.3 1.3 0 0 0-.31-.46zm-2.51 33.42-11.44 6.16v-48.55l11.47 10.42z"
                className="st10"
                id="path14-3"
                style={{
                  fill: 'none',
                  stroke: '#0a5487',
                  strokeWidth: 1.5,
                  strokeLinecap: 'butt'
                }}
              />
            </g>
            <g id="shape1283-31" transform="translate(127.6 4.688)">
              <path
                d="M5.84 839.24H0v2.65h5.84z"
                className="st10"
                id="path15-5"
                style={{
                  fill: 'none',
                  stroke: '#0a5487',
                  strokeWidth: 1.5,
                  strokeLinecap: 'butt'
                }}
              />
            </g>
            <g id="shape1284-33" transform="translate(117.374 4.688)">
              <path
                d="M5.84 839.24H0v2.65h5.84z"
                className="st10"
                id="path16-9"
                style={{
                  fill: 'none',
                  stroke: '#0a5487',
                  strokeWidth: 1.5,
                  strokeLinecap: 'butt'
                }}
              />
            </g>
            <g id="shape1285-35" transform="translate(127.6 -35.025)">
              <path
                d="M5.84 839.24H0v2.65h5.84z"
                className="st10"
                id="path17"
                style={{
                  fill: 'none',
                  stroke: '#0a5487',
                  strokeWidth: 1.5,
                  strokeLinecap: 'butt'
                }}
              />
            </g>
            <g id="shape1286-37" transform="translate(117.374 -35.025)">
              <path
                d="M5.84 839.24H0v2.65h5.84z"
                className="st10"
                id="path18-8"
                style={{
                  fill: 'none',
                  stroke: '#0a5487',
                  strokeWidth: 1.5,
                  strokeLinecap: 'butt'
                }}
              />
            </g>
          </g>
          <text
            id="deviceTextId"
            x={131.194}
            y={891.949}
            className="st6"
            style={{
              fontWeight: 700,
              fontSize: '13.9999px',
              fontFamily: 'Calibri',
              textAnchor: 'middle',
              fill: '#0a5487'
            }}
          >
            {gatewayInfo.GatewayName}
          </text>
          <text
            id="deviceTextId-1"
            x={132.492}
            y={786.16}
            className="st6"
            style={{
              fontWeight: 700,
              fontSize: '13.9999px',
              fontFamily: 'Calibri',
              textAnchor: 'middle',
              overflow: 'visible',
              fill: '#0a5487',
              fillRule: 'evenodd',
              strokeLinecap: 'square',
              strokeMiterlimit: 3
            }}
          >
            {'IoT Gateway'}
          </text>
          <rect
            style={{
              fill: '#000',
              fillOpacity: 0.01,
              stroke: '#0a5487',
              strokeWidth: 0.545485
            }}
            id="gatewayName"
            width={134.795}
            height={132.276}
            x={65.304}
            y={770.965}
            rx={1.906}
          />
        </g>
      </a>
    ) : (
      <></>
    );

  return (
    <svg
      width="100%"
      height="100%"
      viewBox="20 20 450 250"
      id="dv-schematics"
      xmlSpace="preserve"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g id="layer1">
        <rect
          id="tank101_overlay"
          width={26.857}
          height={tnk101_fill_value}
          x={107.82}
          y={-142.344}
          style={{
            fill: 'none',
            strokeWidth: 0.116362
          }}
          transform="scale(1 -1)"
          className={clstnk101_overlay}
        />
        <path
          id="tnk101_overlay_bottom"
          stroke="#000"
          strokeWidth={0}
          transform="matrix(0 .05088 -.0672 0 138.022 139.648)"
          style={{
            fill: 'none'
          }}
          className={clstnk101_overlay_bottom}
          d="M150 115 50 150V50h100v100z"
        />
        <g id="tank101_body" transform="matrix(.35278 0 0 .35278 -6.265 -97.71)">
          <path
            d="M323.15 680.315h57.401l6.376 14.176h12.758V595.275H323.15z"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.5,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="path1"
          />
          <text x={349.479} y={591.129} id="text1">
            <tspan fontFamily="Calibri" fontSize={6} fill="#000" fillOpacity={1} strokeOpacity={1} id="tspan1">
              {'TNK101'}
            </tspan>
          </text>
        </g>
        <g id="tnk102_body" transform="matrix(.35278 0 0 .35278 -6.265 -97.71)">
          <path
            d="M323.15 484.67h57.401l6.375 17.065h12.759V382.302H323.15Z"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.500784,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="path34"
          />
          <text x={349.93} y={379.281} id="text34">
            <tspan fontFamily="Calibri" fontSize={6} fill="#000" fillOpacity={1} strokeOpacity={1} id="tspan34">
              {'TNK102'}
            </tspan>
          </text>
        </g>
        <rect
          id="tank102_overlay"
          width={26.857}
          height={tnk102_fill_value}
          x={107.816}
          y={-73.231}
          style={{
            fill: '#fff',
            strokeWidth: 0.180568
          }}
          transform="scale(1 -1)"
          className={clstnk102_overlay}
        />
        <path
          id="tnk102_overlay_bottom"
          stroke="#000"
          strokeWidth={0}
          transform="matrix(0 .0599 -.0672 0 138.062 70.227)"
          style={{
            fill: 'none'
          }}
          className={clstnk102_overlay_bottom}
          d="M150 116 50 150V50h100v100z"
        />
        <g id="vbl101_body_id" transform="translate(-14.241 1.5)">
          <path
            d="M61.976 116.04v-4.5l9 4.5v-4.5z"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.176389,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="path2"
            className={clsvbl101_body}
          />
          <g id="Layer1002" transform="matrix(.35278 0 0 .35278 7.976 -99.21)">
            <path
              d="M160.724 596.764h10.205v-10.205h-10.205zm5.103 0v7.015"
              style={{
                fill: 'none',
                stroke: '#000',
                strokeWidth: 0.5,
                strokeLinecap: 'round',
                strokeLinejoin: 'round',
                strokeDasharray: 'none'
              }}
              id="path3"
              className={clsvbl101_body}
            />
            <text x={160.724} y={591.661} id="text3" />
          </g>
          <text
            x={63.056}
            y={117.915}
            id="text4"
            style={{
              fontSize: '4.23333px',
              strokeWidth: 0.352777
            }}
          >
            <tspan
              fontFamily="Calibri"
              fontSize={2.117}
              fill="#000"
              fillOpacity={1}
              strokeOpacity={1}
              id="tspan4"
              style={{
                strokeWidth: 0.352777
              }}
            >
              {'VBL101'}
            </tspan>
          </text>
        </g>
        <g id="g30" transform="translate(-14.241 1.5)">
          <path
            d="m121.976 116.04 9-4.5v4.5l-9-4.5zm5.85 1.125a.9.9 0 1 1 .9.9.9.9 0 0 1-.9-.9zm-1.35-3.375v1.8l1.513 1.059"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.176389,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="path4"
          />
          <text
            x={123.256}
            y={120.261}
            id="text5"
            style={{
              fontSize: '4.23333px',
              strokeWidth: 0.352777
            }}
          >
            <tspan
              fontFamily="Calibri"
              fontSize={2.117}
              fill="#000"
              fillOpacity={1}
              strokeOpacity={1}
              id="tspan5"
              style={{
                strokeWidth: 0.352777
              }}
            >
              {'VFL101'}
            </tspan>
          </text>
        </g>
        <g id="vml101-body-id" transform="translate(-14.241 1.5)">
          <path
            d="M43.976 111.54v4.5l9-4.5v4.5zm4.5 2.25v-4.5m-2.25 0h4.5"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.176389,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="path5"
          />
          <text
            x={45.006}
            y={117.865}
            id="text6"
            style={{
              fontSize: '4.23333px',
              strokeWidth: 0.352777
            }}
          >
            <tspan
              fontFamily="Calibri"
              fontSize={2.117}
              fill="#000"
              fillOpacity={1}
              strokeOpacity={1}
              id="tspan6"
              style={{
                strokeWidth: 0.352777
              }}
            >
              {'VML101'}
            </tspan>
          </text>
        </g>
        <text
          x={103.616}
          y={183.817}
          id="text9"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        />
        <path
          d="M38.735 115.289h9"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.176389,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="path10"
          className={clsinput_line_2}
        />
        <text
          x={126.116}
          y={183.817}
          id="text11"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        />
        <path
          d="M43.235 109.289v6"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.176389,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="path12"
          className={clsinput_line_2}
        />
        <text
          x={138.116}
          y={183.817}
          id="text13"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        />
        <g id="flm101_body" transform="translate(-14.241 1.5)">
          <path
            d="M100.976 119.79v-12h6v12zm0 0 .858-1.716m.618-1.236 1.098-2.196m.852-1.704.858-1.716m.858-1.716.858-1.716"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.176389,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="path14"
            className={clsflm101_body}
          />
          <text
            x={100.471}
            y={106.698}
            id="text15"
            style={{
              fontSize: '4.23333px',
              strokeWidth: 0.352777
            }}
          >
            <tspan
              fontFamily="Calibri"
              fontSize={2.117}
              fill="#000"
              fillOpacity={1}
              strokeOpacity={1}
              id="tspan15"
              style={{
                strokeWidth: 0.352777
              }}
            >
              {'FLM101'}
            </tspan>
          </text>
        </g>
        <g id="vbl102_body" transform="translate(-14.241 1.5)">
          <path
            d="M106.226 161.79h-4.5l4.5-9h-4.5z"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.176389,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="path15"
            className={clsvbl102_body}
          />
          <g id="Layer1010" transform="matrix(.35278 0 0 .35278 7.976 -99.21)">
            <path
              d="M265.11 732.189v-10.205h-10.204v10.205zm0-5.102h7.016"
              style={{
                fill: 'none',
                stroke: '#000',
                strokeWidth: 0.5,
                strokeLinecap: 'round',
                strokeLinejoin: 'round',
                strokeDasharray: 'none'
              }}
              id="path16"
              className={clsvbl102_body}
            />
            <text x={254.905} y={727.087} transform="rotate(-90 260.008 727.087)" id="text16" />
          </g>
          <text
            x={105.532}
            y={158.138}
            id="text17"
            style={{
              fontSize: '4.23333px',
              strokeWidth: 0.352777
            }}
          >
            <tspan
              fontFamily="Calibri"
              fontSize={2.117}
              fill="#000"
              fillOpacity={1}
              strokeOpacity={1}
              id="tspan17"
              style={{
                strokeWidth: 0.352777
              }}
            >
              {'VBL102'}
            </tspan>
          </text>
        </g>
        <g id="g1">
          <path
            d="M89.735 121.29v33"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: '.176389!important',
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="flm101_line_id"
            className={clsflm101_line}
          />
        </g>
        <g id="vbl120" transform="translate(-14.241 1.5)">
          <path
            d="M148.226 161.79h-4.5l4.5-9h-4.5z"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.176389,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="path18"
            className={clsvbl120_body}
          />
          <g id="Layer1012" transform="matrix(.35278 0 0 .35278 7.976 -99.21)">
            <path
              d="M384.165 732.189v-10.205h-10.204v10.205zm0-5.102h7.016"
              style={{
                fill: 'none',
                stroke: '#000',
                strokeWidth: 0.5,
                strokeLinecap: 'round',
                strokeLinejoin: 'round',
                strokeDasharray: 'none'
              }}
              id="path19"
              className={clsvbl120_body}
            />
            <text x={373.961} y={727.087} transform="rotate(-90 379.063 727.087)" id="text19" />
          </g>
          <text
            x={147.373}
            y={158.032}
            id="text20"
            style={{
              fontSize: '4.23333px',
              strokeWidth: 0.352777
            }}
          >
            <tspan
              fontFamily="Calibri"
              fontSize={2.117}
              fill="#000"
              fillOpacity={1}
              strokeOpacity={1}
              id="tspan20"
              style={{
                strokeWidth: 0.352777
              }}
            >
              {'VBL120'}
            </tspan>
          </text>
        </g>
        <path
          d="M131.735 154.29v-7"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.176389,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="path20"
          className={clstnk101_line}
        />
        <path
          d="M110.04 133.289h7.5l-5 2.5 5 2.5h-7.5"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.176389,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="path21"
          className={clsclp101_line_1}
        />
        <text
          x={110.384}
          y={132.018}
          id="text21"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        >
          <tspan
            fontFamily="Calibri"
            fontSize={2.117}
            fill="#000"
            fillOpacity={1}
            strokeOpacity={1}
            id="tspan21"
            style={{
              strokeWidth: 0.352777
            }}
          >
            {'CLP101'}
          </tspan>
        </text>
        <text
          x={10.04}
          y={134.024}
          id="text23"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        >
          <tspan
            fontFamily="Calibri"
            fontSize={2.117}
            fill="#000"
            fillOpacity={1}
            strokeOpacity={1}
            id="tspan23"
            style={{
              strokeWidth: 0.352777
            }}
          >
            {'AMBIENT AIR'}
          </tspan>
        </text>
        <g id="g15" transform="translate(-14.241 1.5)">
          <path
            d="M48.476 127.29c6 0 6 9 0 9s-6-9 0-9zm-1.875.409 5.772 1.84m-5.772 6.341 5.772-1.84m-6.522-2.25h5.25m-.375-1.5c.5.937.5 2.062 0 3m-4.5-3c-.5.937-.5 2.062 0 3"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.176389,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="path24"
            className={clsppa101_body}
          />
          <g id="g14">
            <text
              x={45.348}
              y={139.139}
              id="text24"
              style={{
                fontSize: '4.23333px',
                strokeWidth: 0.352777
              }}
            >
              <tspan
                fontFamily="Calibri"
                fontSize={2.117}
                fill="#000"
                fillOpacity={1}
                strokeOpacity={1}
                id="tspan24"
                style={{
                  strokeWidth: 0.352777
                }}
              >
                {'PPA101'}
              </tspan>
            </text>
          </g>
        </g>
        <g id="ambient-air-line-id" transform="matrix(.35278 0 0 .35278 -6.265 -97.71)" className={clsaair_line_1}>
          <defs id="defs24">
            <marker
              id="marker2"
              markerUnits="strokeWidth"
              orient="auto"
              markerWidth={8}
              markerHeight={6}
              viewBox="0 0 10 10"
              refX={1}
              refY={5}
            >
              <path fill="solid" id="polyline2" d="m0 0 10 5-10 5 1-5" />
            </marker>
          </defs>
          <text x={104.469} y={645.681} id="text25" />
        </g>
        <path
          d="M77.735 109.289v6"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.176389,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="path26"
          className={clsinput_line_3}
        />
        <path
          d="M65.735 109.289v6"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.176389,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="path27"
          className={clsinput_line_3}
        />
        <path
          d="M56.735 115.289h30"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.176389,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="path28"
          className={clsinput_line_3}
        />
        <path
          d="M92.735 115.289h15"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.176389,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="input_line_4_id"
          className={clsinput_line_4}
        />
        <text
          x={110.839}
          y={112.071}
          id="text29"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        />
        <path
          d="M64.235 127.29h3a3 3 0 1 0 0-6h-3a3 3 0 1 0 0 6zm-3-3h9m-9 0h9"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.176389,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="ptc112_body"
          className={clsptc112_body}
        />
        <text
          x={126.116}
          y={201.817}
          id="text30"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        />
        <text
          x={62.442}
          y={126.155}
          id="text31"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        >
          <tspan
            fontFamily="Calibri"
            fontSize={2.117}
            fill="#000"
            fillOpacity={1}
            strokeOpacity={1}
            id="tspan31"
            style={{
              strokeWidth: 0.352777
            }}
          >
            {'PTC112'}
          </tspan>
        </text>
        <g id="Layer1020" transform="matrix(.35278 0 0 .35278 -6.265 -97.71)" className={clsaair_line_2}>
          <path
            d="M204.095 637.795v17.008"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.5,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="aair_line_2_2"
            className={clsaair_line_2}
          />
        </g>
        <path
          d="M140.735 133.29h3a3 3 0 1 0 0-6h-3a3 3 0 1 0 0 6zm-3-3h9m-9 0h9"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.176389,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="path32"
          className={clsptc103_body}
        />
        <text
          x={202.616}
          y={207.817}
          id="text32"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        />
        <text
          x={138.865}
          y={132.147}
          id="text33"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        >
          <tspan
            fontFamily="Calibri"
            fontSize={2.117}
            fill="#000"
            fillOpacity={1}
            strokeOpacity={1}
            id="tspan33"
            style={{
              strokeWidth: 0.352777
            }}
          >
            {'PTC103'}
          </tspan>
        </text>
        <path
          d="M142.235 133.289v6h-7.5"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.176389,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="path33"
          className={clsptc103_line}
        />
        <path
          d="M140.735 66.97h3a3 3 0 1 0 0-6h-3a3 3 0 1 0 0 6zm-3-3h9m-9 0h9"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.176389,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="path35"
          className={clsptc106_body}
        />
        <text
          x={202.616}
          y={141.498}
          id="text35"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        />
        <text
          x={138.979}
          y={65.958}
          id="text36"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        >
          <tspan
            fontFamily="Calibri"
            fontSize={2.117}
            fill="#000"
            fillOpacity={1}
            strokeOpacity={1}
            id="tspan36"
            style={{
              strokeWidth: 0.352777
            }}
          >
            {'PTC106'}
          </tspan>
        </text>
        <path
          d="M142.235 66.97v3.319h-7.5"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.176389,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="path36"
          className={clsptc106_line}
        />
        <g id="g45" transform="translate(-14.241 1.5)">
          <path
            d="M193.976 89.79h18v-12l-6.75-3.75v-2.25h-4.5v2.25l-6.75 3.75z"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.176389,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="tnk104_body"
            className={clstnk104_body}
          />
          <text
            x={199.471}
            y={92.419}
            id="text37"
            style={{
              fontSize: '4.23333px',
              strokeWidth: 0.352777
            }}
          >
            <tspan
              fontFamily="Calibri"
              fontSize={2.117}
              fill="#000"
              fillOpacity={1}
              strokeOpacity={1}
              id="tspan37"
              style={{
                strokeWidth: 0.352777
              }}
            >
              {'TNK104'}
            </tspan>
          </text>
          <rect
            style={{
              fill: 'none',
              fillOpacity: 1,
              stroke: '#fff',
              strokeWidth: 0.221246,
              strokeMiterlimit: 10,
              strokeDasharray: 'none',
              strokeDashoffset: 0,
              strokeOpacity: 1
            }}
            id="tnk104_overlay"
            width={17.5}
            height={tnk104_fill_value}
            x={-211.804}
            y={-89.451}
            className={clstnk104_overlay}
            ry={0}
            transform="scale(-1)"
          />
        </g>
        <text
          x={160.616}
          y={183.817}
          id="text38"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        />
        <path
          d="M100.235 109.289v6"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.176389,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="input_line_4n_id"
          className={clsinput_line_4}
        />
        <g id="g3">
          <path
            d="M110.018 138.289H90.714m-2 0h-39.5"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.176389,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none',
              markerEnd: 'url(#endMarker3)'
            }}
            id="path40"
            className={clsaair_line_3}
          />
        </g>
        <text
          x={41.948}
          y={141.634}
          id="text41"
          style={{
            strokeWidth: 0.352777
          }}
        >
          <tspan x={41.948} y={141.634} id="tspan28" fontSize={2} fontFamily="Calibri" fontWeight={600}>
            {'*TO MEMBRANE (FLU101)AIR INLET ON THE FEED PORT*'}
          </tspan>
        </text>
        <g id="vnr102_body" transform="translate(-14.241 1.5)">
          <path
            d="M151.976 99.54v-4.5l9 4.5v-4.5"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.176389,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="path41"
            className={clsvnr102_body}
          />
          <path
            d="M152.426 95.04a.45.45 0 1 1-.45-.45.45.45 0 0 1 .45.45z"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.176389,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="path42"
            className={clsvnr102_body}
          />
          <text
            x={152.826}
            y={101.949}
            id="text42"
            style={{
              fontSize: '4.23333px',
              strokeWidth: 0.352777
            }}
          >
            <tspan
              fontFamily="Calibri"
              fontSize={2.117}
              fill="#000"
              fillOpacity={1}
              strokeOpacity={1}
              id="tspan42"
              style={{
                strokeWidth: 0.352777
              }}
            >
              {'VNR102'}
            </tspan>
          </text>
        </g>
        <path
          d="M131.735 79.29V98.79h6"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.176389,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="path43"
          className={clstnk102_line_1}
        />
        <text
          x={134.839}
          y={95.571}
          id="text43"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        />
        <g id="vbl119_body" transform="translate(-14.241 1.5)">
          <path
            d="M178.226 113.79h-4.5l4.5-9h-4.5z"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.176389,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="path44"
            className={clsvbl119_body}
          />
          <g id="Layer1030" transform="matrix(.35278 0 0 .35278 7.976 -99.21)">
            <path
              d="M469.205 596.126v-10.205H459v10.205zm0-5.102h7.016"
              style={{
                fill: 'none',
                stroke: '#000',
                strokeWidth: 0.5,
                strokeLinecap: 'round',
                strokeLinejoin: 'round',
                strokeDasharray: 'none'
              }}
              id="path45"
              className={clsvbl119_body}
            />
            <text x={459} y={591.024} transform="rotate(-90 464.102 591.024)" id="text45" />
          </g>
          <text
            x={177.402}
            y={109.985}
            id="text46"
            style={{
              fontSize: '4.23333px',
              strokeWidth: 0.352777
            }}
          >
            <tspan
              fontFamily="Calibri"
              fontSize={2.117}
              fill="#000"
              fillOpacity={1}
              strokeOpacity={1}
              id="tspan46"
              style={{
                strokeWidth: 0.352777
              }}
            >
              {'VBL119'}
            </tspan>
          </text>
        </g>
        <path
          d="M163.985 136.289h-4.5l4.5-9h-4.5z"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.176389,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="path46"
          className={clsvbl118_body}
        />
        <g id="Layer1032" transform="matrix(.35278 0 0 .35278 -6.265 -97.71)">
          <path
            d="M469.205 655.654v-10.205H459v10.205zm0-5.103h7.016"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.5,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="path47"
            className={clsvbl118_body}
          />
          <text x={459} y={650.551} transform="rotate(-90 464.102 650.551)" id="text47" />
        </g>
        <text
          x={163.108}
          y={132.26}
          id="text48"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        >
          <tspan
            fontFamily="Calibri"
            fontSize={2.117}
            fill="#000"
            fillOpacity={1}
            strokeOpacity={1}
            id="tspan48"
            style={{
              strokeWidth: 0.352777
            }}
          >
            {'VBL118'}
          </tspan>
        </text>
        <path
          d="M134.735 44.489h18v121.8"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.176389,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="path50"
        />
        <text
          x={136.679}
          y={42.689}
          id="text51"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        >
          <tspan
            fontFamily="Calibri"
            fontStyle="italic"
            fontSize={2.117}
            fill="#000"
            fillOpacity={1}
            strokeOpacity={1}
            id="tspan51"
            style={{
              strokeWidth: 0.352777
            }}
          >
            {'Tank Overflow'}
          </tspan>
        </text>
        <path
          d="M134.735 118.2h15v48.089"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.176389,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="path51"
        />
        <text
          x={135.179}
          y={116.389}
          id="text52"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        >
          <tspan
            fontFamily="Calibri"
            fontStyle="italic"
            fontSize={2.117}
            fill="#000"
            fillOpacity={1}
            strokeOpacity={1}
            id="tspan52"
            style={{
              strokeWidth: 0.352777
            }}
          >
            {'Tank Overflow'}
          </tspan>
        </text>
        <g id="vnr104_body" transform="translate(-14.241 1.5)">
          <path
            d="M173.726 80.79h4.5l-4.5 9h4.5"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.176389,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="path52"
            className={clsvnr104_body}
          />
          <path
            d="M178.226 81.24a.45.45 0 1 1 .45-.45.45.45 0 0 1-.45.45z"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.176389,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="path53"
            className={clsvnr104_body}
          />
          <text
            x={177.824}
            y={86.073}
            id="text53"
            style={{
              fontSize: '4.23333px',
              strokeWidth: 0.352777
            }}
          >
            <tspan
              fontFamily="Calibri"
              fontSize={2.117}
              fill="#000"
              fillOpacity={1}
              strokeOpacity={1}
              id="tspan53"
              style={{
                strokeWidth: 0.352777
              }}
            >
              {'VNR104'}
            </tspan>
          </text>
        </g>
        <path
          d="M188.735 73.289v-3l-9.003.026"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.176389,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="path55"
          className={clstnk104_line_1}
        />
        <text
          x={191.839}
          y={67.071}
          id="text55"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        />
        <path
          d="m170.626 70.306-8.865.018-.03 11.87"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.176389,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="tnk104_line_2"
          className={clstnk104_line_2}
        />
        <path
          d="M212.731 133.306h-5.991v-12.01"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.17,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="input_line_8"
          className={clsinput_line_8}
        />
        <path
          d="M200.714 139.101h6.013v-5.88"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.17,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="input_line_8-0"
          className={clsinput_line_8}
        />
        <text
          x={218.534}
          y={-132.892}
          id="text56"
          transform="scale(.94174 -1.06186)"
          style={{
            fontSize: '3.99006px',
            strokeWidth: 0.332505
          }}
        />
        <path
          d="M172.235 116.789c5.996.004 5.996 9.003 0 9-5.997-.004-5.997-9.004 0-9zm0 0 4.5 4.5-4.5 4.5m-4.5-4.5h9m0 0h.076"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.176389,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="ppf101_body"
          className={clsppf101_body}
        />
        <g id="g35" transform="translate(-15.38 1.155)">
          <text
            x={184.402}
            y={126.837}
            id="text57"
            style={{
              fontSize: '4.23333px',
              strokeWidth: 0.352777
            }}
          >
            <tspan
              fontFamily="Calibri"
              fontSize={2.117}
              fill="#000"
              fillOpacity={1}
              strokeOpacity={1}
              id="tspan57"
              style={{
                strokeWidth: 0.352777
              }}
            >
              {'PPF101'}
            </tspan>
          </text>
        </g>
        <path
          d="M161.735 115.289v6l5.998.019"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.176389,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="path58"
          className={clsvbl119_line}
        />
        <text
          x={164.839}
          y={118.071}
          id="text58"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        />
        <path
          d="M161.716 127.289v-6h5.98"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.176389,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="path59"
          className={clsinput_line_6}
        />
        <text
          x={164.652}
          y={118.52}
          id="text59"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        />
        <g id="ppc101_body" transform="translate(-14.241 1.5)">
          <path
            d="M189.476 73.29c-5.998-.002-5.998-9.002 0-9 5.997.002 5.997 9.002 0 9zm0 0-4.5-4.5 4.5-4.5m4.497 4.5h.003"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.176389,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="path60"
            className={clsppc101_body}
          />
          <text
            x={186.383}
            y={63.079}
            id="text60"
            style={{
              fontSize: '4.23333px',
              strokeWidth: 0.352777
            }}
          >
            <tspan
              fontFamily="Calibri"
              fontSize={2.117}
              fill="#000"
              fillOpacity={1}
              strokeOpacity={1}
              id="tspan60"
              style={{
                strokeWidth: 0.352777
              }}
            >
              {'PPC101'}
            </tspan>
          </text>
        </g>
        <path
          d="M182.173 115.29h3a3 3 0 1 0 0-6h-3a3 3 0 1 0 0 6zm-3-3h9m-9 0h9"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.176389,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="path61"
          className={clsptc102_body}
        />
        <text
          x={244.616}
          y={189.817}
          id="text61"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        />
        <text
          x={180.47}
          y={114.242}
          id="text62"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        >
          <tspan
            fontFamily="Calibri"
            fontSize={2.117}
            fill="#000"
            fillOpacity={1}
            strokeOpacity={1}
            id="tspan62"
            style={{
              strokeWidth: 0.352777
            }}
          >
            {'PTC102'}
          </tspan>
        </text>
        <path
          d="M183.598 115.326v6"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.176389,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="path62"
          className={clsinput_line_7}
        />
        <path
          d="M195.447 115.14h3a3 3 0 1 0 0-6h-3a3 3 0 1 0 0 6zm-3-3h9m-9 0h9"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.176389,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="path63"
          className={clsftr102_body}
        />
        <text
          x={256.616}
          y={189.817}
          id="text63"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        />
        <text
          x={193.948}
          y={114.066}
          id="text64"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        >
          <tspan
            fontFamily="Calibri"
            fontSize={2.117}
            fill="#000"
            fillOpacity={1}
            strokeOpacity={1}
            id="tspan64"
            style={{
              strokeWidth: 0.352777
            }}
          >
            {'FTR102'}
          </tspan>
        </text>
        <path
          d="M196.872 115.326v6"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.176389,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="path64"
          className={clsinput_line_7}
        />
        <g id="flu101_body" transform="matrix(.35278 0 0 .35278 -6.265 -97.71)">
          <path
            d="M782.93 587.055a20.551 20.551 0 0 0 32.881 0v-94.11a20.551 20.551 0 0 0-32.882 0zm0 0h32.881m-32.882-94.11h32.882"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.5,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="path65"
            className={clsflu101_body}
          />
          <text x={775.37} y={609.787} id="text65" />
        </g>
        <g id="Layer1048" transform="matrix(.35278 0 0 .35278 .572 -97.817)">
          <text x={741.354} y={544.252} id="text66">
            <tspan fontFamily="Calibri" fontSize={6} fill="#000" fillOpacity={1} strokeOpacity={1} id="tspan66">
              {'FLU101'}
            </tspan>
          </text>
        </g>
        <g id="flm102_body" transform="translate(-14.241 1.5)">
          <path
            d="M226.976 137.79v-12h6v12zm0 0 .858-1.716m.618-1.236 1.098-2.196m.852-1.704.858-1.716m.858-1.716.858-1.716"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.176389,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="path67"
            className={clsflm102_body}
          />
          <text
            x={226.418}
            y={124.751}
            id="text67"
            style={{
              fontSize: '4.23333px',
              strokeWidth: 0.352777
            }}
          >
            <tspan
              fontFamily="Calibri"
              fontSize={2.117}
              fill="#000"
              fillOpacity={1}
              strokeOpacity={1}
              id="tspan67"
              style={{
                strokeWidth: 0.352777
              }}
            >
              {'FLM102'}
            </tspan>
          </text>
        </g>
        <g id="vbl105_body" transform="translate(-14.241 1.5)">
          <path
            d="M232.226 161.79h-4.5l4.5-9h-4.5z"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.176389,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="path68"
            className={clsvbl105_body}
          />
          <g id="Layer1051" transform="matrix(.35278 0 0 .35278 7.976 -99.21)">
            <path
              d="M622.276 732.189v-10.205H612.07v10.205zm0-5.102h7.015"
              style={{
                fill: 'none',
                stroke: '#000',
                strokeWidth: 0.5,
                strokeLinecap: 'round',
                strokeLinejoin: 'round',
                strokeDasharray: 'none'
              }}
              id="path69"
              className={clsvbl105_body}
            />
            <text x={612.071} y={727.087} transform="rotate(-90 617.173 727.087)" id="text69" />
          </g>
          <text
            x={215.903}
            y={157.92}
            id="text70"
            style={{
              fontSize: '4.23333px',
              strokeWidth: 0.352777
            }}
          >
            <tspan
              fontFamily="Calibri"
              fontSize={2.117}
              fill="#000"
              fillOpacity={1}
              strokeOpacity={1}
              id="tspan70"
              style={{
                strokeWidth: 0.352777
              }}
            >
              {'VBL105'}
            </tspan>
          </text>
        </g>
        <path
          d="M215.735 139.29v15"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.176389,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="path70"
          className={clsflm102_line}
        />
        <g id="flm103_body" transform="translate(-14.241 1.5)">
          <path
            d="M247.976 137.79v-12h6v12zm0 0 .858-1.716m.618-1.236 1.098-2.196m.852-1.704.858-1.716m.858-1.716.858-1.716"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.176389,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="path71"
            className={clsflm103_body}
          />
          <text
            x={247.259}
            y={124.857}
            id="text71"
            style={{
              fontSize: '4.23333px',
              strokeWidth: 0.352777
            }}
          >
            <tspan
              fontFamily="Calibri"
              fontSize={2.117}
              fill="#000"
              fillOpacity={1}
              strokeOpacity={1}
              id="tspan71"
              style={{
                strokeWidth: 0.352777
              }}
            >
              {'FLM103'}
            </tspan>
          </text>
        </g>
        <g id="g50" transform="translate(-14.241 1.5)">
          <path
            d="M253.226 161.79h-4.5l4.5-9h-4.5z"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.176389,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="path72"
            className={clsvbl106_body}
          />
          <g id="Layer1054" transform="matrix(.35278 0 0 .35278 7.976 -99.21)">
            <path
              d="M681.803 732.189v-10.205h-10.205v10.205zm0-5.102h7.016"
              style={{
                fill: 'none',
                stroke: '#000',
                strokeWidth: 0.5,
                strokeLinecap: 'round',
                strokeLinejoin: 'round',
                strokeDasharray: 'none'
              }}
              id="path73"
              className={clsvbl106_body}
            />
            <text x={671.598} y={727.087} transform="rotate(-90 676.7 727.087)" id="text73" />
          </g>
          <text
            x={252.749}
            y={157.985}
            id="text74"
            style={{
              fontSize: '4.23333px',
              strokeWidth: 0.352777
            }}
          >
            <tspan
              fontFamily="Calibri"
              fontSize={2.117}
              fill="#000"
              fillOpacity={1}
              strokeOpacity={1}
              id="tspan74"
              style={{
                strokeWidth: 0.352777
              }}
            >
              {'VBL106'}
            </tspan>
          </text>
        </g>
        <path
          d="M236.735 139.29v15"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.176389,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="flm103_line"
          className={clsflm103_line}
        />
        <path
          d="M218.735 133.289h15"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.176389,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="path75"
          className={clsinput_line_9}
        />
        <text
          x={236.839}
          y={130.071}
          id="text75"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        />
        <path
          d="M224.947 128.137h3a3 3 0 1 0 0-6h-3a3 3 0 1 0 0 6zm-3-3h9m-9 0h9"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.176389,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="ptc104_body"
          className={clsptc104_body}
        />
        <text
          x={286.615}
          y={201.817}
          id="text76"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        />
        <text
          x={223.358}
          y={127.178}
          id="text77"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        >
          <tspan
            fontFamily="Calibri"
            fontSize={2.117}
            fill="#000"
            fillOpacity={1}
            strokeOpacity={1}
            id="tspan77"
            style={{
              strokeWidth: 0.352777
            }}
          >
            {'PTC104'}
          </tspan>
        </text>
        <path
          d="M226.235 128.177v5.125"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.17,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="path77"
          className={clsinput_line_9}
        />
        <path
          d="M260.735 127.29h3a3 3 0 1 0 0-6h-3a3 3 0 1 0 0 6zm-3-3h9m-9 0h9"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.176389,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="ptc107_body"
          className={clsptc107_body}
        />
        <text
          x={322.615}
          y={201.817}
          id="text79"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        />
        <text
          x={259.077}
          y={126.319}
          id="text80"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        >
          <tspan
            fontFamily="Calibri"
            fontSize={2.117}
            fill="#000"
            fillOpacity={1}
            strokeOpacity={1}
            id="tspan80"
            style={{
              strokeWidth: 0.352777
            }}
          >
            {'PTC107'}
          </tspan>
        </text>
        <path
          d="M262.235 127.289v6"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.176389,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="path80"
          className={clsinput_line_11}
        />
        <path
          d="M239.735 133.289h6"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.176389,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="path81"
          className={clsinput_line_10}
        />
        <text
          x={248.839}
          y={130.071}
          id="text81"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        />
        <g id="vbl108_body" transform="translate(-14.241 1.5)">
          <path
            d="M259.976 134.04v-4.5l9 4.5v-4.5z"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.176389,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="path82"
            className={clsvbl108_body}
          />
          <g id="Layer1061" transform="matrix(.35278 0 0 .35278 7.976 -99.21)">
            <path
              d="M721.984 647.787h10.205v-10.204h-10.205zm5.103 0v7.016"
              style={{
                fill: 'none',
                stroke: '#000',
                strokeWidth: 0.5,
                strokeLinecap: 'round',
                strokeLinejoin: 'round',
                strokeDasharray: 'none'
              }}
              id="path83"
              className={clsvbl108_body}
            />
            <text x={721.984} y={642.685} id="text83" />
          </g>
          <text
            x={261.15}
            y={136.149}
            id="text84"
            style={{
              fontSize: '4.23333px',
              strokeWidth: 0.352777
            }}
          >
            <tspan
              fontFamily="Calibri"
              fontSize={2.117}
              fill="#000"
              fillOpacity={1}
              strokeOpacity={1}
              id="tspan84"
              style={{
                strokeWidth: 0.352777
              }}
            >
              {'VBL108'}
            </tspan>
          </text>
        </g>
        <g id="g55" transform="translate(-14.241 1.5)">
          <path
            d="M287.726 125.79h4.5l-4.5-9h4.5zm2.25-4.5h-4.5m0 2.25v-4.5"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.176389,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="path84"
          />
          <text
            x={291.59}
            y={121.873}
            id="text85"
            style={{
              fontSize: '4.23333px',
              strokeWidth: 0.352777
            }}
          >
            <tspan
              fontFamily="Calibri"
              fontSize={2.117}
              fill="#000"
              fillOpacity={1}
              strokeOpacity={1}
              id="tspan85"
              style={{
                strokeWidth: 0.352777
              }}
            >
              {'VML104'}
            </tspan>
          </text>
        </g>
        <path
          d="M275.735 112.289v6"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.176389,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="input_line_14"
          className={clsinput_line_14}
        />
        <path
          d="M275.764 127.406v6"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.176389,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="input_line_12"
          className={clsinput_line_12}
        />
        <g id="vbl110_body" transform="translate(-14.241 1.5)">
          <path
            d="M292.226 161.79h-4.5l4.5-9h-4.5z"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.176389,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="path87"
            className={clsvbl110_body}
          />
          <g id="Layer1066" transform="matrix(.35278 0 0 .35278 7.976 -99.21)">
            <path
              d="M792.354 732.189v-10.205H782.15v10.205zm0-5.102h7.016"
              style={{
                fill: 'none',
                stroke: '#000',
                strokeWidth: 0.5,
                strokeLinecap: 'round',
                strokeLinejoin: 'round',
                strokeDasharray: 'none'
              }}
              id="path88"
              className={clsvbl110_body}
            />
            <text x={782.15} y={727.087} transform="rotate(-90 787.252 727.087)" id="text88" />
          </g>
          <text
            x={275.773}
            y={158.032}
            id="text89"
            style={{
              fontSize: '4.23333px',
              strokeWidth: 0.352777
            }}
          >
            <tspan
              fontFamily="Calibri"
              fontSize={2.117}
              fill="#000"
              fillOpacity={1}
              strokeOpacity={1}
              id="tspan89"
              style={{
                strokeWidth: 0.352777
              }}
            >
              {'VBL110'}
            </tspan>
          </text>
        </g>
        <g id="g44" transform="translate(-14.241 1.5)">
          <path
            d="M205.976 135.54v4.5l9-4.5v4.5zm4.5 2.25v-4.5m-2.25 0h4.5"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.176389,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="path90"
          />
          <text
            x={206.968}
            y={142.157}
            id="text91"
            style={{
              fontSize: '4.23333px',
              strokeWidth: 0.352777
            }}
          >
            <tspan
              fontFamily="Calibri"
              fontSize={2.117}
              fill="#000"
              fillOpacity={1}
              strokeOpacity={1}
              id="tspan91"
              style={{
                strokeWidth: 0.352777
              }}
            >
              {'VML103'}
            </tspan>
          </text>
        </g>
        <g id="g66" transform="translate(-14.241 1.5)">
          <path
            d="M337.975 108.54v-4.5l-9 4.5v-4.5"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.176389,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="path95"
            className={clsvnr107_body}
          />
          <path
            d="M337.525 104.04a.45.45 0 0 1 .45-.45.45.45 0 1 1-.45.45z"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.176389,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="path96"
            className={clsvnr107_body}
          />
          <text
            x={330.315}
            y={110.737}
            id="text96"
            style={{
              fontSize: '4.23333px',
              strokeWidth: 0.352777
            }}
          >
            <tspan
              fontFamily="Calibri"
              fontSize={2.117}
              fill="#000"
              fillOpacity={1}
              strokeOpacity={1}
              id="tspan96"
              style={{
                strokeWidth: 0.352777
              }}
            >
              {'VNR107'}
            </tspan>
          </text>
        </g>
        <g id="g67" transform="translate(-14.241 1.5)">
          <path
            d="M337.975 123.54v-4.5l-9 4.5v-4.5"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.176389,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="path97"
            className={clsvnr106_body}
          />
          <path
            d="M337.525 119.04a.45.45 0 0 1 .45-.45.45.45 0 1 1-.45.45z"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.176389,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="path98"
            className={clsvnr106_body}
          />
          <text
            x={329.944}
            y={126.108}
            id="text98"
            style={{
              fontSize: '4.23333px',
              strokeWidth: 0.352777
            }}
          >
            <tspan
              fontFamily="Calibri"
              fontSize={2.117}
              fill="#000"
              fillOpacity={1}
              strokeOpacity={1}
              id="tspan98"
              style={{
                strokeWidth: 0.352777
              }}
            >
              {'VNR106'}
            </tspan>
          </text>
        </g>
        <path
          d="M314.681 107.736h-3v7.5h-5m-2 0h-10m-2 0h-17"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.176389,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="path99"
          className={clsaair_line_5}
        />
        <text
          x={316.959}
          y={96.515}
          id="text99"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        />
        <path
          d="m363.582 108.154-39-.1"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.176389,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none',
            markerEnd: 'url(#endMarker6)'
          }}
          id="path101"
          className={clsaair_line_4}
        />
        <text
          x={339.21}
          y={106.554}
          id="text101"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        >
          <tspan
            fontFamily="Calibri"
            fontWeight="bold"
            fontSize={2.117}
            fill="#000"
            fillOpacity={1}
            strokeOpacity={1}
            id="tspan101"
            style={{
              strokeWidth: 0.352777
            }}
          >
            {'*FROM AIR PUMP PPA101*'}
          </tspan>
        </text>
        <g id="Layer1075" transform="matrix(.35278 0 0 .35278 -6.265 -97.71)">
          <g id="Layer1076">
            <path
              d="M963.696 637.795a12.756 12.756-90 1 1 0-25.511 12.756 12.756-90 0 1 0 25.511z"
              style={{
                fill: '#fff',
                fillRule: 'evenodd',
                strokeWidth: 0.5,
                strokeLinecap: 'round',
                strokeLinejoin: 'round'
              }}
              id="path102"
              className={clsppa102_body}
            />
            <path
              d="M963.696 637.795c-7.045 0-12.756-5.71-12.756-12.756 0-7.044 5.711-12.755 12.756-12.755s12.756 5.71 12.756 12.755c0 7.045-5.711 12.756-12.756 12.756zm0 0L950.94 625.04l12.756-12.755m0 25.511c8.504-6.378 8.504-19.134 0-25.511m12.749 12.455.007.3m-25.512 0h-.004"
              style={{
                fill: 'none',
                stroke: '#000',
                strokeWidth: 0.5,
                strokeLinecap: 'round',
                strokeLinejoin: 'round',
                strokeDasharray: 'none'
              }}
              id="path103"
              className={clsppa102_body}
            />
          </g>
          <text x={954.638} y={645.066} id="text103">
            <tspan fontFamily="Calibri" fontSize={6} fill="#000" fillOpacity={1} strokeOpacity={1} id="tspan103">
              {'PPA102'}
            </tspan>
          </text>
        </g>
        <text
          x={346.82}
          y={123.468}
          id="text104"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        >
          <tspan
            fontFamily="Calibri"
            fontSize={2.117}
            fill="#000"
            fillOpacity={1}
            strokeOpacity={1}
            id="tspan104"
            style={{
              strokeWidth: 0.352777
            }}
          >
            {'AMBIENT AIR'}
          </tspan>
        </text>
        <path
          d="m344.734 122.789-5.578.026"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.176389,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none',
            markerEnd: 'url(#endMarker7)'
          }}
          id="path7"
          className={clsdit_line_1}
        />
        <text
          x={343.559}
          y={119.571}
          id="text105"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        />
        <path
          d="M323.734 122.789h5.447"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.176389,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="dit_line_2"
          className={clsdit_line_2}
        />
        <text
          x={330.059}
          y={119.571}
          id="text106"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        />
        <text
          x={268.941}
          y={113.842}
          id="text107"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        >
          <tspan
            fontFamily="Calibri"
            fontStyle="italic"
            fontSize={2.117}
            fill="#000"
            fillOpacity={1}
            strokeOpacity={1}
            id="tspan107"
            style={{
              strokeWidth: 0.352777
            }}
          >
            {'Feed'}
          </tspan>
        </text>
        <text
          x={282.701}
          y={81.752}
          id="text108"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        >
          <tspan
            fontFamily="Calibri"
            fontStyle="italic"
            fontSize={2.117}
            fill="#000"
            fillOpacity={1}
            strokeOpacity={1}
            id="tspan108"
            style={{
              strokeWidth: 0.352777
            }}
          >
            {'Concentrate'}
          </tspan>
        </text>
        <g id="vbl107_body" transform="translate(-14.241 1.5)">
          <path
            d="M310.226 161.79h-4.5l4.5-9h-4.5z"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.176389,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="path108"
            className={clsvbl107_body}
          />
          <g id="Layer1080" transform="matrix(.35278 0 0 .35278 7.976 -99.21)">
            <path
              d="M843.378 732.189v-10.205h-10.205v10.205zm0-5.102h7.016"
              style={{
                fill: 'none',
                stroke: '#000',
                strokeWidth: 0.5,
                strokeLinecap: 'round',
                strokeLinejoin: 'round',
                strokeDasharray: 'none'
              }}
              id="path109"
              className={clsvbl107_body}
            />
            <text x={833.173} y={727.087} transform="rotate(-90 838.276 727.087)" id="text109" />
          </g>
          <text
            x={294.574}
            y={157.929}
            id="text110"
            style={{
              fontSize: '4.23333px',
              strokeWidth: 0.352777
            }}
          >
            <tspan
              fontFamily="Calibri"
              fontSize={2.117}
              fill="#000"
              fillOpacity={1}
              strokeOpacity={1}
              id="tspan110"
              style={{
                strokeWidth: 0.352777
              }}
            >
              {'VBL107'}
            </tspan>
          </text>
        </g>
        <g id="g13">
          <path
            d="M281.534 83.039h12.2v71.25"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.176389,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="flu101_line"
            className={clsflu101_line}
          />
        </g>
        <text
          x={296.839}
          y={79.821}
          id="text111"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        />
        <g id="vbl112_body" transform="translate(-14.241 1.5)">
          <path
            d="M322.976 71.04v-4.5l9 4.5v-4.5z"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.176389,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="path111"
            className={clsvbl112_body}
          />
          <g id="Layer1083" transform="matrix(.35278 0 0 .35278 7.976 -99.21)">
            <path
              d="M900.567 469.205h10.205V459h-10.205zm5.102 0v7.016"
              style={{
                fill: 'none',
                stroke: '#000',
                strokeWidth: 0.5,
                strokeLinecap: 'round',
                strokeLinejoin: 'round',
                strokeDasharray: 'none'
              }}
              id="path112"
              className={clsvbl112_body}
            />
            <text x={900.567} y={464.102} id="text112" />
          </g>
          <text
            x={324.159}
            y={72.978}
            id="text113"
            style={{
              fontSize: '4.23333px',
              strokeWidth: 0.352777
            }}
          >
            <tspan
              fontFamily="Calibri"
              fontSize={2.117}
              fill="#000"
              fillOpacity={1}
              strokeOpacity={1}
              id="tspan113"
              style={{
                strokeWidth: 0.352777
              }}
            >
              {'VBL112'}
            </tspan>
          </text>
        </g>
        <path
          d="M275.735 73.289v-3h33"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.176389,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="path113"
          className={clsoutput_line_2}
        />
        <text
          x={278.839}
          y={67.071}
          id="text114"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        />
        <path
          d="M274.235 64.789h3a3 3 0 1 0 0-6h-3a3 3 0 1 0 0 6zm-3-3h9m-9 0h9"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.176389,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="ptc110_body"
          className={clsptc110_body}
        />
        <text
          x={336.115}
          y={139.317}
          id="text115"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        />
        <text
          x={272.471}
          y={63.925}
          id="text116"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        >
          <tspan
            fontFamily="Calibri"
            fontSize={2.117}
            fill="#000"
            fillOpacity={1}
            strokeOpacity={1}
            id="tspan116"
            style={{
              strokeWidth: 0.352777
            }}
          >
            {'PTC110'}
          </tspan>
        </text>
        <path
          d="M275.735 64.789v6"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.176389,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="output_line_1_1"
          className={clsoutput_line_1}
        />
        <g id="g54" transform="translate(-14.241 1.5)">
          <path
            d="M322.225 161.79h-4.5l4.5-9h-4.5z"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.176389,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="path117"
            className={clsvbl111_body}
          />
          <g id="Layer1087" transform="matrix(.35278 0 0 .35278 7.976 -99.21)">
            <path
              d="M877.394 732.189v-10.205h-10.205v10.205zm0-5.102h7.015"
              style={{
                fill: 'none',
                stroke: '#000',
                strokeWidth: 0.5,
                strokeLinecap: 'round',
                strokeLinejoin: 'round',
                strokeDasharray: 'none'
              }}
              id="path118"
              className={clsvbl111_body}
            />
            <text x={867.189} y={727.087} transform="rotate(-90 872.291 727.087)" id="text118" />
          </g>
          <text
            x={322.306}
            y={158.026}
            id="text119"
            style={{
              fontSize: '4.23333px',
              strokeWidth: 0.352777
            }}
          >
            <tspan
              fontFamily="Calibri"
              fontSize={2.117}
              fill="#000"
              fillOpacity={1}
              strokeOpacity={1}
              id="tspan119"
              style={{
                strokeWidth: 0.352777
              }}
            >
              {'VBL111'}
            </tspan>
          </text>
        </g>
        <path
          d="M275.735 73.289v-3h30v84"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.176389,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="output_line_4"
          className={clsoutput_line_4}
        />
        <text
          x={278.839}
          y={67.071}
          id="text120"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        />
        <text
          x={276.457}
          y={72.477}
          id="text121"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        >
          <tspan
            fontFamily="Calibri"
            fontStyle="italic"
            fontSize={2.117}
            fill="#000"
            fillOpacity={1}
            strokeOpacity={1}
            id="tspan121"
            style={{
              strokeWidth: 0.352777
            }}
          >
            {'Filtrate'}
          </tspan>
        </text>
        <g id="vbl109_body" transform="translate(-14.241 1.5)">
          <path
            d="M311.726 53.79h4.5l-4.5 9h4.5z"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.176389,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="path121"
            className={clsvbl109_body}
          />
          <g id="Layer1090" transform="matrix(.35278 0 0 .35278 7.976 -99.21)">
            <path
              d="M874.417 441.354v10.205h10.205v-10.205zm0 5.103h-7.015"
              style={{
                fill: 'none',
                stroke: '#000',
                strokeWidth: 0.5,
                strokeLinecap: 'round',
                strokeLinejoin: 'round',
                strokeDasharray: 'none'
              }}
              id="path122"
              className={clsvbl109_body}
            />
            <text x={874.417} y={446.457} transform="rotate(90 879.52 446.457)" id="text122" />
          </g>
          <text
            x={320.943}
            y={59.076}
            id="text123"
            style={{
              fontSize: '4.23333px',
              strokeWidth: 0.352777
            }}
          >
            <tspan
              fontFamily="Calibri"
              fontSize={2.117}
              fill="#000"
              fillOpacity={1}
              strokeOpacity={1}
              id="tspan123"
              style={{
                strokeWidth: 0.352777
              }}
            >
              {'VBL109'}
            </tspan>
          </text>
        </g>
        <path
          d="m206.693 121.3 13.964-.106v-71.89l79.088.107v5.99"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.17,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="recirc_line_4"
          className={clsrecirc_line_4}
        />
        <text
          x={262.337}
          y={103.742}
          id="text124"
          transform="scale(.87853 1.13827)"
          style={{
            fontSize: '3.71337px',
            strokeWidth: 0.309448
          }}
        />
        <g id="g11">
          <path
            d="m299.8 55.378-.007-5.95h68.975l.005 5.793"
            fill="none"
            stroke="#000"
            strokeMiterlimit={10}
            pointerEvents="none"
            id="recirc_line_3"
            style={{
              strokeWidth: 0.129148
            }}
            className={clsrecirc_line_3}
          />
        </g>
        <g id="g12">
          <path
            d="M299.734 64.289v6h-24v3"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.176389,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="output_line_2"
            className={clsoutput_line_1}
          />
        </g>
        <text
          x={302.839}
          y={67.071}
          id="text125"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        />
        <path
          d="M325.235 64.289h3a3 3 0 1 0 0-6h-3a3 3 0 1 0 0 6zm-3-3h9m-9 0h9"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.176389,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="path125"
          className={clstrb102_body}
        />
        <text
          x={387.115}
          y={138.817}
          id="text126"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        />
        <text
          x={323.537}
          y={63.163}
          id="text127"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        >
          <tspan
            fontFamily="Calibri"
            fontSize={2.117}
            fill="#000"
            fillOpacity={1}
            strokeOpacity={1}
            id="tspan127"
            style={{
              strokeWidth: 0.352777
            }}
          >
            {'TRB102'}
          </tspan>
        </text>
        <g id="flm105_body" transform="translate(-14.241 1.5)">
          <path
            d="M349.975 74.79v-12h6v12zm0 0 .858-1.716m.618-1.236 1.098-2.196m.852-1.704.858-1.716m.858-1.716.858-1.716"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.176389,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="path127"
            className={clsflm105_body}
          />
          <text
            x={349.206}
            y={62.069}
            id="text128"
            style={{
              fontSize: '4.23333px',
              strokeWidth: 0.352777
            }}
          >
            <tspan
              fontFamily="Calibri"
              fontSize={2.117}
              fill="#000"
              fillOpacity={1}
              strokeOpacity={1}
              id="tspan128"
              style={{
                strokeWidth: 0.352777
              }}
            >
              {'FLM105'}
            </tspan>
          </text>
        </g>
        <g id="g23">
          <path
            d="M326.734 64.289v6"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.176389,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="path128"
            className={clsoutput_line_5}
          />
        </g>
        <g id="g22">
          <path
            d="M317.734 70.289h18"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.176389,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="output_line_5"
            className={clsoutput_line_5}
          />
        </g>
        <text
          x={338.839}
          y={67.071}
          id="text129"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        />
        <g id="vbl113_body" transform="translate(-14.241 1.5)">
          <path
            d="M385.225 62.79h-4.5l4.5-9h-4.5z"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.176389,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="path130"
            className={clsvbl113_body}
          />
          <g id="Layer1097" transform="matrix(.35278 0 0 .35278 7.976 -99.21)">
            <path
              d="M1055.976 451.56v-10.206h-10.204v10.205zm0-5.103h7.016"
              style={{
                fill: 'none',
                stroke: '#000',
                strokeWidth: 0.5,
                strokeLinecap: 'round',
                strokeLinejoin: 'round',
                strokeDasharray: 'none'
              }}
              id="path131"
              className={clsvbl113_body}
            />
            <text x={1045.772} y={446.457} transform="rotate(-90 1050.874 446.457)" id="text131" />
          </g>
          <text
            x={384.59}
            y={58.767}
            id="text132"
            style={{
              fontSize: '4.23333px',
              strokeWidth: 0.352777
            }}
          >
            <tspan
              fontFamily="Calibri"
              fontSize={2.117}
              fill="#000"
              fillOpacity={1}
              strokeOpacity={1}
              id="tspan132"
              style={{
                strokeWidth: 0.352777
              }}
            >
              {'VBL113'}
            </tspan>
          </text>
        </g>
        <g id="g59" transform="translate(-14.241 1.5)">
          <path
            d="M364.975 71.04v-4.5l9 4.5v-4.5"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.176389,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="path132"
            className={clsvnr102_body}
          />
          <path
            d="M365.425 66.54a.45.45 0 1 1-.45-.45.45.45 0 0 1 .45.45z"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.176389,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="path133"
            className={clsvnr102_body}
          />
          <text
            x={366.356}
            y={73.502}
            id="text133"
            style={{
              fontSize: '4.23333px',
              strokeWidth: 0.352777
            }}
          >
            <tspan
              fontFamily="Calibri"
              fontSize={2.117}
              fill="#000"
              fillOpacity={1}
              strokeOpacity={1}
              id="tspan133"
              style={{
                strokeWidth: 0.352777
              }}
            >
              {'VNR108'}
            </tspan>
          </text>
        </g>
        <g id="g21">
          <path
            d="M341.734 70.289h9"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.176389,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="output_line_6"
            className={clsoutput_line_6}
          />
        </g>
        <text
          x={353.839}
          y={67.071}
          id="text134"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        />
        <g id="uvm101_body" transform="translate(-14.241 1.5)">
          <g id="Layer1101" transform="matrix(.35278 0 0 .35278 7.976 -99.21)">
            <path
              d="M1080 548.504a8.643 5.179 0 0 0 17.008 0v-88.158a8.643 5.179 0 0 0-17.008 0z"
              style={{
                fill: '#fff',
                fillRule: 'evenodd',
                strokeWidth: 0.5,
                strokeLinecap: 'round',
                strokeLinejoin: 'round'
              }}
              id="path135"
              className={clsuvm101_body}
            />
            <path
              d="M1080 548.504a8.643 5.179 0 0 0 17.008 0v-88.158a8.643 5.179 0 0 0-17.008 0z"
              style={{
                fill: 'none',
                stroke: '#000',
                strokeWidth: 0.5,
                strokeLinecap: 'round',
                strokeLinejoin: 'round',
                strokeDasharray: 'none'
              }}
              id="path136"
              className={clsuvm101_body}
            />
          </g>
          <text
            x={388.312}
            y={98.393}
            id="text136"
            style={{
              fontSize: '4.23333px',
              strokeWidth: 0.352777
            }}
          >
            <tspan
              fontFamily="Calibri"
              fontSize={2.117}
              fill="#000"
              fillOpacity={1}
              strokeOpacity={1}
              id="tspan136"
              style={{
                strokeWidth: 0.352777
              }}
            >
              {'UVM101'}
            </tspan>
          </text>
        </g>
        <g id="g20">
          <path
            d="M359.734 70.289h9v22.737h6"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.176389,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="output_line_7"
            className={clsoutput_line_7}
          />
        </g>
        <text
          x={371.839}
          y={67.071}
          id="text137"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        />
        <path
          d="M388.235 64.289h3a3 3 0 1 0 0-6h-3a3 3 0 1 0 0 6zm-3-3h9m-9 0h9"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.176389,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="ptc111_body"
          className={clsptc111_body}
        />
        <text
          x={450.115}
          y={138.817}
          id="text139"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        />
        <text
          x={386.38}
          y={63.216}
          id="text140"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        >
          <tspan
            fontFamily="Calibri"
            fontSize={2.117}
            fill="#000"
            fillOpacity={1}
            strokeOpacity={1}
            id="tspan140"
            style={{
              strokeWidth: 0.352777
            }}
          >
            {'PTC111'}
          </tspan>
        </text>
        <path
          d="M389.734 64.289v6"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.176389,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="path140"
          className={clsoutput_line_8}
        />
        <g id="vbl115_body" transform="translate(-14.241 1.5)">
          <path
            d="M418.225 161.79h-4.5l4.5-9h-4.5z"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.176389,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="path141"
            className={clsvbl115_body}
          />
          <g id="Layer1106" transform="matrix(.35278 0 0 .35278 7.976 -99.21)">
            <path
              d="M1149.52 732.189v-10.205h-10.205v10.205zm0-5.102h7.015"
              style={{
                fill: 'none',
                stroke: '#000',
                strokeWidth: 0.5,
                strokeLinecap: 'round',
                strokeLinejoin: 'round',
                strokeDasharray: 'none'
              }}
              id="path142"
              className={clsvbl115_body}
            />
            <text x={1139.315} y={727.087} transform="rotate(-90 1144.417 727.087)" id="text142" />
          </g>
          <text
            x={417.431}
            y={157.926}
            id="text143"
            style={{
              fontSize: '4.23333px',
              strokeWidth: 0.352777
            }}
          >
            <tspan
              fontFamily="Calibri"
              fontSize={2.117}
              fill="#000"
              fillOpacity={1}
              strokeOpacity={1}
              id="tspan143"
              style={{
                strokeWidth: 0.352777
              }}
            >
              {'VBL115'}
            </tspan>
          </text>
        </g>
        <g id="vnr105_body" transform="translate(-14.241 1.5)">
          <path
            d="M421.975 71.04v-4.5l9 4.5v-4.5"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.176389,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="path143"
            className={clsvnr105_body}
          />
          <path
            d="M422.425 66.54a.45.45 0 1 1-.45-.45.45.45 0 0 1 .45.45z"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.176389,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="path144"
            className={clsvnr105_body}
          />
          <text
            x={423.25}
            y={73.396}
            id="text144"
            style={{
              fontSize: '4.23333px',
              strokeWidth: 0.352777
            }}
          >
            <tspan
              fontFamily="Calibri"
              fontSize={2.117}
              fill="#000"
              fillOpacity={1}
              strokeOpacity={1}
              id="tspan144"
              style={{
                strokeWidth: 0.352777
              }}
            >
              {'VNR105'}
            </tspan>
          </text>
        </g>
        <path
          d="M422.735 64.289h3a3 3 0 1 0 0-6h-3a3 3 0 1 0 0 6zm-3-3h9m-9 0h9"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.176389,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="ftr103_body"
          className={clsftr103_body}
        />
        <text
          x={484.615}
          y={138.817}
          id="text145"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        />
        <text
          x={420.914}
          y={63.372}
          id="text146"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        >
          <tspan
            fontFamily="Calibri"
            fontSize={2.117}
            fill="#000"
            fillOpacity={1}
            strokeOpacity={1}
            id="tspan146"
            style={{
              strokeWidth: 0.352777
            }}
          >
            {'FTR103'}
          </tspan>
        </text>
        <g id="Layer1108" transform="matrix(.35278 0 0 .35278 -6.265 -97.71)">
          <path
            d="M1220.315 459.213v17.007"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.5,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="path146"
            className={clsoutput_line_9}
          />
        </g>
        <g id="g24">
          <path
            d="M380.734 70.289h27"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.176389,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="output_line_8"
            className={clsoutput_line_8}
          />
        </g>
        <text
          x={410.839}
          y={67.071}
          id="text147"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        />
        <path
          d="M388.235 88.29h3a3 3 0 1 0 0-6h-3a3 3 0 1 0 0 6zm-3-3h9m-9 0h9"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.176389,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="uvi101_body"
          className={clsuvi101_body}
        />
        <text
          x={450.115}
          y={162.817}
          id="text149"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        />
        <text
          x={386.445}
          y={87.16}
          id="text150"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        >
          <tspan
            fontFamily="Calibri"
            fontSize={2.117}
            fill="#000"
            fillOpacity={1}
            strokeOpacity={1}
            id="tspan150"
            style={{
              strokeWidth: 0.352777
            }}
          >
            {'UVI101'}
          </tspan>
        </text>
        <path
          d="M385.234 85.289h-4.5"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.176389,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="path150"
        />
        <g id="vbl116_body" transform="translate(-14.241 1.5)">
          <path
            d="M445.975 71.04v-4.5l9 4.5v-4.5z"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.176389,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="path151"
            className={clsvbl116_body}
          />
          <g id="Layer1113" transform="matrix(.35278 0 0 .35278 7.976 -99.21)">
            <path
              d="M1249.228 469.205h10.205V459h-10.205zm5.103 0v7.016"
              style={{
                fill: 'none',
                stroke: '#000',
                strokeWidth: 0.5,
                strokeLinecap: 'round',
                strokeLinejoin: 'round',
                strokeDasharray: 'none'
              }}
              id="path152"
              className={clsvbl116_body}
            />
            <text x={1249.228} y={464.102} id="text152" />
          </g>
          <text
            x={447.097}
            y={73.084}
            id="text153"
            style={{
              fontSize: '4.23333px',
              strokeWidth: 0.352777
            }}
          >
            <tspan
              fontFamily="Calibri"
              fontSize={2.117}
              fill="#000"
              fillOpacity={1}
              strokeOpacity={1}
              id="tspan153"
              style={{
                strokeWidth: 0.352777
              }}
            >
              {'VBL116'}
            </tspan>
          </text>
        </g>
        <g id="vml102_body" transform="translate(-14.241 1.5)">
          <path
            d="M445.975 83.04v4.5l9-4.5v4.5zm4.5 2.25v-4.5m-2.25 0h4.5"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.176389,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="path153"
          />
          <text
            x={447.203}
            y={89.843}
            id="text154"
            style={{
              fontSize: '4.23333px',
              strokeWidth: 0.352777
            }}
          >
            <tspan
              fontFamily="Calibri"
              fontSize={2.117}
              fill="#000"
              fillOpacity={1}
              strokeOpacity={1}
              id="tspan154"
              style={{
                strokeWidth: 0.352777
              }}
            >
              {'VML102'}
            </tspan>
          </text>
        </g>
        <text
          x={447.985}
          y={87.468}
          id="text155"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        >
          <tspan
            fontFamily="Calibri"
            fontSize={2.117}
            fill="#000"
            fillOpacity={1}
            strokeOpacity={1}
            id="tspan155"
            style={{
              strokeWidth: 0.352777
            }}
          >
            {'SAMPLE WATER'}
          </tspan>
        </text>
        <text
          x={447.847}
          y={70.854}
          id="text157"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        >
          <tspan
            fontFamily="Calibri"
            fontSize={2.117}
            fill="#000"
            fillOpacity={1}
            strokeOpacity={1}
            id="tspan157"
            style={{
              strokeWidth: 0.352777
            }}
          >
            {'OUTPUT WATER'}
          </tspan>
        </text>
        <path
          d="M416.734 70.289h15"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.176389,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="output_line_9"
          className={clsoutput_line_9}
        />
        <text
          x={434.839}
          y={67.071}
          id="text159"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        />
        <g id="vbl114_body" transform="translate(-14.241 1.5)">
          <path
            d="M413.725 53.79h4.5l-4.5 9h4.5z"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.176389,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="path159"
            className={clsvbl114_body}
          />
          <g id="Layer1119" transform="matrix(.35278 0 0 .35278 7.976 -99.21)">
            <path
              d="M1163.551 441.354v10.205h10.205v-10.205zm0 5.103h-7.016"
              style={{
                fill: 'none',
                stroke: '#000',
                strokeWidth: 0.5,
                strokeLinecap: 'round',
                strokeLinejoin: 'round',
                strokeDasharray: 'none'
              }}
              id="path160"
              className={clsvbl114_body}
            />
            <text x={1163.551} y={446.457} transform="rotate(90 1168.653 446.457)" id="text160" />
          </g>
          <text
            x={422.649}
            y={59.02}
            id="text161"
            style={{
              fontSize: '4.23333px',
              strokeWidth: 0.352777
            }}
          >
            <tspan
              fontFamily="Calibri"
              fontSize={2.117}
              fill="#000"
              fillOpacity={1}
              strokeOpacity={1}
              id="tspan161"
              style={{
                strokeWidth: 0.352777
              }}
            >
              {'VBL114'}
            </tspan>
          </text>
        </g>
        <g id="Layer1120" transform="matrix(.35278 0 0 .35278 -6.265 -97.71)">
          <text x={1165.335} y={467.098} id="text162" />
        </g>
        <text
          x={404.839}
          y={67.071}
          id="text163"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        />
        <g id="g10">
          <path
            d="M134.735 40.189h267v15.1"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.176389,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="path163"
            className={clsrefill_line_2}
          />
        </g>
        <text
          x={404.839}
          y={36.971}
          id="text164"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        />
        <g id="vsn103_body" transform="translate(-14.241 1.5)">
          <path
            d="M430.975 177.54v-4.5l9 4.5v-4.5"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.176389,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="path165"
            className={clsvnr103_body}
          />
          <path
            d="M431.425 173.04a.45.45 0 1 1-.45-.45.45.45 0 0 1 .45.45z"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.176389,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="path166"
            className={clsvnr103_body}
          />
          <text
            x={431.826}
            y={179.737}
            id="text166"
            style={{
              fontSize: '4.23333px',
              strokeWidth: 0.352777
            }}
          >
            <tspan
              fontFamily="Calibri"
              fontSize={2.117}
              fill="#000"
              fillOpacity={1}
              strokeOpacity={1}
              id="tspan166"
              style={{
                strokeWidth: 0.352777
              }}
            >
              {'VNR103'}
            </tspan>
          </text>
        </g>
        <g id="vsn101_body" transform="translate(-14.241 1.5)">
          <path
            d="M430.975 192.54v-4.5l9 4.5v-4.5"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.176389,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="path167"
            className={clsvsn101_body}
          />
          <path
            d="M431.425 188.04a.45.45 0 1 1-.45-.45.45.45 0 0 1 .45.45z"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.176389,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="path168"
            className={clsvsn101_body}
          />
          <text
            x={431.985}
            y={194.843}
            id="text168"
            style={{
              fontSize: '4.23333px',
              strokeWidth: 0.352777
            }}
          >
            <tspan
              fontFamily="Calibri"
              fontSize={2.117}
              fill="#000"
              fillOpacity={1}
              strokeOpacity={1}
              id="tspan168"
              style={{
                strokeWidth: 0.352777
              }}
            >
              {'VNR101'}
            </tspan>
          </text>
        </g>
        <g id="g6">
          <path
            d="M425.734 191.789h3v-7.5"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.176389,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="path170"
            className={clswaste1_line_6}
          />
        </g>
        <text
          x={431.839}
          y={188.571}
          id="text170"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        />
        <text
          x={296.839}
          y={188.571}
          id="text176"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        />
        <path
          d="M305.734 163.289v6"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.176389,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="vbl111_line_1"
          className={clsvbl111_line}
        />
        <text
          x={308.839}
          y={166.071}
          id="text177"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        />
        <path
          d="M305.781 172.353v4.326l-.013-.387"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.164801,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="vbl111_line_2"
          className={clsvbl111_line}
        />
        <text
          x={332.043}
          y={161.216}
          id="text178"
          transform="scale(.92884 1.07662)"
          style={{
            fontSize: '3.94265px',
            strokeWidth: 0.328554
          }}
        />
        <path
          d="M401.734 163.289v6"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.176389,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="path180"
          className={clsvbl115_line}
        />
        <text
          x={404.839}
          y={166.071}
          id="text180"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        />
        <g id="g7">
          <path
            d="M428.734 184.289v-7.5h-3"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.176389,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="path182"
            className={clswaste2_line_4}
          />
        </g>
        <text
          x={431.839}
          y={173.571}
          id="text182"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        />
        <g id="g26">
          <path
            d="M416.772 70.326h10.5v16.5h4.5"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.176389,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="output_line_10"
            className={clsoutput_line_10}
          />
        </g>
        <text
          x={430.376}
          y={67.108}
          id="text183"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        />
        <path
          d="m155.735 166.29-4.5 6-4.5-6"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.176389,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="path184"
        />
        <path
          d="m307.985 169.29-2.25 3-2.25-3"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.176389,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="path185"
        />
        <g id="g29">
          <path
            d="m403.985 169.29-2.25 3-2.25-3"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.176389,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="path186"
          />
        </g>
        <path
          d="M287.284 64.214h3a3 3 0 1 0 0-6h-3a3 3 0 1 0 0 6zm-3-3h9m-9 0h9"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.176389,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="ctr102_body"
          className={clsctr102_body}
        />
        <text
          x={348.115}
          y={138.817}
          id="text187"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        />
        <text
          x={285.333}
          y={63.085}
          id="text188"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        >
          <tspan
            fontFamily="Calibri"
            fontSize={2.117}
            fill="#000"
            fillOpacity={1}
            strokeOpacity={1}
            id="tspan188"
            style={{
              strokeWidth: 0.352777
            }}
          >
            {'CTR102'}
          </tspan>
        </text>
        <path
          d="M289.234 64.364v6"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.176389,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="path188"
          className={clsoutput_line_2}
        />
        <path
          d="M436.235 178.29h3a3 3 0 1 0 0-6h-3a3 3 0 1 0 0 6zm-3-3h9m-9 0h9"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.176389,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="ptc114_body"
          className={clsptc114_body}
        />
        <text
          x={498.115}
          y={252.817}
          id="text189"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        />
        <text
          x={434.449}
          y={177.261}
          id="text190"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        >
          <tspan
            fontFamily="Calibri"
            fontSize={2.117}
            fill="#000"
            fillOpacity={1}
            strokeOpacity={1}
            id="tspan190"
            style={{
              strokeWidth: 0.352777
            }}
          >
            {'PTC114'}
          </tspan>
        </text>
        <path
          d="M437.734 178.289v6"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.176389,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="path190"
          className={clswaste1_line_7}
        />
        <path
          d="M22.865 115.35h6.776"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.153054,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="inpput_line_1"
          className={clsinpput_line_1}
        />
        <path
          d="M161.7 91.438v7.352"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.17,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="path77-8"
          className={clsvnr104_body}
        />
        <text
          x={169.075}
          y={-145.575}
          id="text50-0"
          transform="scale(1 -1)"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        />
        <path
          d="M161.717 136.376v7.352"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.17,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="path77-8-7"
          className={clsinput_line_5}
        />
        <path
          d="M153.59 143.807h8.034"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.17,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="path77-8-7-1"
          className={clsinput_line_5}
        />
        <path
          d="M150.12 143.794h2.173"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.17,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="path77-8-7-1-2"
          className={clsinput_line_5}
        />
        <path
          d="M134.96 143.817h14.005"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.17,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="path77-8-7-1-8"
          className={clsinput_line_5}
        />
        <g id="Layer1056-1-6-2-3-6" transform="matrix(0 -.35278 .33663 0 -28.852 371.954)">
          <path
            d="M659.055 638.015v17.008"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.5,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="path77-8-7-1-2-3"
          />
        </g>
        <g id="g28">
          <path
            d="M440.927 86.8h5.683"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.176389,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="path106-4"
          />
        </g>
        <text
          x={340.339}
          y={111.026}
          id="text106-9"
          transform="scale(1.32835 .75282)"
          style={{
            fontSize: '5.62332px',
            strokeWidth: 0.46861
          }}
        />
        <g id="g27">
          <path
            d="M440.9 70.19h5.683"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.176389,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="vbl116_line"
            className={clsvbl116_line}
          />
        </g>
        <text
          x={340.319}
          y={88.961}
          id="text106-9-2"
          transform="scale(1.32835 .75282)"
          style={{
            fontSize: '5.62332px',
            strokeWidth: 0.46861
          }}
        />
        <g id="g8">
          <path
            d="M428.848 184.463h17.77"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.139269,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="path106-4-1"
            className={clswaste1_line_7}
          />
        </g>
        <text
          x={200.626}
          y={418.114}
          id="text106-9-7"
          transform="scale(2.3069 .43348)"
          style={{
            fontSize: '9.76585px',
            strokeWidth: 0.813821
          }}
        />
        <g id="g34">
          <rect
            x={7.208}
            y={114.017}
            width={15.636}
            height={2.606}
            rx={1.303}
            ry={1.303}
            id="rect18"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.153228,
              strokeLinecap: 'round',
              strokeLinejoin: 'round'
            }}
            className={clsinput_arrow_body}
          />
          <text
            x={9.249}
            y={116.053}
            id="text7-0"
            style={{
              fontSize: '4.23333px',
              strokeWidth: 0.352777
            }}
          >
            <tspan
              fontFamily="Calibri"
              fontSize={2.117}
              fill="#000"
              fillOpacity={1}
              strokeOpacity={1}
              id="tspan7-8"
              style={{
                strokeWidth: 0.352777
              }}
            >
              {'INPUT WATER'}
            </tspan>
          </text>
        </g>
        <g id="g33">
          <rect
            x={8.06}
            y={132.044}
            width={15.636}
            height={2.606}
            rx={1.303}
            ry={1.303}
            id="rect18-4"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.153228,
              strokeLinecap: 'round',
              strokeLinejoin: 'round'
            }}
            className={clsaair_arrow}
          />
        </g>
        <rect
          x={344.786}
          y={121.478}
          width={15.636}
          height={2.606}
          rx={1.303}
          ry={1.303}
          id="rect18-8"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.153228,
            strokeLinecap: 'round',
            strokeLinejoin: 'round'
          }}
          className={clsdit_arrow_body}
        />
        <rect
          x={446.89}
          y={68.825}
          width={15.636}
          height={2.606}
          rx={1.303}
          ry={1.303}
          id="rect18-5"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.153228,
            strokeLinecap: 'round',
            strokeLinejoin: 'round'
          }}
          className={clsoutput_arrow_body}
        />
        <rect
          x={446.743}
          y={85.447}
          width={15.636}
          height={2.606}
          rx={1.303}
          ry={1.303}
          id="rect18-2"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.153228,
            strokeLinecap: 'round',
            strokeLinejoin: 'round'
          }}
          className={clssample_arrow_body}
        />
        <text
          x={448.821}
          y={185.019}
          id="text169"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        >
          <tspan
            fontFamily="Calibri"
            fontSize={2.117}
            fill="#000"
            fillOpacity={1}
            strokeOpacity={1}
            id="tspan169"
            style={{
              strokeWidth: 0.352777
            }}
          >
            {'DRAIN WATER'}
          </tspan>
        </text>
        <rect
          x={446.711}
          y={183.058}
          width={15.636}
          height={2.606}
          rx={1.303}
          ry={1.303}
          id="drain_arrow"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.153228,
            strokeLinecap: 'round',
            strokeLinejoin: 'round'
          }}
          className={clsdrain_arrow_body}
        />
        <g id="group1129-437" transform="matrix(.30646 0 0 .30646 170.172 -222.219)">
          <g id="shape1130-438" transform="translate(25.512 -10.63)" />
          <rect
            x={0}
            y={1169.29}
            width={51.024}
            height={21.26}
            rx={10.63}
            ry={10.63}
            className="st1"
            id="rect212"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.5,
              strokeLinecap: 'round',
              strokeLinejoin: 'round'
            }}
          />
          <g id="shape1129-441">
            <text
              x={9.21}
              y={1178.12}
              className="st2"
              id="text212"
              style={{
                fontSize: '4.9999px',
                fontFamily: 'Calibri',
                fill: '#000'
              }}
            >
              {'HIGH PRESSURE '}
              <tspan x={5.94} dy={6} className="st10" id="tspan212">
                {'SERVICING WATER'}
              </tspan>
            </text>
          </g>
        </g>
        <g id="ptc101_body" transform="translate(-14.241 1.5)">
          <path
            d="M55.976 107.79h3a3 3 0 1 0 0-6h-3a3 3 0 1 0 0 6zm-3-3h9m-9 0h9"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.176389,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="ptc101_body_id"
            className={clsptc101_body}
          />
          <text
            x={54.061}
            y={106.595}
            id="text10"
            style={{
              fontSize: '4.23333px',
              strokeWidth: 0.352777
            }}
          >
            <tspan
              fontFamily="Calibri"
              fontSize={2.117}
              fill="#000"
              fillOpacity={1}
              strokeOpacity={1}
              id="tspan10"
              style={{
                strokeWidth: 0.352777
              }}
            >
              {'PTC101'}
            </tspan>
          </text>
          <text
            x={57.535}
            y={100.652}
            id="ptc101_value_id"
            style={{
              fontSize: '4.23333px',
              textAnchor: 'middle',
              strokeWidth: 0.352777
            }}
            className={clsshow_sensor}
          >
            <tspan
              fontFamily="Calibri"
              fontSize={2.117}
              fill="#000"
              fillOpacity={1}
              strokeOpacity={1}
              id="tspan121-3"
              style={{
                strokeWidth: 0.352777
              }}
            >
              {ptc101_value}
            </tspan>
          </text>
        </g>
        <text
          x={142.51}
          y={60.024}
          id="ptc106_value_id"
          style={{
            fontSize: '4.23333px',
            textAnchor: 'middle',
            strokeWidth: 0.352777
          }}
          className={clsshow_sensor}
        >
          <tspan
            fontFamily="Calibri"
            fontSize={2.117}
            fill="#000"
            fillOpacity={1}
            strokeOpacity={1}
            id="tspan121-3-2-4"
            style={{
              strokeWidth: 0.352777
            }}
          >
            {ptc106_value}
          </tspan>
        </text>
        <text
          x={120.903}
          y={108.458}
          id="tnk101_value_id"
          style={{
            fontSize: '4.23333px',
            textAnchor: 'middle',
            strokeWidth: 0.352777
          }}
          className={clsshow_sensor}
        >
          <tspan
            fontFamily="Calibri"
            fontSize={2.117}
            fill="#000"
            fillOpacity={1}
            strokeOpacity={1}
            id="tspan121-3-2-6"
            style={{
              strokeWidth: 0.352777
            }}
          >
            {tnk101_value}
          </tspan>
        </text>
        <g id="ptc113_body" transform="translate(-14.241 1.5)">
          <path
            d="M112.976 107.79h3a3 3 0 1 0 0-6h-3a3 3 0 1 0 0 6zm-3-3h9m-9 0h9"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.176389,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="path38"
            className={clsptc113_body}
          />
          <text
            x={111.061}
            y={106.717}
            id="text39"
            style={{
              fontSize: '4.23333px',
              strokeWidth: 0.352777
            }}
          >
            <tspan
              fontFamily="Calibri"
              fontSize={2.117}
              fill="#000"
              fillOpacity={1}
              strokeOpacity={1}
              id="tspan39"
              style={{
                strokeWidth: 0.352777
              }}
            >
              {'PTC113'}
            </tspan>
          </text>
          <text
            x={114.872}
            y={100.738}
            id="ptc113_value_id"
            style={{
              fontSize: '4.23333px',
              textAnchor: 'middle',
              strokeWidth: 0.352777
            }}
            className={clsshow_sensor}
          >
            <tspan
              fontFamily="Calibri"
              fontSize={2.117}
              fill="#000"
              fillOpacity={1}
              strokeOpacity={1}
              id="tspan121-3-2-82"
              style={{
                strokeWidth: 0.352777
              }}
            >
              {ptc113_value}
            </tspan>
          </text>
        </g>
        <g id="ctr101_body" transform="translate(-14.241 1.5)">
          <path
            d="M90.476 107.79h3a3 3 0 1 0 0-6h-3a3 3 0 1 0 0 6zm-3-3h9m-9 0h9"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.176389,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="path13"
            className={clsctr101_body}
          />
          <text
            x={88.533}
            y={106.595}
            id="text14"
            style={{
              fontSize: '4.23333px',
              strokeWidth: 0.352777
            }}
          >
            <tspan
              fontFamily="Calibri"
              fontSize={2.117}
              fill="#000"
              fillOpacity={1}
              strokeOpacity={1}
              id="tspan14"
              style={{
                strokeWidth: 0.352777
              }}
            >
              {'CTR101'}
            </tspan>
          </text>
          <text
            x={93.1}
            y={101.043}
            id="ctr101_value_id"
            style={{
              fontSize: '4.23333px',
              textAnchor: 'middle',
              strokeWidth: 0.352777
            }}
            className={clsshow_sensor}
          >
            <tspan
              fontFamily="Calibri"
              fontSize={2.117}
              fill="#000"
              fillOpacity={1}
              strokeOpacity={1}
              id="tspan121-3-2-2"
              style={{
                strokeWidth: 0.352777
              }}
            >
              {ctr101_value}
            </tspan>
          </text>
        </g>
        <g id="trb101_body" transform="translate(-14.241 1.5)">
          <path
            d="M78.476 107.79h3a3 3 0 1 0 0-6h-3a3 3 0 1 0 0 6zm-3-3h9m-9 0h9"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.176389,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="path11"
            className={clstrb101_body}
          />
          <text
            x={76.522}
            y={106.717}
            id="text12"
            style={{
              fontSize: '4.23333px',
              strokeWidth: 0.352777
            }}
          >
            <tspan
              fontFamily="Calibri"
              fontSize={2.117}
              fill="#000"
              fillOpacity={1}
              strokeOpacity={1}
              id="tspan12"
              style={{
                strokeWidth: 0.352777
              }}
            >
              {'TRB101'}
            </tspan>
          </text>
          <text
            x={80.359}
            y={100.783}
            id="trb101_value_id"
            style={{
              fontSize: '4.23333px',
              textAnchor: 'middle',
              strokeWidth: 0.352777
            }}
            className={clsshow_sensor}
          >
            <tspan
              fontFamily="Calibri"
              fontSize={2.117}
              fill="#000"
              fillOpacity={1}
              strokeOpacity={1}
              id="tspan121-3-2-8"
              style={{
                strokeWidth: 0.352777
              }}
            >
              {trb101_value}
            </tspan>
          </text>
        </g>
        <text
          x={52.426}
          y={121.4}
          id="vbl101_value_id"
          style={{
            fontSize: '4.23333px',
            textAnchor: 'middle',
            strokeWidth: 0.352777
          }}
          className={clsshow_sensor}
        >
          <tspan
            fontFamily="Calibri"
            fontSize={2.117}
            fill="#000"
            fillOpacity={1}
            strokeOpacity={1}
            id="tspan121-3-2-1"
            style={{
              strokeWidth: 0.352777
            }}
          >
            {vbl101_value}
          </tspan>
        </text>
        <text
          x={121.864}
          y={33.393}
          id="tnk102_value_id"
          style={{
            fontSize: '4.23333px',
            textAnchor: 'middle',
            strokeWidth: 0.352777
          }}
          className={clsshow_sensor}
        >
          <tspan
            fontFamily="Calibri"
            fontSize={2.117}
            fill="#000"
            fillOpacity={1}
            strokeOpacity={1}
            id="tspan121-3-2-6-0"
            style={{
              strokeWidth: 0.352777
            }}
          >
            {tnk102_value}
          </tspan>
        </text>
        <text
          x={99.25}
          y={162.155}
          id="vbl102_value_id"
          style={{
            fontSize: '4.23333px',
            textAnchor: 'middle',
            strokeWidth: 0.352777
          }}
          className={clsshow_sensor}
        >
          <tspan
            fontFamily="Calibri"
            fontSize={2.117}
            fill="#000"
            fillOpacity={1}
            strokeOpacity={1}
            id="tspan121-3-2-1-4"
            style={{
              strokeWidth: 0.352777
            }}
          >
            {vbl102_value}
          </tspan>
        </text>
        <path
          d="M89.74 191.826h41.959"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.17,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="path28-4"
          className={clsvbl102_line}
        />
        <path
          d="M131.844 191.845h83.688"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.17,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="path28-4-9"
          className={clswaste1_line_1}
        />
        <path
          d="M89.592 163.381v28.51"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.171952,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="vbl102_line"
          className={clsvbl102_line}
        />
        <path
          d="M131.722 163.23v28.51"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.171952,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="clsvbl120_line"
          className={clsvbl120_line}
        />
        <path
          d="M215.605 163.248v28.51"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.171952,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="path28-4-1-7-7"
          className={clsvbl105_line}
        />
        <path
          d="M236.72 163.327v28.51"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.171952,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="path28-4-1-7-7-5"
          className={clsvbl106_line}
        />
        <text
          x={35.045}
          y={128.041}
          id="ppa101_value_id"
          style={{
            fontSize: '4.23333px',
            textAnchor: 'middle',
            strokeWidth: 0.352777
          }}
          className={clsshow_sensor}
        >
          <tspan
            fontFamily="Calibri"
            fontSize={2.117}
            fill="#000"
            fillOpacity={1}
            strokeOpacity={1}
            id="tspan121-3-2-7"
            style={{
              strokeWidth: 0.352777
            }}
          >
            {ppa101_value}
          </tspan>
        </text>
        <text
          x={67.013}
          y={120.51}
          id="ptc112_value_id"
          style={{
            fontSize: '4.23333px',
            textAnchor: 'middle',
            strokeWidth: 0.352777
          }}
          className={clsshow_sensor}
        >
          <tspan
            fontFamily="Calibri"
            fontSize={2.117}
            fill="#000"
            fillOpacity={1}
            strokeOpacity={1}
            id="tspan121-3-2-27"
            style={{
              strokeWidth: 0.352777
            }}
          >
            {ptc112_value}
          </tspan>
        </text>
        <text
          x={132.999}
          y={161.465}
          id="vbl120_value_id"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777,
            textAnchor: 'left'
          }}
          className={clsshow_sensor}
        >
          <tspan
            fontFamily="Calibri"
            fontSize={2.117}
            fill="#000"
            fillOpacity={1}
            strokeOpacity={1}
            id="tspan121-3-2-1-0"
            style={{
              strokeWidth: 0.352777
            }}
          >
            {vbl120_value}
          </tspan>
        </text>
        <rect
          x={413.649}
          y={93.878}
          width={59.13}
          height={73.79}
          rx={3.411}
          ry={11.068}
          fill="none"
          stroke="#666"
          strokeWidth={3.127}
          strokeDasharray="2, 2"
          pointerEvents="none"
          id="rect172"
          style={{
            strokeWidth: 0.141741,
            strokeMiterlimit: 4,
            strokeDasharray: '.0906473,.0906473',
            strokeDashoffset: 0
          }}
        />
        <text
          x={421.211}
          y={101.507}
          fill="#000"
          fontFamily="Helvetica"
          fontSize={5.364}
          fontWeight="bold"
          id="text854"
          style={{
            strokeWidth: 0.229842
          }}
        >
          {'Auxillary sensors'}
        </text>
        <image
          width={122.702}
          height={46.942}
          preserveAspectRatio="none"
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAACjYAAAOyCAYAAADaI34KAAAsd2NhQlgAACx3anVtYgAAAB5qdW1k YzJwYQARABCAAACqADibcQNjMnBhAAAALFFqdW1iAAAAR2p1bWRjMm1hABEAEIAAAKoAOJtxA3Vy bjp1dWlkOjRlZjhjNzBkLWZjNDUtNDM0ZS1iMDJmLTgyNmJiYjFkYzNmMwAAAAGzanVtYgAAAClq dW1kYzJhcwARABCAAACqADibcQNjMnBhLmFzc2VydGlvbnMAAAAA12p1bWIAAAAmanVtZGNib3IA EQAQgAAAqgA4m3EDYzJwYS5hY3Rpb25zAAAAAKljYm9yoWdhY3Rpb25zgaNmYWN0aW9ua2MycGEu ZWRpdGVkbXNvZnR3YXJlQWdlbnRtQWRvYmUgRmlyZWZseXFkaWdpdGFsU291cmNlVHlwZXhTaHR0 cDovL2N2LmlwdGMub3JnL25ld3Njb2Rlcy9kaWdpdGFsc291cmNldHlwZS9jb21wb3NpdGVXaXRo VHJhaW5lZEFsZ29yaXRobWljTWVkaWEAAACranVtYgAAAChqdW1kY2JvcgARABCAAACqADibcQNj MnBhLmhhc2guZGF0YQAAAAB7Y2JvcqVqZXhjbHVzaW9uc4GiZXN0YXJ0GCFmbGVuZ3RoGSyDZG5h bWVuanVtYmYgbWFuaWZlc3RjYWxnZnNoYTI1NmRoYXNoWCD1PTbPPowVqNqfhZP/SdDMT8U7AUle Y19m2/TaS0aEumNwYWRIAAAAAAAAAAAAAAIPanVtYgAAACRqdW1kYzJjbAARABCAAACqADibcQNj MnBhLmNsYWltAAAAAeNjYm9yqGhkYzp0aXRsZW9HZW5lcmF0ZWQgaW1hZ2VpZGM6Zm9ybWF0aWlt YWdlL3BuZ2ppbnN0YW5jZUlEeCx4bXAuaWlkOmQxZmM4MzZlLWMxOTYtNDc0NS1hZWY2LTFiMDgw MzA5NjY1M29jbGFpbV9nZW5lcmF0b3J4PkFkb2JlX1Bob3Rvc2hvcC8yNS40LjAgYWRvYmVfYzJw YS8wLjcuNi0yIGMycGEtcnMvMC4yNS4yLXBhdGNodGNsYWltX2dlbmVyYXRvcl9pbmZvgb9kbmFt ZW9BZG9iZSBQaG90b3Nob3BndmVyc2lvbmYyNS40LjD/aXNpZ25hdHVyZXgZc2VsZiNqdW1iZj1j MnBhLnNpZ25hdHVyZWphc3NlcnRpb25zgqJjdXJseCdzZWxmI2p1bWJmPWMycGEuYXNzZXJ0aW9u cy9jMnBhLmFjdGlvbnNkaGFzaFggSmnBvf+o3kEweL4k7cz4MTrB0WSVNFZxoA1rBrM31K+iY3Vy bHgpc2VsZiNqdW1iZj1jMnBhLmFzc2VydGlvbnMvYzJwYS5oYXNoLmRhdGFkaGFzaFggNRWOu64F 7wco+7Dy55mzLqc+WNehISTKIOMR9Oc8xMZjYWxnZnNoYTI1NgAAKEBqdW1iAAAAKGp1bWRjMmNz ABEAEIAAAKoAOJtxA2MycGEuc2lnbmF0dXJlAAAAKBBjYm9y0oREoQE4JKNmc2lnVHN0oWl0c3RU b2tlbnOBoWN2YWxZDjYwgg4yMAMCAQAwgg4pBgkqhkiG9w0BBwKggg4aMIIOFgIBAzEPMA0GCWCG SAFlAwQCAQUAMIGBBgsqhkiG9w0BCRABBKByBHAwbgIBAQYJYIZIAYb9bAcBMDEwDQYJYIZIAWUD BAIBBQAEIP6WanvB2fG2ujdXnItZpCewOrlaR1PV/SJzdcM2N2b9AhB7ci+Id/tE35iiLufpynLw GA8yMDI0MDIxODIzNDE1M1oCCAwBnO6PDN5doIILvTCCBQcwggLvoAMCAQICEAUenpHXHpEKu+Q9 XO3Q3dkwDQYJKoZIhvcNAQELBQAwYzELMAkGA1UEBhMCVVMxFzAVBgNVBAoTDkRpZ2lDZXJ0LCBJ bmMuMTswOQYDVQQDEzJEaWdpQ2VydCBUcnVzdGVkIEc0IFJTQTQwOTYgU0hBMjU2IFRpbWVTdGFt cGluZyBDQTAeFw0yMzA5MDgwMDAwMDBaFw0zNDEyMDcyMzU5NTlaMFgxCzAJBgNVBAYTAlVTMRcw FQYDVQQKEw5EaWdpQ2VydCwgSW5jLjEwMC4GA1UEAxMnRGlnaUNlcnQgQWRvYmUgQUFUTCBUaW1l c3RhbXAgUmVzcG9uZGVyMFkwEwYHKoZIzj0CAQYIKoZIzj0DAQcDQgAETSyuUfkD/7Xn8wWXVqw2 HxDxO5s6wRV+7SqUmsXSyaO3AvUh4dn8AHsnn27VOumGjUEM3zmV9NjfSs0Gx9P6bKOCAYswggGH MA4GA1UdDwEB/wQEAwIHgDAMBgNVHRMBAf8EAjAAMBYGA1UdJQEB/wQMMAoGCCsGAQUFBwMIMCAG A1UdIAQZMBcwCAYGZ4EMAQQCMAsGCWCGSAGG/WwHATAfBgNVHSMEGDAWgBS6FtltTYUvcyl2mi91 jGogj57IbzAdBgNVHQ4EFgQUsDWqVsMhqYvO07i8ixYlV53vNOEwWgYDVR0fBFMwUTBPoE2gS4ZJ aHR0cDovL2NybDMuZGlnaWNlcnQuY29tL0RpZ2lDZXJ0VHJ1c3RlZEc0UlNBNDA5NlNIQTI1NlRp bWVTdGFtcGluZ0NBLmNybDCBkAYIKwYBBQUHAQEEgYMwgYAwJAYIKwYBBQUHMAGGGGh0dHA6Ly9v Y3NwLmRpZ2ljZXJ0LmNvbTBYBggrBgEFBQcwAoZMaHR0cDovL2NhY2VydHMuZGlnaWNlcnQuY29t L0RpZ2lDZXJ0VHJ1c3RlZEc0UlNBNDA5NlNIQTI1NlRpbWVTdGFtcGluZ0NBLmNydDANBgkqhkiG 9w0BAQsFAAOCAgEAeCuMQseEEIRYlILJFfuWwvQL0smBtfWvJVjJI1HEeQxHYuoLs9BlEmAM1H6Q minw/m/YHOn+MyvPDhTiljqti/cjwekWUlri4HBRMhSAdamLxfF3UkQRf3g844OLsfJJ6RfrQDTn kGjMVvsYZVrFvQut5BNFeeSvqCA81Q9f0aH7ZJw7GVN1BAuBluR1i/GjcCnpzL2uJmKNHE5mqI7J ZLExSGArF4rPCsVbpdt7RrA2E5RdnMjFziLGkrNZIi2k8nfRmIFCfj1TcANhOeyFs31mRMDWkd/8 2i/ZlS+912RnxRi/Cj28G8tMO+eYAGdEwEppdgCzdkK/D0KQM85ZN5QkwVEC2ZTHnaiFoDecPxsI npR+lDakV851KHClvoYq/SD4GBx0gbYsc8nRR+av5eamBmCr8ciB7SGNwIAOmMOCrbPgHQvjG0AD UzwytTHTaHFvvXTicUqoy6/nMlNCXeyDCpdTI/73MdA/3L9nkXH8BBas5cJbnp1Xs/hwUEmXzMeq KeWGQ5K1nWbbb70eWr54LSEnaWQXUu7NF0klv/nUteg8pGeikUOeDpemgPt4brDhikDH34/TQm5S gGxhKt2y4WLJbJBAYECeMjr2CBtItxb6EnK26KdrFrBWUi0mRLZ5XlnhezE+Dt/za5GR203SFMd4 j3cI3c5Z5F5ucrswggauMIIElqADAgECAhAHNje3JFR82Ees/ShmKl5bMA0GCSqGSIb3DQEBCwUA MGIxCzAJBgNVBAYTAlVTMRUwEwYDVQQKEwxEaWdpQ2VydCBJbmMxGTAXBgNVBAsTEHd3dy5kaWdp Y2VydC5jb20xITAfBgNVBAMTGERpZ2lDZXJ0IFRydXN0ZWQgUm9vdCBHNDAeFw0yMjAzMjMwMDAw MDBaFw0zNzAzMjIyMzU5NTlaMGMxCzAJBgNVBAYTAlVTMRcwFQYDVQQKEw5EaWdpQ2VydCwgSW5j LjE7MDkGA1UEAxMyRGlnaUNlcnQgVHJ1c3RlZCBHNCBSU0E0MDk2IFNIQTI1NiBUaW1lU3RhbXBp bmcgQ0EwggIiMA0GCSqGSIb3DQEBAQUAA4ICDwAwggIKAoICAQDGhjUGSbPBPXJJUVXHJQPE8pE3 qZdRodbSg9GeTKJtoLDMg/la9hGhRBVCX6SI82j6ffOciQt/nR+eDzMfUBMLJnOWbfhXqAJ9/UO0 hNoR8XOxs+4rgISKIhjf69o9xBd/qxkrPkLcZ47qUT3w1lbU5ygt69OxtXXnHwZljZQp09nsad/Z kIdGAHvbREGJ3HxqV3rwN3mfXazL6IRktFLydkf3YYMZ3V+0VAshaG43IbtArF+y3kp9zvU5Emfv DqVjbOSmxR3NNg1c1eYbqMFkdECnwHLFuk4fsbVYTXn+149zk6wsOeKlSNbwsDETqVcplicu9Yem j052FVUmcJgmf6AaRyBD40NjgHt1biclkJg6OBGz9vae5jtb7IHeIhTZgirHkr+g3uM+onP65x9a bJTyUpURK1h0QCirc0PO30qhHGs4xSnzyqqWc0Jon7ZGs506o9UD4L/wojzKQtwYSH8UNM/STKvv mz3+DrhkKvp1KCRB7UK/BZxmSVJQ9FHzNklNiyDSLFc1eSuo80VgvCONWPfcYd6T/jnA+bIwpUzX 6ZhKWD7TA4j+s4/TXkt2ElGTyYwMO1uKIqjBJgj5FBASA31fI7tk42PgpuE+9sJ0sj8eCXbsq11G deJgo1gJASgADoRU7s7pXcheMBK9Rp6103a50g5rmQzSM7TNsQIDAQABo4IBXTCCAVkwEgYDVR0T AQH/BAgwBgEB/wIBADAdBgNVHQ4EFgQUuhbZbU2FL3MpdpovdYxqII+eyG8wHwYDVR0jBBgwFoAU 7NfjgtJxXWRM3y5nP+e6mK4cD08wDgYDVR0PAQH/BAQDAgGGMBMGA1UdJQQMMAoGCCsGAQUFBwMI MHcGCCsGAQUFBwEBBGswaTAkBggrBgEFBQcwAYYYaHR0cDovL29jc3AuZGlnaWNlcnQuY29tMEEG CCsGAQUFBzAChjVodHRwOi8vY2FjZXJ0cy5kaWdpY2VydC5jb20vRGlnaUNlcnRUcnVzdGVkUm9v dEc0LmNydDBDBgNVHR8EPDA6MDigNqA0hjJodHRwOi8vY3JsMy5kaWdpY2VydC5jb20vRGlnaUNl cnRUcnVzdGVkUm9vdEc0LmNybDAgBgNVHSAEGTAXMAgGBmeBDAEEAjALBglghkgBhv1sBwEwDQYJ KoZIhvcNAQELBQADggIBAH1ZjsCTtm+YqUQiAX5m1tghQuGwGC4QTRPPMFPOvxj7x1Bd4ksp+3CK Daopafxpwc8dB+k+YMjYC+VcW9dth/qEICU0MWfNthKWb8RQTGIdDAiCqBa9qVbPFXONASIlzpVp P0d3+3J0FNf/q0+KLHqrhc1DX+1gtqpPkWaeLJ7giqzl/Yy8ZCaHbJK9nXzQcAp876i8dU+6Wvep ELJd6f8oVInw1YpxdmXazPByoyP6wCeCRK6ZJxurJB4mwbfeKuv2nrF5mYGjVoarCkXJ38SNoOeY +/umnXKvxMfBwWpx2cYTgAnEtp/Nh4cku0+jSbl3ZpHxcpzpSwJSpzd+k1OsOx0ISQ+UzTl63f8l Y5knLD0/a6fxZsNBzU+2QJshIUDQtxMkzdwdeDrknq3lNHGS1yZr5Dhzq6YBT70/O3itTK37xJV7 7QpfMzmHQXh6OOmc4d0j/R0o08f56PGYX/sr2H7yRp11LB4nLCbbbxV7HhmLNriT1ObyF5lZynDw N7+YAN8gFk8n+2BnFqFmut1VwDophrCYoCvtlUG3OtUVmDG0YgkPCr2B2RP+v6TR81fZvAT6gt4y 3wSJ8ADNXcL50CN/AAvkdgIm2fBldkKmKYcJRyvmfxqkhQ/8mJb2VVQrH4D6wPIOK+XW+6kvRBVK 5xMOHds3OBqhK/bt1nz8MYIBuTCCAbUCAQEwdzBjMQswCQYDVQQGEwJVUzEXMBUGA1UEChMORGln aUNlcnQsIEluYy4xOzA5BgNVBAMTMkRpZ2lDZXJ0IFRydXN0ZWQgRzQgUlNBNDA5NiBTSEEyNTYg VGltZVN0YW1waW5nIENBAhAFHp6R1x6RCrvkPVzt0N3ZMA0GCWCGSAFlAwQCAQUAoIHRMBoGCSqG SIb3DQEJAzENBgsqhkiG9w0BCRABBDAcBgkqhkiG9w0BCQUxDxcNMjQwMjE4MjM0MTUzWjArBgsq hkiG9w0BCRACDDEcMBowGDAWBBTZGrkz/het6YIephP1pDpxTj5+fTAvBgkqhkiG9w0BCQQxIgQg IT6iZZeS5JsGYaSZfNTKcnf1HESA19AUx96MgmS+77swNwYLKoZIhvcNAQkQAi8xKDAmMCQwIgQg gtrxlJV7NoQCRY/VJwBp/mLHFFb6nguGq/gn6FMgJ9kwCgYIKoZIzj0EAwIESDBGAiEAieoc4/ZY wzxDS6IMNftKjgWqzIXL/hhuUW7JJb79vsgCIQDRjN71MI1p9FufErtPSdFNyGmCb5xQkgmvaCwy 38epQ2d4NWNoYWluglkGEDCCBgwwggP0oAMCAQICEH/ydB/Rxt5DtZR6jmVwnp4wDQYJKoZIhvcN AQELBQAwdTELMAkGA1UEBhMCVVMxIzAhBgNVBAoTGkFkb2JlIFN5c3RlbXMgSW5jb3Jwb3JhdGVk MR0wGwYDVQQLExRBZG9iZSBUcnVzdCBTZXJ2aWNlczEiMCAGA1UEAxMZQWRvYmUgUHJvZHVjdCBT ZXJ2aWNlcyBHMzAeFw0yNDAxMTEwMDAwMDBaFw0yNTAxMTAyMzU5NTlaMH8xETAPBgNVBAMMCGNh aS1wcm9kMRMwEQYDVQQKDApBZG9iZSBJbmMuMREwDwYDVQQHDAhTYW4gSm9zZTETMBEGA1UECAwK Q2FsaWZvcm5pYTELMAkGA1UEBhMCVVMxIDAeBgkqhkiG9w0BCQEWEWNhaS1vcHNAYWRvYmUuY29t MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA79MAp32GPZZBw7MpK0xuxWJZ2BwXMrmp bg+bvVC487/hbE1ji4PDYa8/UU8SPRHgW7t1pu3+L6j7EGH8ZBKdMCGug1ZhDmYWwHkX24cm1kPw +Fr73JOJhGUfkGZk6SJ+x1+tYG7TBR5SVMZGAXLSKALfUwQBW8/XeSINlhtG7B9/W+v/FEl5yCJO BQenbQUU9cXhMEg7cDndWAaV1zQSZkVh1zSWWfOaH9rQU3rIP5DL06ziScWA2fe1ONesHL21aJpX nrPjV1GN/2QeMR/jbGYpbO5tWy9r9oUpx4i6KmXlCpJWx1Jk+GaY62QnbbiLFpuY9jz1yq+xylLg m2UlwQIDAQAFo4IBjDCCAYgwDAYDVR0TAQH/BAIwADAOBgNVHQ8BAf8EBAMCB4AwHgYDVR0lBBcw FQYJKoZIhvcvAQEMBggrBgEFBQcDBDCBjgYDVR0gBIGGMIGDMIGABgkqhkiG9y8BAgMwczBxBggr BgEFBQcCAjBlDGNZb3UgYXJlIG5vdCBwZXJtaXR0ZWQgdG8gdXNlIHRoaXMgTGljZW5zZSBDZXJ0 aWZpY2F0ZSBleGNlcHQgYXMgcGVybWl0dGVkIGJ5IHRoZSBsaWNlbnNlIGFncmVlbWVudC4wXQYD VR0fBFYwVDBSoFCgToZMaHR0cDovL3BraS1jcmwuc3ltYXV0aC5jb20vY2FfN2E1YzNhMGM3MzEx NzQwNmFkZDE5MzEyYmMxYmMyM2YvTGF0ZXN0Q1JMLmNybDA3BggrBgEFBQcBAQQrMCkwJwYIKwYB BQUHMAGGG2h0dHA6Ly9wa2ktb2NzcC5zeW1hdXRoLmNvbTAfBgNVHSMEGDAWgBRXKXoyTcz+5DVO wB8kc85zU6vfajANBgkqhkiG9w0BAQsFAAOCAgEAIWPV/Nti76MPfipUnZACP/eVrEv59WObHuWC ZHj1By8bGm5UmjTgPQYlXyTj8XE/iY27phgrHg0piDsWDzu5s8B6TKkaMmUvgtk+UgukybbfdtBC 6KvtGgy40cO4DkEUoPDitDxT1igbQqdKogAoVKqDEVqnF+CFQQztbGcZhFI9XKTsCQwf9hw7LhJC o6jANBIABNyQtSwWIpPeSEJhPVgWLyKepgQxJMqL6sgYZxGq9pCSQn2gS8pafyQFLByZwEBD/Dxy tRZZL6b3ZXqF+fZZsE9fsBxpcWFiv8pFvgBQOtCzlSbfG8o7bgBPJXm7mAA8j3t3hDEeEx0Gx8B/ 9a89pzTebWVrD3SEe0uZl9EbVC++F4EosRJFdYwzuP1iJO1d5I3VxGa9FrVq/FYBGORvvDaTwand izCwae43ozCI97QPEUtS+jJztz1kapHcBsLAh7LxnE82rlmq1o4vfdFsQUz7HEpOkPFkyKohyPTn 1FIq4lkJKX3jBA6Na/sxyUZo9uvs4CA+0AeNcTXldyugRUF+mspdbMLiIduigdDLu+LJ3UcxvvLT E3374waDvUD1vzrXVsmJrCxk9CnI/RGmiINSZoDbUQcKPX/PXmCUmMHp0PhnXaanZwSI5Ot0Pit4 AnZaU7PvrSQmew1/cp3ZmJcfeB4FGRT3DYprp+lZBqUwggahMIIEiaADAgECAhAMqLZUe4nm0gaJ dc2Lm4niMA0GCSqGSIb3DQEBCwUAMGwxCzAJBgNVBAYTAlVTMSMwIQYDVQQKExpBZG9iZSBTeXN0 ZW1zIEluY29ycG9yYXRlZDEdMBsGA1UECxMUQWRvYmUgVHJ1c3QgU2VydmljZXMxGTAXBgNVBAMT EEFkb2JlIFJvb3QgQ0EgRzIwHhcNMTYxMTI5MDAwMDAwWhcNNDExMTI4MjM1OTU5WjB1MQswCQYD VQQGEwJVUzEjMCEGA1UEChMaQWRvYmUgU3lzdGVtcyBJbmNvcnBvcmF0ZWQxHTAbBgNVBAsTFEFk b2JlIFRydXN0IFNlcnZpY2VzMSIwIAYDVQQDExlBZG9iZSBQcm9kdWN0IFNlcnZpY2VzIEczMIIC IjANBgkqhkiG9w0BAQEFAAOCAg8AMIICCgKCAgEAtx8uvb0Js1xIbP4Mg65sAepReCWkgD6Jp7Gy iGTa9ol2gfn5HfOV/HiYjZiOz+TuHFU+DXNad86xEqgVeGVMlvIHGe/EHcKBxvEDXdlTXB5zIEkf l0/SGn7J6vTX8MNybfSi95eQDUOZ9fjCaq+PBFjS5ZfeNmzi/yR+MsA0jKKoWarSRCFFFBpUFQWf AgLyXOyxOnXQOQudjxNj6Wu0X0IB13+IH11WcKcWEWXM4j4jh6hLy29Cd3EoVG3oxcVenMF/EMgD 2tXjx4NUbTNB1/g9+MR6Nw5Mhp5k/g3atNExAxhtugC+T3SDShSEJfs2quiiRUHtX3RhOcK1s1OJ gT5s2s9xGy5/uxVpcAIaK2KiDJXW3xxN8nXPmk1NSVu/mxtfapr4TvSJbhrU7UA3qhQY9n4On2sb H1X1Tw+7LTek8KCA5ZDghOERPiIp/Jt893qov1bE5rJkagcVg0Wqjh89NhCaBA8VyRt3ovlGyCKd NV2UL3bn5vdFsTk7qqmp9makz1/SuVXYxIf6L6+8RXOatXWaPkmucuLE1TPOeP7S1N5JToFCs80l 2D2EtxoQXGCR48K/cTUR5zV/fQ+hdIOzoo0nFn77Y8Ydd2k7/x9BE78pmoeMnw6VXYfXCuWEgj6p 7jpbLoxQMoWMCVzlg72WVNhJFlSw4aD8fc6ezeECAwEAAaOCATQwggEwMBIGA1UdEwEB/wQIMAYB Af8CAQAwNQYDVR0fBC4wLDAqoCigJoYkaHR0cDovL2NybC5hZG9iZS5jb20vYWRvYmVyb290ZzIu Y3JsMA4GA1UdDwEB/wQEAwIBBjAUBgNVHSUEDTALBgkqhkiG9y8BAQcwVwYDVR0gBFAwTjBMBgkq hkiG9y8BAgMwPzA9BggrBgEFBQcCARYxaHR0cHM6Ly93d3cuYWRvYmUuY29tL21pc2MvcGtpL3By b2Rfc3ZjZV9jcHMuaHRtbDAkBgNVHREEHTAbpBkwFzEVMBMGA1UEAxMMU1lNQy00MDk2LTMzMB0G A1UdDgQWBBRXKXoyTcz+5DVOwB8kc85zU6vfajAfBgNVHSMEGDAWgBSmHOFtVCRMqI9Icr9uqYzV 5Owx1DANBgkqhkiG9w0BAQsFAAOCAgEAcc7lB4ym3C3cyOA7ZV4AkoGV65UgJK+faThdyXzxuNql TQBlOyXBGFyevlm33BsGO1mDJfozuyLyT2+7IVxWFvW5yYMV+5S1NeChMXIZnCzWNXnuiIQSdmPD 82TEVCkneQpFET4NDwSxo8/ykfw6Hx8fhuKz0wjhjkWMXmK3dNZXIuYVcbynHLyJOzA+vWU3sH2T 0jPtFp7FN39GZne4YG0aVMlnHhtHhxaXVCiv2RVoR4w1QtvKHQpzfPObR53Cl74iLStGVFKPwCLY RSpYRF7J6vVS/XxW4LzvN2b6VEKOcvJmN3LhpxFRl3YYzW+dwnwtbuHW6WJlmjffbLm1MxLFGlG9 5aCz31X8wzqYNsvb9+5AXcv8Ll69tLXmO1OtsY/3wILNUEp4VLZTE3wqm3n8hMnClZiiKyZCS7L4 E0mClbx+BRSMH3eVo6jgve41/fK3FQM4QCNIkpGs7FjjLy+ptC+JyyWqcfvORrFV/GOgB5hD+G5g hJcIpeigD/lHsCRYsOa5sFdqREhwIWLmSWtNwfLZdJ3dkCc7yRpm3gal6qRfTkYpxTNxxKyvKbka JDoxR9vtWrC3iNrQd9VvxC3TXtuzoHbqumeqgcAqefWF9u6snQ4Q9FkXzeuJArNuSvPIhgBjVtgg H0w0vm/lmCQYiC/Y12GeCxfgYlL33btjcGFkWQvgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPZZAQA3bX8v VEOKgQJ/m+vd1YdRqFO8wsHGAa/hqkQ8SD18D7Lag7jYhQTf+24u+deZcu0jn/E763tArKjV0Oj+ EjmREXgs/CkqbmrRpUbsdU7qkwNV2FiePr8MRaluKpnrrk0Xe1daI1Lq+i2cvX8zYWWWl0dbfnrf 5K+rsbhpCVFcngZdXJnLuoMYMgsEq6oQqeOwGQH1SLAQ9a7O6GjrQVX1e7XRYD9Xfi8tRBr6JRuZ 5+YiQ6o1QPBdT1cAYsLsiST1HrUbmb7GPvR27ZQJr9PzBu92132M+a1OU5t8E9Yrbdj8Mg8VnB3s Q1cldDbIhDio7Sy0mBHNQwbQb/fB7pzlbRRC3AAAAAlwSFlzAAAuIwAALiMBeKU/dgAANFhpVFh0 WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2Vo aUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6 eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDkuMS1jMDAyIDc5LmYzNTRlZmM3MCwgMjAyMy8xMS8wOS0x MjowNTo1MyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8x OTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIg eG1sbnM6ZGM9Imh0dHA6Ly9wdXJsLm9yZy9kYy9lbGVtZW50cy8xLjEvIiB4bWxuczp4bXA9Imh0 dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtbG5zOnhtcE1NPSJodHRwOi8vbnMuYWRvYmUu Y29tL3hhcC8xLjAvbW0vIiB4bWxuczpzdFJlZj0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4w L3NUeXBlL1Jlc291cmNlUmVmIyIgeG1sbnM6c3RFdnQ9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFw LzEuMC9zVHlwZS9SZXNvdXJjZUV2ZW50IyIgeG1sbnM6aWxsdXN0cmF0b3I9Imh0dHA6Ly9ucy5h ZG9iZS5jb20vaWxsdXN0cmF0b3IvMS4wLyIgeG1sbnM6eG1wVFBnPSJodHRwOi8vbnMuYWRvYmUu Y29tL3hhcC8xLjAvdC9wZy8iIHhtbG5zOnN0RGltPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8x LjAvc1R5cGUvRGltZW5zaW9ucyMiIHhtbG5zOnhtcEc9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFw LzEuMC9nLyIgeG1sbnM6cGRmPSJodHRwOi8vbnMuYWRvYmUuY29tL3BkZi8xLjMvIiB4bWxuczpw aG90b3Nob3A9Imh0dHA6Ly9ucy5hZG9iZS5jb20vcGhvdG9zaG9wLzEuMC8iIGRjOmZvcm1hdD0i aW1hZ2UvcG5nIiB4bXA6TWV0YWRhdGFEYXRlPSIyMDI0LTAyLTE5VDEwOjQxOjQ4KzExOjAwIiB4 bXA6TW9kaWZ5RGF0ZT0iMjAyNC0wMi0xOVQxMDo0MTo0OCsxMTowMCIgeG1wOkNyZWF0ZURhdGU9 IjIwMjQtMDItMTlUMTA6Mzc6NTArMTE6MDAiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgSWxsdXN0 cmF0b3IgMjguMiAoTWFjaW50b3NoKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpkMWZjODM2 ZS1jMTk2LTQ3NDUtYWVmNi0xYjA4MDMwOTY2NTMiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6 YTMzNDMwNjItOGJkYy00MzYwLWIyYjMtMmQxMDM3MWUzMjVkIiB4bXBNTTpPcmlnaW5hbERvY3Vt ZW50SUQ9InV1aWQ6NUQyMDg5MjQ5M0JGREIxMTkxNEE4NTkwRDMxNTA4QzgiIHhtcE1NOlJlbmRp dGlvbkNsYXNzPSJwcm9vZjpwZGYiIGlsbHVzdHJhdG9yOlR5cGU9IkRvY3VtZW50IiBpbGx1c3Ry YXRvcjpTdGFydHVwUHJvZmlsZT0iUHJpbnQiIGlsbHVzdHJhdG9yOkNyZWF0b3JTdWJUb29sPSJB SVJvYmluIiB4bXBUUGc6SGFzVmlzaWJsZU92ZXJwcmludD0iRmFsc2UiIHhtcFRQZzpIYXNWaXNp YmxlVHJhbnNwYXJlbmN5PSJGYWxzZSIgeG1wVFBnOk5QYWdlcz0iMSIgcGRmOlByb2R1Y2VyPSJB ZG9iZSBQREYgbGlicmFyeSAxNy4wMCIgcGhvdG9zaG9wOkNvbG9yTW9kZT0iMyI+IDxkYzp0aXRs ZT4gPHJkZjpBbHQ+IDxyZGY6bGkgeG1sOmxhbmc9IngtZGVmYXVsdCI+QnJvbGdhLUxvZ28tVmVj dG9yPC9yZGY6bGk+IDwvcmRmOkFsdD4gPC9kYzp0aXRsZT4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0 UmVmOmluc3RhbmNlSUQ9InV1aWQ6MzJhODk4MDktZGZjMy0zYzRkLTk4ZjctNGQxMzcyMzViNWIw IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOmEzMzQzMDYyLThiZGMtNDM2MC1iMmIzLTJkMTAz NzFlMzI1ZCIgc3RSZWY6b3JpZ2luYWxEb2N1bWVudElEPSJ1dWlkOjVEMjA4OTI0OTNCRkRCMTE5 MTRBODU5MEQzMTUwOEM4IiBzdFJlZjpyZW5kaXRpb25DbGFzcz0icHJvb2Y6cGRmIi8+IDx4bXBN TTpIaXN0b3J5PiA8cmRmOlNlcT4gPHJkZjpsaSBzdEV2dDphY3Rpb249InNhdmVkIiBzdEV2dDpp bnN0YW5jZUlEPSJ4bXAuaWlkOmEzMzQzMDYyLThiZGMtNDM2MC1iMmIzLTJkMTAzNzFlMzI1ZCIg c3RFdnQ6d2hlbj0iMjAyNC0wMi0xOVQxMDozNzo0OSsxMTowMCIgc3RFdnQ6c29mdHdhcmVBZ2Vu dD0iQWRvYmUgSWxsdXN0cmF0b3IgMjguMiAoTWFjaW50b3NoKSIgc3RFdnQ6Y2hhbmdlZD0iLyIv PiA8cmRmOmxpIHN0RXZ0OmFjdGlvbj0iY29udmVydGVkIiBzdEV2dDpwYXJhbWV0ZXJzPSJmcm9t IGFwcGxpY2F0aW9uL3BkZiB0byBhcHBsaWNhdGlvbi92bmQuYWRvYmUucGhvdG9zaG9wIi8+IDxy ZGY6bGkgc3RFdnQ6YWN0aW9uPSJkZXJpdmVkIiBzdEV2dDpwYXJhbWV0ZXJzPSJjb252ZXJ0ZWQg ZnJvbSBhcHBsaWNhdGlvbi92bmQuYWRvYmUucGhvdG9zaG9wIHRvIGltYWdlL3BuZyIvPiA8cmRm OmxpIHN0RXZ0OmFjdGlvbj0ic2F2ZWQiIHN0RXZ0Omluc3RhbmNlSUQ9InhtcC5paWQ6ZDFmYzgz NmUtYzE5Ni00NzQ1LWFlZjYtMWIwODAzMDk2NjUzIiBzdEV2dDp3aGVuPSIyMDI0LTAyLTE5VDEw OjQxOjQ4KzExOjAwIiBzdEV2dDpzb2Z0d2FyZUFnZW50PSJBZG9iZSBQaG90b3Nob3AgMjUuNCAo TWFjaW50b3NoKSIgc3RFdnQ6Y2hhbmdlZD0iLyIvPiA8L3JkZjpTZXE+IDwveG1wTU06SGlzdG9y eT4gPHhtcFRQZzpNYXhQYWdlU2l6ZSBzdERpbTp3PSI4NDEuODg5ODMyIiBzdERpbTpoPSI1OTUu Mjc1NTc0IiBzdERpbTp1bml0PSJQb2ludHMiLz4gPHhtcFRQZzpQbGF0ZU5hbWVzPiA8cmRmOlNl cT4gPHJkZjpsaT5DeWFuPC9yZGY6bGk+IDxyZGY6bGk+TWFnZW50YTwvcmRmOmxpPiA8cmRmOmxp PlllbGxvdzwvcmRmOmxpPiA8cmRmOmxpPkJsYWNrPC9yZGY6bGk+IDwvcmRmOlNlcT4gPC94bXBU UGc6UGxhdGVOYW1lcz4gPHhtcFRQZzpTd2F0Y2hHcm91cHM+IDxyZGY6U2VxPiA8cmRmOmxpPiA8 cmRmOkRlc2NyaXB0aW9uIHhtcEc6Z3JvdXBOYW1lPSJEZWZhdWx0IFN3YXRjaCBHcm91cCIgeG1w Rzpncm91cFR5cGU9IjAiPiA8eG1wRzpDb2xvcmFudHM+IDxyZGY6U2VxPiA8cmRmOmxpIHhtcEc6 c3dhdGNoTmFtZT0iV2hpdGUiIHhtcEc6bW9kZT0iQ01ZSyIgeG1wRzp0eXBlPSJQUk9DRVNTIiB4 bXBHOmN5YW49IjAuMDAwMDAwIiB4bXBHOm1hZ2VudGE9IjAuMDAwMDAwIiB4bXBHOnllbGxvdz0i MC4wMDAwMDAiIHhtcEc6YmxhY2s9IjAuMDAwMDAwIi8+IDxyZGY6bGkgeG1wRzpzd2F0Y2hOYW1l PSJCbGFjayIgeG1wRzptb2RlPSJDTVlLIiB4bXBHOnR5cGU9IlBST0NFU1MiIHhtcEc6Y3lhbj0i MC4wMDAwMDAiIHhtcEc6bWFnZW50YT0iMC4wMDAwMDAiIHhtcEc6eWVsbG93PSIwLjAwMDAwMCIg eG1wRzpibGFjaz0iMTAwLjAwMDAwMCIvPiA8cmRmOmxpIHhtcEc6c3dhdGNoTmFtZT0iQ01ZSyBS ZWQiIHhtcEc6bW9kZT0iQ01ZSyIgeG1wRzp0eXBlPSJQUk9DRVNTIiB4bXBHOmN5YW49IjAuMDAw MDAwIiB4bXBHOm1hZ2VudGE9IjEwMC4wMDAwMDAiIHhtcEc6eWVsbG93PSIxMDAuMDAwMDAwIiB4 bXBHOmJsYWNrPSIwLjAwMDAwMCIvPiA8cmRmOmxpIHhtcEc6c3dhdGNoTmFtZT0iQ01ZSyBZZWxs b3ciIHhtcEc6bW9kZT0iQ01ZSyIgeG1wRzp0eXBlPSJQUk9DRVNTIiB4bXBHOmN5YW49IjAuMDAw MDAwIiB4bXBHOm1hZ2VudGE9IjAuMDAwMDAwIiB4bXBHOnllbGxvdz0iMTAwLjAwMDAwMCIgeG1w RzpibGFjaz0iMC4wMDAwMDAiLz4gPHJkZjpsaSB4bXBHOnN3YXRjaE5hbWU9IkNNWUsgR3JlZW4i IHhtcEc6bW9kZT0iQ01ZSyIgeG1wRzp0eXBlPSJQUk9DRVNTIiB4bXBHOmN5YW49IjEwMC4wMDAw MDAiIHhtcEc6bWFnZW50YT0iMC4wMDAwMDAiIHhtcEc6eWVsbG93PSIxMDAuMDAwMDAwIiB4bXBH OmJsYWNrPSIwLjAwMDAwMCIvPiA8cmRmOmxpIHhtcEc6c3dhdGNoTmFtZT0iQ01ZSyBDeWFuIiB4 bXBHOm1vZGU9IkNNWUsiIHhtcEc6dHlwZT0iUFJPQ0VTUyIgeG1wRzpjeWFuPSIxMDAuMDAwMDAw IiB4bXBHOm1hZ2VudGE9IjAuMDAwMDAwIiB4bXBHOnllbGxvdz0iMC4wMDAwMDAiIHhtcEc6Ymxh Y2s9IjAuMDAwMDAwIi8+IDxyZGY6bGkgeG1wRzpzd2F0Y2hOYW1lPSJDTVlLIEJsdWUiIHhtcEc6 bW9kZT0iQ01ZSyIgeG1wRzp0eXBlPSJQUk9DRVNTIiB4bXBHOmN5YW49IjEwMC4wMDAwMDAiIHht cEc6bWFnZW50YT0iMTAwLjAwMDAwMCIgeG1wRzp5ZWxsb3c9IjAuMDAwMDAwIiB4bXBHOmJsYWNr PSIwLjAwMDAwMCIvPiA8cmRmOmxpIHhtcEc6c3dhdGNoTmFtZT0iQ01ZSyBNYWdlbnRhIiB4bXBH Om1vZGU9IkNNWUsiIHhtcEc6dHlwZT0iUFJPQ0VTUyIgeG1wRzpjeWFuPSIwLjAwMDAwMCIgeG1w RzptYWdlbnRhPSIxMDAuMDAwMDAwIiB4bXBHOnllbGxvdz0iMC4wMDAwMDAiIHhtcEc6YmxhY2s9 IjAuMDAwMDAwIi8+IDxyZGY6bGkgeG1wRzpzd2F0Y2hOYW1lPSJDPTE1IE09MTAwIFk9OTAgSz0x MCIgeG1wRzptb2RlPSJDTVlLIiB4bXBHOnR5cGU9IlBST0NFU1MiIHhtcEc6Y3lhbj0iMTUuMDAw MDAwIiB4bXBHOm1hZ2VudGE9IjEwMC4wMDAwMDAiIHhtcEc6eWVsbG93PSI5MC4wMDAwMDAiIHht cEc6YmxhY2s9IjEwLjAwMDAwMCIvPiA8cmRmOmxpIHhtcEc6c3dhdGNoTmFtZT0iQz0wIE09OTAg WT04NSBLPTAiIHhtcEc6bW9kZT0iQ01ZSyIgeG1wRzp0eXBlPSJQUk9DRVNTIiB4bXBHOmN5YW49 IjAuMDAwMDAwIiB4bXBHOm1hZ2VudGE9IjkwLjAwMDAwMCIgeG1wRzp5ZWxsb3c9Ijg1LjAwMDAw MCIgeG1wRzpibGFjaz0iMC4wMDAwMDAiLz4gPHJkZjpsaSB4bXBHOnN3YXRjaE5hbWU9IkM9MCBN PTgwIFk9OTUgSz0wIiB4bXBHOm1vZGU9IkNNWUsiIHhtcEc6dHlwZT0iUFJPQ0VTUyIgeG1wRzpj eWFuPSIwLjAwMDAwMCIgeG1wRzptYWdlbnRhPSI4MC4wMDAwMDAiIHhtcEc6eWVsbG93PSI5NS4w MDAwMDAiIHhtcEc6YmxhY2s9IjAuMDAwMDAwIi8+IDxyZGY6bGkgeG1wRzpzd2F0Y2hOYW1lPSJD PTAgTT01MCBZPTEwMCBLPTAiIHhtcEc6bW9kZT0iQ01ZSyIgeG1wRzp0eXBlPSJQUk9DRVNTIiB4 bXBHOmN5YW49IjAuMDAwMDAwIiB4bXBHOm1hZ2VudGE9IjUwLjAwMDAwMCIgeG1wRzp5ZWxsb3c9 IjEwMC4wMDAwMDAiIHhtcEc6YmxhY2s9IjAuMDAwMDAwIi8+IDxyZGY6bGkgeG1wRzpzd2F0Y2hO YW1lPSJDPTAgTT0zNSBZPTg1IEs9MCIgeG1wRzptb2RlPSJDTVlLIiB4bXBHOnR5cGU9IlBST0NF U1MiIHhtcEc6Y3lhbj0iMC4wMDAwMDAiIHhtcEc6bWFnZW50YT0iMzUuMDAwMDAwIiB4bXBHOnll bGxvdz0iODUuMDAwMDAwIiB4bXBHOmJsYWNrPSIwLjAwMDAwMCIvPiA8cmRmOmxpIHhtcEc6c3dh dGNoTmFtZT0iQz01IE09MCBZPTkwIEs9MCIgeG1wRzptb2RlPSJDTVlLIiB4bXBHOnR5cGU9IlBS T0NFU1MiIHhtcEc6Y3lhbj0iNS4wMDAwMDAiIHhtcEc6bWFnZW50YT0iMC4wMDAwMDAiIHhtcEc6 eWVsbG93PSI5MC4wMDAwMDAiIHhtcEc6YmxhY2s9IjAuMDAwMDAwIi8+IDxyZGY6bGkgeG1wRzpz d2F0Y2hOYW1lPSJDPTIwIE09MCBZPTEwMCBLPTAiIHhtcEc6bW9kZT0iQ01ZSyIgeG1wRzp0eXBl PSJQUk9DRVNTIiB4bXBHOmN5YW49IjIwLjAwMDAwMCIgeG1wRzptYWdlbnRhPSIwLjAwMDAwMCIg eG1wRzp5ZWxsb3c9IjEwMC4wMDAwMDAiIHhtcEc6YmxhY2s9IjAuMDAwMDAwIi8+IDxyZGY6bGkg eG1wRzpzd2F0Y2hOYW1lPSJDPTUwIE09MCBZPTEwMCBLPTAiIHhtcEc6bW9kZT0iQ01ZSyIgeG1w Rzp0eXBlPSJQUk9DRVNTIiB4bXBHOmN5YW49IjUwLjAwMDAwMCIgeG1wRzptYWdlbnRhPSIwLjAw MDAwMCIgeG1wRzp5ZWxsb3c9IjEwMC4wMDAwMDAiIHhtcEc6YmxhY2s9IjAuMDAwMDAwIi8+IDxy ZGY6bGkgeG1wRzpzd2F0Y2hOYW1lPSJDPTc1IE09MCBZPTEwMCBLPTAiIHhtcEc6bW9kZT0iQ01Z SyIgeG1wRzp0eXBlPSJQUk9DRVNTIiB4bXBHOmN5YW49Ijc1LjAwMDAwMCIgeG1wRzptYWdlbnRh PSIwLjAwMDAwMCIgeG1wRzp5ZWxsb3c9IjEwMC4wMDAwMDAiIHhtcEc6YmxhY2s9IjAuMDAwMDAw Ii8+IDxyZGY6bGkgeG1wRzpzd2F0Y2hOYW1lPSJDPTg1IE09MTAgWT0xMDAgSz0xMCIgeG1wRzpt b2RlPSJDTVlLIiB4bXBHOnR5cGU9IlBST0NFU1MiIHhtcEc6Y3lhbj0iODUuMDAwMDAwIiB4bXBH Om1hZ2VudGE9IjEwLjAwMDAwMCIgeG1wRzp5ZWxsb3c9IjEwMC4wMDAwMDAiIHhtcEc6YmxhY2s9 IjEwLjAwMDAwMCIvPiA8cmRmOmxpIHhtcEc6c3dhdGNoTmFtZT0iQz05MCBNPTMwIFk9OTUgSz0z MCIgeG1wRzptb2RlPSJDTVlLIiB4bXBHOnR5cGU9IlBST0NFU1MiIHhtcEc6Y3lhbj0iOTAuMDAw MDAwIiB4bXBHOm1hZ2VudGE9IjMwLjAwMDAwMCIgeG1wRzp5ZWxsb3c9Ijk1LjAwMDAwMCIgeG1w RzpibGFjaz0iMzAuMDAwMDAwIi8+IDxyZGY6bGkgeG1wRzpzd2F0Y2hOYW1lPSJDPTc1IE09MCBZ PTc1IEs9MCIgeG1wRzptb2RlPSJDTVlLIiB4bXBHOnR5cGU9IlBST0NFU1MiIHhtcEc6Y3lhbj0i NzUuMDAwMDAwIiB4bXBHOm1hZ2VudGE9IjAuMDAwMDAwIiB4bXBHOnllbGxvdz0iNzUuMDAwMDAw IiB4bXBHOmJsYWNrPSIwLjAwMDAwMCIvPiA8cmRmOmxpIHhtcEc6c3dhdGNoTmFtZT0iQz04MCBN PTEwIFk9NDUgSz0wIiB4bXBHOm1vZGU9IkNNWUsiIHhtcEc6dHlwZT0iUFJPQ0VTUyIgeG1wRzpj eWFuPSI4MC4wMDAwMDAiIHhtcEc6bWFnZW50YT0iMTAuMDAwMDAwIiB4bXBHOnllbGxvdz0iNDUu MDAwMDAwIiB4bXBHOmJsYWNrPSIwLjAwMDAwMCIvPiA8cmRmOmxpIHhtcEc6c3dhdGNoTmFtZT0i Qz03MCBNPTE1IFk9MCBLPTAiIHhtcEc6bW9kZT0iQ01ZSyIgeG1wRzp0eXBlPSJQUk9DRVNTIiB4 bXBHOmN5YW49IjcwLjAwMDAwMCIgeG1wRzptYWdlbnRhPSIxNS4wMDAwMDAiIHhtcEc6eWVsbG93 PSIwLjAwMDAwMCIgeG1wRzpibGFjaz0iMC4wMDAwMDAiLz4gPHJkZjpsaSB4bXBHOnN3YXRjaE5h bWU9IkM9ODUgTT01MCBZPTAgSz0wIiB4bXBHOm1vZGU9IkNNWUsiIHhtcEc6dHlwZT0iUFJPQ0VT UyIgeG1wRzpjeWFuPSI4NS4wMDAwMDAiIHhtcEc6bWFnZW50YT0iNTAuMDAwMDAwIiB4bXBHOnll bGxvdz0iMC4wMDAwMDAiIHhtcEc6YmxhY2s9IjAuMDAwMDAwIi8+IDxyZGY6bGkgeG1wRzpzd2F0 Y2hOYW1lPSJDPTEwMCBNPTk1IFk9NSBLPTAiIHhtcEc6bW9kZT0iQ01ZSyIgeG1wRzp0eXBlPSJQ Uk9DRVNTIiB4bXBHOmN5YW49IjEwMC4wMDAwMDAiIHhtcEc6bWFnZW50YT0iOTUuMDAwMDAwIiB4 bXBHOnllbGxvdz0iNS4wMDAwMDAiIHhtcEc6YmxhY2s9IjAuMDAwMDAwIi8+IDxyZGY6bGkgeG1w Rzpzd2F0Y2hOYW1lPSJDPTEwMCBNPTEwMCBZPTI1IEs9MjUiIHhtcEc6bW9kZT0iQ01ZSyIgeG1w Rzp0eXBlPSJQUk9DRVNTIiB4bXBHOmN5YW49IjEwMC4wMDAwMDAiIHhtcEc6bWFnZW50YT0iMTAw LjAwMDAwMCIgeG1wRzp5ZWxsb3c9IjI1LjAwMDAwMCIgeG1wRzpibGFjaz0iMjUuMDAwMDAwIi8+ IDxyZGY6bGkgeG1wRzpzd2F0Y2hOYW1lPSJDPTc1IE09MTAwIFk9MCBLPTAiIHhtcEc6bW9kZT0i Q01ZSyIgeG1wRzp0eXBlPSJQUk9DRVNTIiB4bXBHOmN5YW49Ijc1LjAwMDAwMCIgeG1wRzptYWdl bnRhPSIxMDAuMDAwMDAwIiB4bXBHOnllbGxvdz0iMC4wMDAwMDAiIHhtcEc6YmxhY2s9IjAuMDAw MDAwIi8+IDxyZGY6bGkgeG1wRzpzd2F0Y2hOYW1lPSJDPTUwIE09MTAwIFk9MCBLPTAiIHhtcEc6 bW9kZT0iQ01ZSyIgeG1wRzp0eXBlPSJQUk9DRVNTIiB4bXBHOmN5YW49IjUwLjAwMDAwMCIgeG1w RzptYWdlbnRhPSIxMDAuMDAwMDAwIiB4bXBHOnllbGxvdz0iMC4wMDAwMDAiIHhtcEc6YmxhY2s9 IjAuMDAwMDAwIi8+IDxyZGY6bGkgeG1wRzpzd2F0Y2hOYW1lPSJDPTM1IE09MTAwIFk9MzUgSz0x MCIgeG1wRzptb2RlPSJDTVlLIiB4bXBHOnR5cGU9IlBST0NFU1MiIHhtcEc6Y3lhbj0iMzUuMDAw MDAwIiB4bXBHOm1hZ2VudGE9IjEwMC4wMDAwMDAiIHhtcEc6eWVsbG93PSIzNS4wMDAwMDAiIHht cEc6YmxhY2s9IjEwLjAwMDAwMCIvPiA8cmRmOmxpIHhtcEc6c3dhdGNoTmFtZT0iQz0xMCBNPTEw MCBZPTUwIEs9MCIgeG1wRzptb2RlPSJDTVlLIiB4bXBHOnR5cGU9IlBST0NFU1MiIHhtcEc6Y3lh bj0iMTAuMDAwMDAwIiB4bXBHOm1hZ2VudGE9IjEwMC4wMDAwMDAiIHhtcEc6eWVsbG93PSI1MC4w MDAwMDAiIHhtcEc6YmxhY2s9IjAuMDAwMDAwIi8+IDxyZGY6bGkgeG1wRzpzd2F0Y2hOYW1lPSJD PTAgTT05NSBZPTIwIEs9MCIgeG1wRzptb2RlPSJDTVlLIiB4bXBHOnR5cGU9IlBST0NFU1MiIHht cEc6Y3lhbj0iMC4wMDAwMDAiIHhtcEc6bWFnZW50YT0iOTUuMDAwMDAwIiB4bXBHOnllbGxvdz0i MjAuMDAwMDAwIiB4bXBHOmJsYWNrPSIwLjAwMDAwMCIvPiA8cmRmOmxpIHhtcEc6c3dhdGNoTmFt ZT0iQz0yNSBNPTI1IFk9NDAgSz0wIiB4bXBHOm1vZGU9IkNNWUsiIHhtcEc6dHlwZT0iUFJPQ0VT UyIgeG1wRzpjeWFuPSIyNS4wMDAwMDAiIHhtcEc6bWFnZW50YT0iMjUuMDAwMDAwIiB4bXBHOnll bGxvdz0iNDAuMDAwMDAwIiB4bXBHOmJsYWNrPSIwLjAwMDAwMCIvPiA8cmRmOmxpIHhtcEc6c3dh dGNoTmFtZT0iQz00MCBNPTQ1IFk9NTAgSz01IiB4bXBHOm1vZGU9IkNNWUsiIHhtcEc6dHlwZT0i UFJPQ0VTUyIgeG1wRzpjeWFuPSI0MC4wMDAwMDAiIHhtcEc6bWFnZW50YT0iNDUuMDAwMDAwIiB4 bXBHOnllbGxvdz0iNTAuMDAwMDAwIiB4bXBHOmJsYWNrPSI1LjAwMDAwMCIvPiA8cmRmOmxpIHht cEc6c3dhdGNoTmFtZT0iQz01MCBNPTUwIFk9NjAgSz0yNSIgeG1wRzptb2RlPSJDTVlLIiB4bXBH OnR5cGU9IlBST0NFU1MiIHhtcEc6Y3lhbj0iNTAuMDAwMDAwIiB4bXBHOm1hZ2VudGE9IjUwLjAw MDAwMCIgeG1wRzp5ZWxsb3c9IjYwLjAwMDAwMCIgeG1wRzpibGFjaz0iMjUuMDAwMDAwIi8+IDxy ZGY6bGkgeG1wRzpzd2F0Y2hOYW1lPSJDPTU1IE09NjAgWT02NSBLPTQwIiB4bXBHOm1vZGU9IkNN WUsiIHhtcEc6dHlwZT0iUFJPQ0VTUyIgeG1wRzpjeWFuPSI1NS4wMDAwMDAiIHhtcEc6bWFnZW50 YT0iNjAuMDAwMDAwIiB4bXBHOnllbGxvdz0iNjUuMDAwMDAwIiB4bXBHOmJsYWNrPSI0MC4wMDAw MDAiLz4gPHJkZjpsaSB4bXBHOnN3YXRjaE5hbWU9IkM9MjUgTT00MCBZPTY1IEs9MCIgeG1wRzpt b2RlPSJDTVlLIiB4bXBHOnR5cGU9IlBST0NFU1MiIHhtcEc6Y3lhbj0iMjUuMDAwMDAwIiB4bXBH Om1hZ2VudGE9IjQwLjAwMDAwMCIgeG1wRzp5ZWxsb3c9IjY1LjAwMDAwMCIgeG1wRzpibGFjaz0i MC4wMDAwMDAiLz4gPHJkZjpsaSB4bXBHOnN3YXRjaE5hbWU9IkM9MzAgTT01MCBZPTc1IEs9MTAi IHhtcEc6bW9kZT0iQ01ZSyIgeG1wRzp0eXBlPSJQUk9DRVNTIiB4bXBHOmN5YW49IjMwLjAwMDAw MCIgeG1wRzptYWdlbnRhPSI1MC4wMDAwMDAiIHhtcEc6eWVsbG93PSI3NS4wMDAwMDAiIHhtcEc6 YmxhY2s9IjEwLjAwMDAwMCIvPiA8cmRmOmxpIHhtcEc6c3dhdGNoTmFtZT0iQz0zNSBNPTYwIFk9 ODAgSz0yNSIgeG1wRzptb2RlPSJDTVlLIiB4bXBHOnR5cGU9IlBST0NFU1MiIHhtcEc6Y3lhbj0i MzUuMDAwMDAwIiB4bXBHOm1hZ2VudGE9IjYwLjAwMDAwMCIgeG1wRzp5ZWxsb3c9IjgwLjAwMDAw MCIgeG1wRzpibGFjaz0iMjUuMDAwMDAwIi8+IDxyZGY6bGkgeG1wRzpzd2F0Y2hOYW1lPSJDPTQw IE09NjUgWT05MCBLPTM1IiB4bXBHOm1vZGU9IkNNWUsiIHhtcEc6dHlwZT0iUFJPQ0VTUyIgeG1w RzpjeWFuPSI0MC4wMDAwMDAiIHhtcEc6bWFnZW50YT0iNjUuMDAwMDAwIiB4bXBHOnllbGxvdz0i OTAuMDAwMDAwIiB4bXBHOmJsYWNrPSIzNS4wMDAwMDAiLz4gPHJkZjpsaSB4bXBHOnN3YXRjaE5h bWU9IkM9NDAgTT03MCBZPTEwMCBLPTUwIiB4bXBHOm1vZGU9IkNNWUsiIHhtcEc6dHlwZT0iUFJP Q0VTUyIgeG1wRzpjeWFuPSI0MC4wMDAwMDAiIHhtcEc6bWFnZW50YT0iNzAuMDAwMDAwIiB4bXBH OnllbGxvdz0iMTAwLjAwMDAwMCIgeG1wRzpibGFjaz0iNTAuMDAwMDAwIi8+IDxyZGY6bGkgeG1w Rzpzd2F0Y2hOYW1lPSJDPTUwIE09NzAgWT04MCBLPTcwIiB4bXBHOm1vZGU9IkNNWUsiIHhtcEc6 dHlwZT0iUFJPQ0VTUyIgeG1wRzpjeWFuPSI1MC4wMDAwMDAiIHhtcEc6bWFnZW50YT0iNzAuMDAw MDAwIiB4bXBHOnllbGxvdz0iODAuMDAwMDAwIiB4bXBHOmJsYWNrPSI3MC4wMDAwMDAiLz4gPC9y ZGY6U2VxPiA8L3htcEc6Q29sb3JhbnRzPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6bGk+IDxy ZGY6bGk+IDxyZGY6RGVzY3JpcHRpb24geG1wRzpncm91cE5hbWU9IkdyYXlzIiB4bXBHOmdyb3Vw VHlwZT0iMSI+IDx4bXBHOkNvbG9yYW50cz4gPHJkZjpTZXE+IDxyZGY6bGkgeG1wRzpzd2F0Y2hO YW1lPSJDPTAgTT0wIFk9MCBLPTEwMCIgeG1wRzptb2RlPSJDTVlLIiB4bXBHOnR5cGU9IlBST0NF U1MiIHhtcEc6Y3lhbj0iMC4wMDAwMDAiIHhtcEc6bWFnZW50YT0iMC4wMDAwMDAiIHhtcEc6eWVs bG93PSIwLjAwMDAwMCIgeG1wRzpibGFjaz0iMTAwLjAwMDAwMCIvPiA8cmRmOmxpIHhtcEc6c3dh dGNoTmFtZT0iQz0wIE09MCBZPTAgSz05MCIgeG1wRzptb2RlPSJDTVlLIiB4bXBHOnR5cGU9IlBS T0NFU1MiIHhtcEc6Y3lhbj0iMC4wMDAwMDAiIHhtcEc6bWFnZW50YT0iMC4wMDAwMDAiIHhtcEc6 eWVsbG93PSIwLjAwMDAwMCIgeG1wRzpibGFjaz0iODkuOTk5NDAwIi8+IDxyZGY6bGkgeG1wRzpz d2F0Y2hOYW1lPSJDPTAgTT0wIFk9MCBLPTgwIiB4bXBHOm1vZGU9IkNNWUsiIHhtcEc6dHlwZT0i UFJPQ0VTUyIgeG1wRzpjeWFuPSIwLjAwMDAwMCIgeG1wRzptYWdlbnRhPSIwLjAwMDAwMCIgeG1w Rzp5ZWxsb3c9IjAuMDAwMDAwIiB4bXBHOmJsYWNrPSI3OS45OTg4MDAiLz4gPHJkZjpsaSB4bXBH OnN3YXRjaE5hbWU9IkM9MCBNPTAgWT0wIEs9NzAiIHhtcEc6bW9kZT0iQ01ZSyIgeG1wRzp0eXBl PSJQUk9DRVNTIiB4bXBHOmN5YW49IjAuMDAwMDAwIiB4bXBHOm1hZ2VudGE9IjAuMDAwMDAwIiB4 bXBHOnllbGxvdz0iMC4wMDAwMDAiIHhtcEc6YmxhY2s9IjY5Ljk5OTcwMCIvPiA8cmRmOmxpIHht cEc6c3dhdGNoTmFtZT0iQz0wIE09MCBZPTAgSz02MCIgeG1wRzptb2RlPSJDTVlLIiB4bXBHOnR5 cGU9IlBST0NFU1MiIHhtcEc6Y3lhbj0iMC4wMDAwMDAiIHhtcEc6bWFnZW50YT0iMC4wMDAwMDAi IHhtcEc6eWVsbG93PSIwLjAwMDAwMCIgeG1wRzpibGFjaz0iNTkuOTk5MTAwIi8+IDxyZGY6bGkg eG1wRzpzd2F0Y2hOYW1lPSJDPTAgTT0wIFk9MCBLPTUwIiB4bXBHOm1vZGU9IkNNWUsiIHhtcEc6 dHlwZT0iUFJPQ0VTUyIgeG1wRzpjeWFuPSIwLjAwMDAwMCIgeG1wRzptYWdlbnRhPSIwLjAwMDAw MCIgeG1wRzp5ZWxsb3c9IjAuMDAwMDAwIiB4bXBHOmJsYWNrPSI1MC4wMDAwMDAiLz4gPHJkZjps aSB4bXBHOnN3YXRjaE5hbWU9IkM9MCBNPTAgWT0wIEs9NDAiIHhtcEc6bW9kZT0iQ01ZSyIgeG1w Rzp0eXBlPSJQUk9DRVNTIiB4bXBHOmN5YW49IjAuMDAwMDAwIiB4bXBHOm1hZ2VudGE9IjAuMDAw MDAwIiB4bXBHOnllbGxvdz0iMC4wMDAwMDAiIHhtcEc6YmxhY2s9IjM5Ljk5OTQwMCIvPiA8cmRm OmxpIHhtcEc6c3dhdGNoTmFtZT0iQz0wIE09MCBZPTAgSz0zMCIgeG1wRzptb2RlPSJDTVlLIiB4 bXBHOnR5cGU9IlBST0NFU1MiIHhtcEc6Y3lhbj0iMC4wMDAwMDAiIHhtcEc6bWFnZW50YT0iMC4w MDAwMDAiIHhtcEc6eWVsbG93PSIwLjAwMDAwMCIgeG1wRzpibGFjaz0iMjkuOTk4ODAwIi8+IDxy ZGY6bGkgeG1wRzpzd2F0Y2hOYW1lPSJDPTAgTT0wIFk9MCBLPTIwIiB4bXBHOm1vZGU9IkNNWUsi IHhtcEc6dHlwZT0iUFJPQ0VTUyIgeG1wRzpjeWFuPSIwLjAwMDAwMCIgeG1wRzptYWdlbnRhPSIw LjAwMDAwMCIgeG1wRzp5ZWxsb3c9IjAuMDAwMDAwIiB4bXBHOmJsYWNrPSIxOS45OTk3MDAiLz4g PHJkZjpsaSB4bXBHOnN3YXRjaE5hbWU9IkM9MCBNPTAgWT0wIEs9MTAiIHhtcEc6bW9kZT0iQ01Z SyIgeG1wRzp0eXBlPSJQUk9DRVNTIiB4bXBHOmN5YW49IjAuMDAwMDAwIiB4bXBHOm1hZ2VudGE9 IjAuMDAwMDAwIiB4bXBHOnllbGxvdz0iMC4wMDAwMDAiIHhtcEc6YmxhY2s9IjkuOTk5MTAwIi8+ IDxyZGY6bGkgeG1wRzpzd2F0Y2hOYW1lPSJDPTAgTT0wIFk9MCBLPTUiIHhtcEc6bW9kZT0iQ01Z SyIgeG1wRzp0eXBlPSJQUk9DRVNTIiB4bXBHOmN5YW49IjAuMDAwMDAwIiB4bXBHOm1hZ2VudGE9 IjAuMDAwMDAwIiB4bXBHOnllbGxvdz0iMC4wMDAwMDAiIHhtcEc6YmxhY2s9IjQuOTk4ODAwIi8+ IDwvcmRmOlNlcT4gPC94bXBHOkNvbG9yYW50cz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOmxp PiA8cmRmOmxpPiA8cmRmOkRlc2NyaXB0aW9uIHhtcEc6Z3JvdXBOYW1lPSJCcmlnaHRzIiB4bXBH Omdyb3VwVHlwZT0iMSI+IDx4bXBHOkNvbG9yYW50cz4gPHJkZjpTZXE+IDxyZGY6bGkgeG1wRzpz d2F0Y2hOYW1lPSJDPTAgTT0xMDAgWT0xMDAgSz0wIiB4bXBHOm1vZGU9IkNNWUsiIHhtcEc6dHlw ZT0iUFJPQ0VTUyIgeG1wRzpjeWFuPSIwLjAwMDAwMCIgeG1wRzptYWdlbnRhPSIxMDAuMDAwMDAw IiB4bXBHOnllbGxvdz0iMTAwLjAwMDAwMCIgeG1wRzpibGFjaz0iMC4wMDAwMDAiLz4gPHJkZjps aSB4bXBHOnN3YXRjaE5hbWU9IkM9MCBNPTc1IFk9MTAwIEs9MCIgeG1wRzptb2RlPSJDTVlLIiB4 bXBHOnR5cGU9IlBST0NFU1MiIHhtcEc6Y3lhbj0iMC4wMDAwMDAiIHhtcEc6bWFnZW50YT0iNzUu MDAwMDAwIiB4bXBHOnllbGxvdz0iMTAwLjAwMDAwMCIgeG1wRzpibGFjaz0iMC4wMDAwMDAiLz4g PHJkZjpsaSB4bXBHOnN3YXRjaE5hbWU9IkM9MCBNPTEwIFk9OTUgSz0wIiB4bXBHOm1vZGU9IkNN WUsiIHhtcEc6dHlwZT0iUFJPQ0VTUyIgeG1wRzpjeWFuPSIwLjAwMDAwMCIgeG1wRzptYWdlbnRh PSIxMC4wMDAwMDAiIHhtcEc6eWVsbG93PSI5NS4wMDAwMDAiIHhtcEc6YmxhY2s9IjAuMDAwMDAw Ii8+IDxyZGY6bGkgeG1wRzpzd2F0Y2hOYW1lPSJDPTg1IE09MTAgWT0xMDAgSz0wIiB4bXBHOm1v ZGU9IkNNWUsiIHhtcEc6dHlwZT0iUFJPQ0VTUyIgeG1wRzpjeWFuPSI4NS4wMDAwMDAiIHhtcEc6 bWFnZW50YT0iMTAuMDAwMDAwIiB4bXBHOnllbGxvdz0iMTAwLjAwMDAwMCIgeG1wRzpibGFjaz0i MC4wMDAwMDAiLz4gPHJkZjpsaSB4bXBHOnN3YXRjaE5hbWU9IkM9MTAwIE09OTAgWT0wIEs9MCIg eG1wRzptb2RlPSJDTVlLIiB4bXBHOnR5cGU9IlBST0NFU1MiIHhtcEc6Y3lhbj0iMTAwLjAwMDAw MCIgeG1wRzptYWdlbnRhPSI5MC4wMDAwMDAiIHhtcEc6eWVsbG93PSIwLjAwMDAwMCIgeG1wRzpi bGFjaz0iMC4wMDAwMDAiLz4gPHJkZjpsaSB4bXBHOnN3YXRjaE5hbWU9IkM9NjAgTT05MCBZPTAg Sz0wIiB4bXBHOm1vZGU9IkNNWUsiIHhtcEc6dHlwZT0iUFJPQ0VTUyIgeG1wRzpjeWFuPSI2MC4w MDAwMDAiIHhtcEc6bWFnZW50YT0iOTAuMDAwMDAwIiB4bXBHOnllbGxvdz0iMC4wMDMxMDAiIHht cEc6YmxhY2s9IjAuMDAzMTAwIi8+IDwvcmRmOlNlcT4gPC94bXBHOkNvbG9yYW50cz4gPC9yZGY6 RGVzY3JpcHRpb24+IDwvcmRmOmxpPiA8L3JkZjpTZXE+IDwveG1wVFBnOlN3YXRjaEdyb3Vwcz4g PC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9 InIiPz6LL2IlAADObUlEQVR4nOzdd5zlZ0Hv8e/MzvaUTQ/pITmUwAP5UQIhCYRDr9IERAGRuoiC CHbF6+WqqBSvyFFULAh6LRdRbIBroRc54I8mQ68JgTRIQsru3D/OcJNAys7uzDy/3znv9+t1XpuE ZPfDZrNnZs73PM/c0tJSAAAAAAAAAAAAALpgvnYAAAAAAAAAAAAAwLcZNgIAAAAAAAAAAACdYdgI AAAAAAAAAAAAdIZhIwAAAAAAAAAAANAZho0AAAAAAAAAAABAZxg2AgAAAAAAAAAAAJ1h2AgAAAAA AAAAAAB0hmEjAAAAAAAAAAAA0BmGjQAAAAAAAAAAAEBnGDYCAAAAAAAAAAAAnWHYCAAAAAAAAAAA AHSGYSMAAAAAAAAAAADQGYaNAAAAAAAAAAAAQGcYNgIAAAAAAAAAAACdYdgIAAAAAAAAAAAAdIZh IwAAAAAAAAAAANAZho0AAAAAAAAAAABAZxg2AgAAAAAAAAAAAJ1h2AgAAAAAAAAAAAB0hmEjAAAA AAAAAAAA0BmGjQAAAAAAAAAAAEBnGDYCAAAAAAAAAAAAnWHYCAAAAAAAAAAAAHSGYSMAAAAAAAAA AADQGYaNAAAAAAAAAAAAQGcYNgIAAAAAAAAAAACdYdgIAAAAAAAAAAAAdIZhIwAAAAAAAAAAANAZ ho0AAAAAAAAAAABAZxg2AgAAAAAAAAAAAJ1h2AgAAAAAAAAAAAB0hmEjAAAAAAAAAAAA0BmGjQAA AAAAAAAAAEBnGDYCAAAAAAAAAAAAnWHYCAAAAAAAAAAAAHSGYSMAAAAAAAAAAADQGYaNAAAAAAAA AAAAQGcYNgIAAAAAAAAAAACdYdgIAAAAAAAAAAAAdIZhIwAAAAAAAAAAANAZho0AAAAAAAAAAABA Zxg2AgAAAAAAAAAAAJ1h2AgAAAAAAAAAAAB0hmEjAAAAAAAAAAAA0BmGjQAAAAAAAAAAAEBnGDYC AAAAAAAAAAAAnWHYCAAAAAAAAAAAAHSGYSMAAAAAAAAAAADQGYaNAAAAAAAAAAAAQGcYNgIAAAAA AAAAAACdYdgIAAAAAAAAAAAAdIZhIwAAAAAAAAAAANAZho0AAAAAAAAAAABAZxg2AgAAAAAAAAAA AJ1h2AgAAAAAAAAAAAB0hmEjAAAAAAAAAAAA0BmGjQAAAAAAAAAAAEBnGDYCAAAAAAAAAAAAnWHY CAAAAAAAAAAAAHSGYSMAAAAAAAAAAADQGYaNAAAAAAAAAAAAQGcYNgIAAAAAAAAAAACdYdgIAAAA AAAAAAAAdIZhIwAAAAAAAAAAANAZho0AAAAAAAAAAABAZxg2AgAAAAAAAAAAAJ1h2AgAAAAAAAAA AAB0hmEjAAAAAAAAAAAA0BmGjQAAAAAAAAAAAEBnGDYCAAAAAAAAAAAAnWHYCAAAAAAAAAAAAHSG YSMAAAAAAAAAAADQGYaNAAAAAAAAAAAAQGcYNgIAAAAAAAAAAACdYdgIAAAAAAAAAAAAdIZhIwAA AAAAAAAAANAZho0AAAAAAAAAAABAZxg2AgAAAAAAAAAAAJ1h2AgAAAAAAAAAAAB0hmEjAAAAAAAA AAAA0BmGjQAAAAAAAAAAAEBnGDYCAAAAAAAAAAAAnWHYCAAAAAAAAAAAAHSGYSMAAAAAAAAAAADQ GYaNAAAAAAAAAAAAQGcYNgIAAAAAAAAAAACdYdgIAAAAAAAAAAAAdIZhIwAAAAAAAAAAANAZho0A AAAAAAAAAABAZxg2AgAAAAAAAAAAAJ1h2AgAAAAAAAAAAAB0hmEjAAAAAAAAAAAA0BmGjQAAAAAA AAAAAEBnGDYCAAAAAAAAAAAAnWHYCAAAAAAAAAAAAHSGYSMAAAAAAAAAAADQGYaNAAAAAAAAAAAA QGcYNgIAAAAAAAAAAACdYdgIAAAAAAAAAAAAdIZhIwAAAAAAAAAAANAZho0AAAAAAAAAAABAZxg2 AgAAAAAAAAAAAJ1h2AgAAAAAAAAAAAB0hmEjAAAAAAAAAAAA0BmGjQAAAAAAAAAAAEBnGDYCAAAA AAAAAAAAnWHYCAAAAAAAAAAAAHSGYSMAAAAAAAAAAADQGYaNAAAAAAAAAAAAQGcYNgIAAAAAAAAA AACdYdgIAAAAAAAAAAAAdIZhIwAAAAAAAAAAANAZho0AAAAAAAAAAABAZxg2AgAAAAAAAAAAAJ1h 2AgAAAAAAAAAAAB0hmEjAAAAAAAAAAAA0BmGjQAAAAAAAAAAAEBnGDYCAAAAAAAAAAAAnWHYCAAA AAAAAAAAAHSGYSMAAAAAAAAAAADQGYaNAAAAAAAAAAAAQGcYNgIAAAAAAAAAAACdYdgIAAAAAAAA AAAAdIZhIwAAAAAAAAAAANAZho0AAAAAAAAAAABAZxg2AgAAAAAAAAAAAJ1h2AgAAAAAAAAAAAB0 hmEjAAAAAAAAAAAA0BmGjQAAAAAAAAAAAEBnGDYCAAAAAAAAAAAAnWHYCAAAAAAAAAAAAHSGYSMA AAAAAAAAAADQGYaNAAAAAAAAAAAAQGcYNgIAAAAAAAAAAACdYdgIAAAAAAAAAAAAdIZhIwAAAAAA AAAAANAZho0AAAAAAAAAAABAZxg2AgAAAAAAAAAAAJ1h2AgAAAAAAAAAAAB0hmEjAAAAAAAAAAAA 0BmGjQAAAAAAAAAAAEBnGDYCAAAAAAAAAAAAnWHYCAAAAAAAAAAAAHSGYSMAAAAAAAAAAADQGYaN AAAAAAAAAAAAQGcYNgIAAAAAAAAAAACdYdgIAAAAAAAAAAAAdIZhIwAAAAAAAAAAANAZho0AAAAA AAAAAABAZxg2AgAAAAAAAAAAAJ1h2AgAAAAAAAAAAAB0hmEjAAAAAAAAAAAA0BmGjQAAAAAAAAAA AEBnGDYCAAAAAAAAAAAAnWHYCAAAAAAAAAAAAHSGYSMAAAAAAAAAAADQGYaNAAAAAAAAAAAAQGcY NgIAAAAAAAAAAACdYdgIAAAAAAAAAAAAdIZhIwAAAAAAAAAAANAZho0AAAAAAAAAAABAZxg2AgAA AAAAAAAAAJ1h2AgAAAAAAAAAAAB0hmEjAAAAAAAAAAAA0BmGjQAAAAAAAAAAAEBnGDYCAAAAAAAA AAAAnWHYCAAAAAAAAAAAAHSGYSMAAAAAAAAAAADQGYaNAAAAAAAAAAAAQGcYNgIAAAAAAAAAAACd YdgIAAAAAAAAAAAAdIZhIwAAAAAAAAAAANAZho0AAAAAAAAAAABAZxg2AgAAAAAAAAAAAJ1h2AgA AAAAAAAAAAB0hmEjAAAAAAAAAAAA0BmGjQAAAAAAAAAAAEBnGDYCAAAAAAAAAAAAnWHYCAAAAAAA AAAAAHSGYSMAAAAAAAAAAADQGYaNAAAAAAAAAAAAQGcYNgIAAAAAAAAAAACdYdgIAAAAAAAAAAAA dIZhIwAAAAAAAAAAANAZho0AAAAAAAAAAABAZxg2AgAAAAAAAAAAAJ1h2AgAAAAAAAAAAAB0hmEj AAAAAAAAAAAA0BmGjQAAAAAAAAAAAEBnGDYCAAAAAAAAAAAAnWHYCAAAAAAAAAAAAHSGYSMAAAAA AAAAAADQGYaNAAAAAAAAAAAAQGcYNgIAAAAAAAAAAACdYdgIAAAAAAAAAAAAdIZhIwAAAAAAAAAA ANAZho0AAAAAAAAAAABAZxg2AgAAAAAAAAAAAJ1h2AgAAAAAAAAAAAB0hmEjAAAAAAAAAAAA0BmG jQAAAAAAAAAAAEBnGDYCAAAAAAAAAAAAnWHYCAAAAAAAAAAAAHSGYSMAAAAAAAAAAADQGYaNAAAA AAAAAAAAQGcYNgIAAAAAAAAAAACdYdgIAAAAAAAAAAAAdIZhIwAAAAAAAAAAANAZho0AAAAAAAAA AABAZxg2AgAAAAAAAAAAAJ1h2AgAAAAAAAAAAAB0hmEjAAAAAAAAAAAA0BmGjQAAAAAAAAAAAEBn GDYCAAAAAAAAAAAAnWHYCAAAAAAAAAAAAHSGYSMAAAAAAAAAAADQGYaNAAAAAAAAAAAAQGcYNgIA AAAAAAAAAACdYdgIAAAAAAAAAAAAdIZhIwAAAAAAAAAAANAZho0AAAAAAAAAAABAZxg2AgAAAAAA AAAAAJ1h2AgAAAAAAAAAAAB0hmEjAAAAAAAAAAAA0BmGjQAAAAAAAAAAAEBnGDYCAAAAAAAAAAAA nWHYCAAAAAAAAAAAAHSGYSMAAAAAAAAAAADQGYaNAAAAAAAAAAAAQGcYNgIAAAAAAAAAAACdYdgI AAAAAAAAAAAAdIZhIwAAAAAAAAAAANAZC7UDAPbF3Nxc7QTgOgbD0XySI5Yft0hyyPJjx3UehyQ5 MMn25cfG5b++Kcm25e9qe/bu45PLklyTZCnJJUmuTHJFkm8kuTrJpUkuvs7jout8e8Hy4yuLu3Ze tvL/twAAAAAAANB9S0tLtRMA9tmc38SAPjJshPUzGI62JznhOo/jlr89NpMR45FJDk8/T4K+Isl5 Sb6a5CtJPp/kC8uPzy8/zlvctXN3tUIAAAAAAADYBzZBQJ8ZNgK9ZNgIq2swHB2a5FZJTkly6nc8 Dq+Y1gXXJPlskk8k+XSSTy4/FpN8enHXzmvqpQEAAAAAAMANswkC+sywEeglw0bYN4Ph6JAkJclp y4/bL397VM2uHrs6yceTfHT5248s//F/GzwCAAAAAABQk00Q0GeGjUAvGTbCzRsMR8cnaZKcnuRO y4/jazbNkG8l+XCScZIPJPlgkg8t7tp5Rc0oAAAAAAAAZodNENBnho1ALxk2wvUNhqODk9wtyRlJ zlz+dtavkO6aPUk+luSdSd6b5F1JPra4a+eeqlUAAAAAAABMJZsgoM8MG4FeMmxk1g2Go1OSnLP8 ODPJbZL4D6N/vpFrR47/nuSdi7t2Xl43CQAAAAAAgGlgEwT0mWEj0EuGjcyawXB0myTnJjl7+dtj a/awZq5J8p9J/i3JfyR5x+KunZdULQIAAAAAAKCXbIKAPjNsBHrJsJFpNxiOjkxyvyT3TXL/JMfU LaKS3Unek+TNSd6a5D2Lu3ZeUzcJAAAAAACAPrAJAvrMsBHoJcNGps1gOFrI5DTGB2cyaDy9ahBd dWmSXZkMHd+0uGvnFyr3AAAAAAAA0FE2QUCfGTYCvWTYyDQYDEeHJXlgkoctf3tw3SJ66L+SvGn5 8Z7FXTv3VO4BAAAAAACgI2yCgD4zbAR6ybCRvhoMRyck+d4kj0hyjyTzVYOYJl9L8ndJ3pDkzYu7 dl5ZuQcAAAAAAICKbIKAPjNsBHrJsJE+GQxHgySPzmTQeKfKOcyGS5P8fZK/TvIPi7t2XlG5BwAA AAAAgHVmEwT0mWEj0EuGjXTdYDg6Mcn3Jfn+JLevnMNsuzyTq6r/LMk/OskRAAAAAABgNtgEAX1m 2Aj0kmEjXTQYjo7I5FTG78/kmmnomouT/FWS1yf598VdO/fUzQEAAAAAAGCt2AQBfWbYCPSSYSNd MRiONid5WJKnJLl/koW6RbDXvpzkT5P84eKunR+vHQMAAAAAAMDqsgkC+sywEeglw0ZqGwxHpyf5 oSRPSHJY3RrYb+9K8pokf7G4a+eltWMAAAAAAADYfzZBQJ8ZNgK9ZNhIDYPh6KAkT8pk0NhUzoG1 cEUmV1W/enHXzrfXjgEAAAAAAGDf2QQBfWbYCPSSYSPraTAcNUl2Jvn+JNsq58B6+XCSUZI/dYoj AAAAAABA/9gEAX1m2Aj0kmEja20wHG1J8vhMBo1nVM6Bmr6Z5PVJXrW4a+eHascAAAAAAACwd2yC gD4zbAR6ybCRtTIYjm6R5NlJnpXk8Mo50DX/nuQVSf52cdfOPZVbAAAAAAAAuAk2QUCfGTYCvWTY yGobDEd3TvK8JI9LsrFuDXTeZ5L87ySvcU01AAAAAABAN9kEAX1m2Aj0kmEjq2EwHM0leXCSn0py duUc6KNvJHl1kpcv7tr5pdoxAAAAAAAAXMsmCOgzw0aglwwb2R+D4WghyeOT/GSS21fOgWlwdZLX Jvn1xV07P147BgAAAAAAAMNGoN8MG4FeMmxkXwyGo61JnpbkBUlOqJwD02gpyd8kecnirp3vqdwC AAAAAAAw02yCgD4zbAR6ybCRlVgeND4zkxMaj66cA7Pin5P84uKune+uHQIAAAAAADCLbIKAPjNs BHrJsJG9MRiODkjynCQ/nuTwyjkwqwwcAQAAAAAAKrAJAvrMsBHoJcNGbsryCY0/muSFSQ6rnANM GDgCAAAAAACsI5sgoM8MG4FeMmzkhgyGo41JnprkRXHlNHTV3yb5ucVdO9vaIQAAAAAAANPMJgjo M8NGoJcMG7muwXA0n+TxSX4pySmVc4Cbt5TkdZmc4Pip2jEAAAAAAADTyCYI6DPDRqCXDBv5tsFw 9MAkv5rkjrVbgBW7OsnvZTJwvKB2DAAAAAAAwDSxCQL6zLAR6CXDRgbDUUny60keULsF2G+XJvnl JL+5uGvnt2rHAAAAAAAATAObIKDPDBuBXjJsnF2D4ejoTK6cfmqS+co5wOr6XJKfTvLni7t2+iAV AAAAAABgP9gEAX1m2Aj0kmHj7BkMR5uT/Hgmo6cDKucAa+u9SX50cdfO99QOAQAAAAAA6CubIKDP DBuBXjJsnC2D4eghSX4zySm1W4B1s5Tkj5L81OKunV+t3AIAAAAAANA7NkFAnxk2Ar1k2DgbBsPR KZkMGh9SuwWo5pIkv5DkVYu7dl5TOwYAAAAAAKAvbIKAPjNsBHrJsHG6DYajrUl+LskLkmyqnAN0 w0eS7FzctfNttUMAAAAAAAD6wCYI6DPDRqCXDBun12A4un+SUZJb1m4BOukPkvzE4q6dF9YOAQAA AAAA6DKbIKDPDBuBXjJsnD6D4eioJC9P8n21W4DOuyDJ8xd37fzT2iEAAAAAAABdZRME9JlhI9BL ho3TYzAczSV5epKXJNlRtwbomX9J8qzFXTs/WTsEAAAAAACga2yCgD4zbAR6ybBxOgyGo5OTvCbJ uZVTgP66IsnPJvnfi7t27q4dAwAAAAAA0BU2QUCfGTYCvWTY2G+D4Wg+yXOS/HKS7ZVzgOnwniQ/ uLhr58drhwAAAAAAAHSBTRDQZ4aNQC8ZNvbXYDgaZHJK49m1W4Cpc2WSX0zyG4u7dl5TuQUAAAAA AKAqmyCgzwwbgV4ybOyfwXA0l8kpjS9JsrVyDjDd3pfkiYu7dv537RAAAAAAAIBabIKAPjNsBHrJ sLFfBsPRsUn+KMl9K6cAs+OKJC9IMlrctdMHvAAAAAAAwMyxCQL6zLAR6CXDxv4YDEePTzJKsqNy CjCb/jnJUxd37fxS7RAAAAAAAID1ZBME9JlhI9BLho3dNxiODk7yO0keX7sFmHkXJnnm4q6df1U7 BAAAAAAAYL3YBAF9ZtgI9JJhY7cNhqMzk7w+yUmVUwCu6/eSPHdx184raocAAAAAAACsNZsgoM8M G4FeMmzspsFwNJ/kJ5P8UpKFyjkAN+SjSR6/uGtnWzsEAAAAAABgLdkEAX1m2Aj0kmFj9wyGo1sk eW2S+9RuAbgZ30ry/MVdO0e1QwAAAAAAANaKTRDQZ4aNQC8ZNnbLYDi6T5I/S3JE7RaAFfjrJE9Z 3LXzG7VDAAAAAAAAVptNENBnho1ALxk2dsNgOJpL8nNJfjHJfN0agH2ymOTRrqYGAAAAAACmjU0Q 0GeGjUAvGTbWNxiODk3yuiQPrN0CsJ8uT/LsxV07/7h2CAAAAAAAwGqxCQL6zLAR6CXDxroGw9EZ Sf4yyQm1WwBW0e8l+ZHFXTuvrB0CAAAAAACwv2yCgD4zbAR6ybCxnsFw9INJfjfJpsopAGvhvUke tbhr55dqhwAAAAAAAOwPmyCgzwwbgV4ybFx/g+FoIcnLkzyndgvAGjs/k3HjO2uHAAAAAAAA7Cub IKDP5msHANB9g+HoiCRviVEjMBuOSvJvg+HoGbVDAAAAAAAAAGaRExuBXnJi4/oZDEenJ3ljkhMq pwDU8DtJfnRx186ra4cAAAAAAACshE0Q0GeGjUAvGTauj8Fw9PAkr0+yvXYLQEW7kjxmcdfOi2qH AAAAAAAA7C2bIKDPXEUNwA0aDEcvSPKGGDUCDJO8azAcnVo7BAAAAAAAAGAWOLER6CUnNq6dwXC0 MclvJ3l67RaAjrkwySMXd+38j9ohAAAAAAAAN8cmCOgzJzYC8P8NhqODk/xTjBoBbsihSd46GI6e VDsEAAAAAAAAYJoZNgKQJBkMR8cleVsmV64CcMM2JvnjwXD0s7VDAAAAAAAAAKaVq6iBXnIV9eoa DEe3y+SkxuNqtwD0yO8kec7irp27a4cAAAAAAAB8J5sgoM8MG4FeMmxcPYPh6F5J3pjk4NotAD30 xiRPWNy18/LaIQAAAAAAANdlEwT0mauoAWbYYDh6bJK3xKgRYF99T5K3Doajw2qHAAAAAAAAAEwL w0aAGTUYjp6e5M+SbKzdAtBzZyb5t8FwdFztEAAAAAAAAIBpYNgIMIMGw9FPJHl1PA8ArJbbJ/n3 wXB0au0QAAAAAAAAgL6bW1paqt0AsGJzc3O1E3ppMBzNJfnlJD9VuwVgSn0lyQMWd+1sa4cAAAAA AACzzSYI6DPDRqCXDBtXbjAcbUjyyiTPqt0CMOUuTvLAxV0731M7BAAAAAAAmF02QUCfGTYCvWTY uDLLo8Y/SfKE2i0AM+LSJA9Z3LXz7bVDAAAAAACA2WQTBPTZfO0AANaWUSNAFQclefNgOBrWDgEA AAAAAADoG8NGgCk2GI42JXldjBoBatia5E3GjQAAAAAAAAArY9gIMKWWR41/leRxtVsAZti3x40P rR0CAAAAAAAA0BdzS0tLtRsAVmxubq52QqddZ9T4sNotACRJrk7y0MVdO99cOwQAAAAAAJgNNkFA nzmxEWDKDIajDUn+JEaNAF2yMcnfuJYaAAAAAAAA4OYZNgJMkeuMGl0/DdA9376W2rgRAAAAAAAA 4CYYNgJMicFwNJfkj5I8oXIKADdua5I3DIaju9UOAQAAAAAAAOgqw0aAKbA8anxVkh+o3QLAzToo yZsHw9Gda4cAAAAAAAAAdJFhI8B0+F9JnlU7AoC9dlCSfxoMR7euHQIAAAAAAADQNXNLS0u1GwBW bG5urnZCZwyGoxck+fXaHQDsky8lufvirp1frB0CAACw1kppFpIcluTA5cfBy48Dkyws/22bk2y9 zj+2lOSS6/z5N77jcWmSr7ft+LI1jQeg00pp5nPtc8xBufb55aAkm5b/to1Jtn/HP/rNJNcs//G3 lv/8G5k893xj+c8vaNvxnrXsB1grNkFAnxk2Ar1k2DgxGI6emuT3a3cAsF8+keTsxV07L6gdAgAA sK+WR4vHJzk5yS2XHycmOTLJMUmOWH6slSuSfCXJV5Oct/zHn15+fCbJZ9p2fPEa/vgArJFSmg1J js3kueXk5cdJSY5KcvTyt0dk7W4rXEpyQZKvZfIcc36Szyb5/PK3n83keebKNfrxAfaZTRDQZ4aN QC8ZNiaD4egxSf5P1u4TdQDWzzjJvRd37bzkZv9OAACAykppTklSlh+3X37cKteeuthVX0vy4STt 8uMjST7ktEeA7iilOTHJHTN5brnd8re3zeS0xS7bk8mQ/qPXeXwwyUfbdnzNTfxzAGvKJgjoM8NG oJdmfdg4GI7OSfKWTK7mAWA6vDXJQxZ37byqdggwW0ppjklyryTH5buv5GLfXHydP/7m8uOyXHud 2SVJzjeiYG+U0uxIck6SQSbX6LE+buzq20uv8+3XM7mW8Or1z4P1U0pzQJJ7JDkjyZlJ7pbJVZ/T YncmY8d3f/vRtuOP101iX5TSbEtydiYDqEMq5+yrS5MsJnmbE0aZBaU02zN5bjkjk+eXu2dy0u80 +VaSDyT5zyTvSfKOth1/tmoRM235+fKMJKdlcmV7H15r/GYmb1AZJ/mvth0buayATRDQZ4aNQC/N 8rBxMBydluQdSXZUTgFg9f1pkict7trpg3RgzZXSHJLkt5J8X5wCXsu3MrnO7PxMrsv83PLj29eZ fbJtxxdWq6Oq5StdfynJc5Nsq5zDTbtg+fHlJF/MtdfefjrJp9p2fH7FNlixUppNmQxL7pPkvpkM TTZUjVp/52Xy5rN/SfLWth1/sXIPN6GUZi7JjyZ5Ufo7aPxOlyV5RZIXte14d+UWWDWlNBszeV65 b5JhJs83XT+JcS18Lsm/LT88z7Ault+s8uIkT01yQOWc/fGZJD/ftuPX1Q7pC5sgoM8MG4FemtVh 42A4OjbJu5IcX7sFgDXzq4u7dv507QhgupXSbEny9iR3rt3CzbogkyvMPr78+ECScduOv1G1ijVX SvMnSZ5Yu4NVcVGuvfb2w0k+lOSDbTu+omoVXMfy6bAPSfLIJA9Iv1/sXgsfTfKGJH+T5D+dEtQt pTT/I8kv1O5YI3/YtuMfqh0B+6OU5uBMnmO+J8mDkhxYt6iTPpjk75K8Kcn723a8p24O02Z5VPzv mZyQOi1+um3Hv1o7og9sgoA+M2wEemkWh42D4ejgTD7puGPtFgDW3HMWd+387doRwPQqpfmRJP+7 dgf7bCnJJzK5yuy9Sd6W5ENO85kepTRnZ/Lvlel1TSbXqL03yTuTvL1tx5+vm8SsWR6aPHb5cW6S hapB/fHFTAaOf9q24/dUbpl5pTQnJvlUpvtU0TPbdvzu2hGwEsvPMY9J8rgk947nmJU4L8lfJXl9 kncb07MaSmmelWRUu2OVXZnkVj6Punk2QUCfGTYCvTRrw8bBcLSQ5B+S3K92CwDrYk+SRyzu2vl3 tUOA6VRK8+5Mrv9ielya5B1J/iPJmzM51dEXfXqqlGaU5Fm1O1h3i5lcffvWJP/atuOLKvcwhZav ub9/kicneXiSLXWLem8xyWuTvLZtx5+t3DKTSml+IslLanessVe27fhHakfAzVl+jnlAkifFc8xq +VySP8/k9Nb/rh1DP5XSzCX5bJITKqeshZe27fgFtSO6ziYI6DPDRqCXZnDY6EUtgNlzWZKzF3ft /GDtEGD6lNJclWRj7Q7W1PlJ/jHJ3yd5S9uOL6ncwwqU0rw3yV1rd1DVnkxubXhDkjc6hYT9VUpz dJJnJnlGkmMq50yrf07y20n+3hWi66eU5s8zORFumr2jbcdn146AG1NKc4tMnl88x6ytf0/y6iR/ 3bbjK2vH0B+lNHdP8q7aHWvkC0lO9MbOm2YTBPSZYSPQS7M0bBwMR89N8oraHQBU8YUkZyzu2nle 7RBgepTSHJjJ6X7MjqsyOcXxL5L8rZFj95XSfDLJKbU76JQPZHJaz+vadvzl2jH0RynN3ZI8N5Pr QL2pYX18Nsmrkvxe244vrpsy/Upp3pzpv+Xm4207vm3tCPhOpTRnZvIc8+i4ano9fT3J7yT5rbYd n187hu4rpfm5JP+zdscaOq1txx+rHdFlNkFAnxk2Ar00K8PGwXD0kCR/m2S+dgsA1bwvybmLu3Ze XjsEmA6lNDuSuN50dl2VyUmOr0nyD207vqZyDzeglOazSU6s3UEn7cnkquo/SfKGth37GJEbVEoz TPLzSc6tnDLLLk0ySvKyth1/tXbMtCql+bck96rdscY+17bjk2pHwLeV0jwgyU9n+v/b67orM/mY 8KWuqeamlNL8Q5IH1e5YQ09t2/Frakd0mU0Q0GeGMgAdNRiOSpI/i9+rAWbdXZP80WA4mo1VPwBr bVOS70nyxiRfKKX51VKaQeUmYO/NJ7l/kj9N8qVSmpeV0jjdk/+vlOaBpTTvTvIvMWqs7aAkP5nk c6U0v1lK43pWoNdKaR5eSvO+JP8Uo8Yu2Jzk6Uk+Vkrz56U0t64dRPeU0swnuXvtjjV2j9oBAKwd YxmADhoMR4dl8kLjgbVbAOiE703yc7UjAJg6R2cyuPhEKc0/lNLcv5TGkB76Y0eSH0uyuPzf8AMq 91BRKc1dl0+u+8ckd6ucw/VtSfKjST5ZSvPiUpqDawcBrEQpzVmlNG/P5DWLu9Tu4bvMJXlcko+U 0vxRKY2T37mu2yU5pHbEGjundgAAa8ewEaBjBsPRhiR/keTk2i0AdMr/GAxHD6sdAcDUelCSf07y 4VKap5fSbKodBOy1uUz+G/6nUpr/LKV51PLJLMyAUppbltL8RZL3xulZXbc1yc8m+VQpzXNLaTbW DgK4KaU0tyqleUOStyc5q3YPN2tDkidn8qaXXy+lOah2EJ0wC6O/W5XSHFU7AoC14QtcAN3za0mG tSMA6Jy5JK8bDEe3qR0CwFQ7LcmrMzlV6lkGjtA7d0ry15mMlJ9g4Di9Smk2l9K8KMlHMznhnf44 LMkrknyolObcqiUAN6CUZlspzf9K0iZ5ROUcVm5jkhdkMnB8io8HZ94sDBuT5OzaAQCsDR/IAHTI YDj6gSTPr90BQGcdmORvBsORd1wDsNaOTzLKZOD4zFKahdpBwIrcNsnrkvxnKc39a8ewukpp7pfk w0l+McnmujXsh9sm+ddSmj91yhDQFaU0D0/ykSQ/k8SbnPrtyCSvSfKuUprb146hmlkZNs7K/0+A mWPYCNARg+HoTkl+r3YHAJ136ySvHwxHc7VDAJgJxyf5nUxOf3tY7RhgxU5P8s+lNP9SStPUjmH/ lNLsKKX54yRvTnJq7R5Wzfcn+e9SmifWDgFmVynNYaU0f57kjUlOqpzD6jojybiU5hedyD9bSmlO SnJs7Y514sRGgCll2AjQAYPh6JAkf5VkS+0WAHrhIUl+unYEADPl1kn+tpTmX0tpTq8dA6zYMMn7 S2l+u5TmkNoxrFwpzX2T/FeSJ9VuYU0cnORPSmn+ppTmiNoxwGxZfgPTR5I8rnYLa2YhyYuSfKCU 5k61Y1g3s3SKYVNKc0DtCABW39zS0lLtBoAVm5ubnkOqlk/c+pskD6+c0llz2zZl4fjDamfAPlva vSe5evfkj6+6OtmTLF1x1eSx/NdhH+xJct/FXTv/tXYI0C+lNDuSXFS7g17bneQ3k7yobcffrB0z jUppPpvkxNodTK2vJnlhkte27dgXhzuulGZzkpcm+eHaLaybryV5etuO/6Z2SB+U0vxbknvV7lhj n2vb8Um1I5g+pTTbk/zvJD9Uu4V1dXUmb5h+mY8Fp1spzauTPL12xzp6YNuO/7l2RBfZBAF9tlA7 AIC8MEaNN2nDEQdl22PPqJ0Ba+OaPdlzxVVZ+uaV2XPpFdlzyeVZuuiy7Ln48uy5+PLs/to3kz17 alfSTfNJ/mwwHN1pcdfOL9eOAWCmbEjy/CTfW0rzo4YX0DtHJvnjJD9QSvO0th1/vnYQN6yU5pZJ /jKJk5Vmy+FJ3lBK8/IkP9m246trBwHTp5TmtEyeY06r3cK625jkN5Lcr5TmyW07Pr92EGtmlk5s TCb/fw0bAaaMExuBXpqWExsHw9G9kvxLJi8MciMWTjw82590Vu0MqGPPUnZf8I3s+eql2f3VS7P7 vEuy+4sXZumqa2qX0R1vSzJc3LXTLwpgrzixkTXw+iQ/3Lbji2uHTAsnNrKOvpHkx5P8vhN7uqWU 5hFJ/jDJjrolVPbuJI8zQL5xTmyElSul+YEkv5Nke+0Wqjs/yaPbdvyO2iGsrlKaIzI5qX2W/Hvb js+tHdFFNkFAn83XDgCYVYPh6MgkfxajRuCmzM9lw1EHZWM5Llvuc1q2f/+ZOegnHpwDnn5utj7o Dtl4++Myd8Dm2pXUdU6SF9eOAGCmPSHJh0tp7lc7BFixA5O8Osk/ltIcWTuGpJRmrpTmfyV5Q4wa Se6eZFxKc+/aIUD/ldJsKKX530leG6NGJo5K8q+lNM+oHcKqm8XTQs4opdlUOwKA1WXYCFDBYDia S/InSW5RuwXoobm5bDj64Gy6y8nZ9sg756Afe2AOePq52XLv22bhhMOS+ek41ZYV+cnBcHT/2hEA zLRjk7y5lOblXkiAXnpAkg8aT9VVSrMtk2tBf6Z2C51yaJJ/NjoB9kcpzcFJ3pTkR2q30Dkbk/xu Kc3v+lxuqszaNdRJsjXJnWtHALC6DBsB6nh+Ji8aAKyKDUcfnM1n3yrbn3x2DvrxB2Xrw5osnHJk Mu/DvRnyJ8unAQNATc9L8u+lNMfXDgFW7BZJ3lpK84ulNG6XWGelNLdI8h9JHl27hU769ujkpf77 BFaqlObkTK62f2DtFjrtGUn+rpTmwNohrIpZHDYmyT1rBwCwurzSDbDOBsPRnZP8Su0OYHrNbdmY TaefkO1PODMH/fgDs/Whp2fhxMNrZ7H2jspk3OjITgBq+/a1mV44hf6ZT/KiJH9fSrOjcsvMKKU5 Ncl744QZbt7zk/yVE7WAvVVKUzIZNd6mdgu9cP8k/1ZK483TPVZKc0CSO9XuqGRWB50AU8uwEWAd DYajA5L8eSbvsgZYc3NbNmZTc2K2P+msHPjs+2Tzmadmbvvm2lmsnQck+fHaEQCQ5LBMhlEvqB0C 7JMHJHl3Kc2ta4dMu+XByTuTHFe7hd54RJJ/LKXZXjsE6LZSmnskeXsSIzVW4k5J3rn8xgv66e5J ZvWE53uU0tjAAEwRv6kDrK9XJvHJIFDF/GEHZMt9b5eDnnf/bHv0XbLh2ENqJ7E2fnkwHDW1IwAg k687/XopzatLaby5C/rn1kneU0rzgNoh06qU5u6ZDE6OqN1C7wyT7CqlOax2CNBNy8/fb01yUO0W eumUTE5u9HpWP51dO6CiQ5KcVjsCgNVj2AiwTgbD0aOSPLl2B0Dm57PxtGNzwA/dMwf84DnZeJtb JHNuL54iG5O8bjAcbakdAgDLnp7kn0ppDq4dAqzYwZmcvvqU2iHTppTmbkl2xeCEfXdGJqMT71oE rqeUZpjk75Jsrd1Crx0b48a+mvXrmGf9/z/AVDFsBFgHg+Ho6CS/W7sD4DttOP7QbPveM3Lgs++T TXc8IZk3cJwSt03yK7UjAOA6hkn+tZTGqWTQPxuSvKaU5qdrh0yLUpomyZtjcML+u328eQC4jlKa c5O8KZM3vsL++va48aTaIeydUpqFJGfW7qjsnrUDAFg9ho0A6+P3kxxeOwLgxswfuj1bH97kwGcN s/F2xzrBcTo8bzAcDWtHAMB1NEn+o5TmuNohwD755VKa3yyl8cnCfiilKZmMGp3UyGo5I8mbSmm2 1Q4B6lo+DfiNMZxndR2byYj+sNoh7JW7xO8BTmwEmCKGjQBrbDAcPSPJQ2p3AOyN+cMOyLZH3SUH PuveWRgcVTuH/fdHg+FoR+0IALiO2yR5WynNybVDgH3yo0leZdy4b0ppjk/yj/HmV1bf2UnesHxK EzCDSmluleQfYjjP2rh1kr8tpZn1wVwfnF07oAOOdcoowPQwbARYQ4Ph6OQkL6vdAbBS84cfmO2P v3u2f/+ZmT/iwNo57Lvjk7yidgQAfIeTkrzFyY3QW8+KceOKldIcmOTvMjn1CNbC/ZP8du0IYP0t n6T3piSH1m5hqt0jyZ+W0tgXdJth44RTGwGmhA88ANbIYDiay+QK6u21WwD21cItj8yBz7x3tj6w ZG7Lxto57JsnD4YjJwcD0DWnZDJuPKJ2CLBPjBtXoJRmQ5I/S3LH2i1MvWeU0rywdgSwfkppNiX5 mySDyinMhkcleVHtCG7Y8sfmho0Tfh4ApoRhI8DaeVqSYe0IgP02N5dNd71lDnz2fbLxNIeL9NRo MBy5igiArrlNkreW0niOgn56VpKX147oid9I4s1GrJeXlNI8onYEsG5eHQMe1tcvlNI8rHYEN+i2 SQ6rHdER96wdAMDqMGwEWAOD4eiEJC+t3QGwmua2b862R98l2x53t8wfuKV2DitzfDwvAdBNd0jy F8unmQH989xSmp+qHdFlpTSPSfK82h3MlLkkf1xKc0rtEGBtldI8NcmTa3cwk15bSnNq7Qi+izHf tW7jhgiA6WDYCLA2RkkOrB0BsBY23uroHPDs+2TT6SfUTmFlnjYYju5TOwIAbsADkvxW7Qhgn/1K Kc1Takd00fKw7A9qdzCTDkry16U03pUIU6qU5vQkr6zdwcw6OJM3qG2sHcL1OL31+s6qHQDA/jNs BFhlg+HoSUkeXLsDYC3NbVrI1oc12faYu2Zu66baOey93x8MR9tqRwDADdhZSvMjtSOAffbqUpp7 147okuVB2V9nMjCDGu4YbxyAqVRKc2CSv0xivExNTZL/UTuC6zFsvL5zagcAsP8MGwFW0WA4Oiyu +gRmyMbbHpMDnnnvLJx0eO0U9s5JSX6xcgMA3JiXltKcWTsC2CcLSf6qlObk2iEd8j8zGZZBTU8r pXlk7Qhg1b0siWuA6YKfLKVxKl4HlNIcn+TE2h0dY+gJMAUMGwFW168nse4BZsr8gVuy/YlnZfM9 b107hb3z/MFwVGpHAMAN2Jjk/5TSHFY7BNgnhyZ5YynNAbVDaiulOTvJ82t3wLJXl9IcUTsCWB2l NA9I8rTaHbBsPskfl9JsrR2C0wlvwJ1LabbXjgBg/xg2AqySwXB0TpKn1O4AqGXLvW6T7Y+/e+a2 bKydwk3bkOR3B8ORzwUA6KLjk7y2lGaudgiwT0qS368dUVMpzbYkfxhfe6c7Dk/yqtoRwP4rpdmR 5DW1O+A7nJLk52pHkHvWDuigDUncCgHQc764ArAKBsPRpiS/W7sDoLaFwVE54Gn3yoajDqqdwk07 M8kzakcAwI14UJxCA332uFKap9eOqOh/xvWgdM9jSmm+t3YEsN9+LckxtSPgBryglOY2tSNmnGuX b5ifF4CeM2wEWB0vTHLb2hEAXTB/yPZsf8o9szA4qnYKN+1XB8ORf0kAdNXLSmlOrh0B7LNXlNLM 3NdJSmlOS/Lc2h1wI17hqnjor1Kau8Sbf+iuTUl+u3bErCqlOTTJ7Wp3dJQrugF6zrARYD8NhqMT kvxs7Q6ALpnbuCHbH3e3bLqLPUKHHZzkV2tHAMCNOCDJa1xJDb21Lcn/KaXZXDtknf1WJlfeQRcd E1eFQi+V0sxnMhrzsTFdNiyl+Z7aETPqrNoBHXZmKc1C7QgA9p1hI8D+e2mSrbUjADpnbi5bH3SH bLnf7ZI5X3ftqB8cDEd3rx0BADfi3CRPrB0B7LOS5GdqR6yXUprHJBnW7oCb8fxSmlvXjgBW7MlJ zqgdAXvhl5eHuKwvpxLeuK1J7lw7AoB95wMLgP0wGI6GSR5TuwOgyzbf/dRse8SdjBu765WD4cjn BQB01UtKaQ6qHQHss58ppbl97Yi1VkqzKcmv1+6AvbAxya/VjgD2XinN1iQvrt0Be+m0JE+qHTGD 7lk7oOMMPwF6zAuYAPtoMBwtZHLFEAA3Y+Ptj8u2x56RbPDhZwfdOclTa0cAwI04OsnP144A9tlC JtfKT/v1zD+U5KTaEbCXHl5K4+R+6I9nZXKVPPTFLy2/6YN1UEqzLcmdand03Nm1AwDYd15ZBth3 P5LJu88A2Asbb3V0tj/ubpnbOO2vafbSLw+Go0NqRwDAjXhuKc2ptSOAfXbXJM+oHbFWlk/S+tna HbBCTn+DHiilOSCeY+if45M8oXbEDLlbJicyc+POLqVxnRRATxk2AuyDwXB0WJJfqN0B0DcLpxyZ bY+/u3Fj9xye5OdqRwDAjdgYz1PQd79USrOjdsQaeWaS42pHwArdp5Tm3NoRwM16TpLDakfAPnih Idm6cRrhzTssyW1rRwCwbwwbAfbNLyTZUTsCoI8WTjo82x5zV9dSd8+PDIajU2pHAMCN+IFSmlvV jgD22eGZwjeILl+z+MLaHbCPvGkAOqyUZnOSH6vdAfvotCQPrh0xI86pHdATfp4AesqryQArNBiO bpVkZ+0OgD5bOPWobHvUXZI5b9ztkI1JXlI7AgBuxIYk/6N2BLBfnjOF18o/NskxtSNgH92nlOaO tSOAG/XEJEfWjoD98ILaAdOulGYhyT1qd/SEYSNATxk2AqzcSzIZfwCwHzbe5hbZ9j1N7Qyu79GD 4cj1JQB01feW0pxQOwLYZ9N4rfzzawfAfvrx2gHAd1u+wvd5tTtgP507hW9q6ZrTk2yvHdETvuYN 0FOGjQArMBiOzknyiNodANNiYzk+W4an1c7g+l46GI4cpQlAF21I8pzaEcB++YFpeYG7lObcJN6p Rd89vpTGqaPQPfdLcrvaEbAKnlY7YMo5hXDvnVhKc3ztCABWzrARYC8tjzx+o3YHwLTZfNYgm5oT a2dwrTOSPKZ2BADciKeX0jiRAvprQ6bn1MZn1Q6AVbAxRifQRU+vHQCr5AdLadyAtnacQrgyhqAA PbRQOwCgR74nk7EHAKts64PvmD2XXJFrPv3V2ilMvHgwHL1hcdfOa2qHAMB32JHk+5O8unIHsO9+ oJTm59p2/MXaIfuqlOaQJI+s3TFFrkryxSTnJflGkm8luXj5r29KsmX5sSPJQUmOTXJkhc5p9YOl NP+zbcdLtUOApJTm8CQPr90xRa5O8pUkX87kOebyXPtcsyGTgfeBufZ55qQkR1XonFZHJXlAkjfV DplShnorc88kr68dAcDKGDYC7IXBcDSf5JdrdwBMrfm5bHvMXfPNP/j37Pn6N2vXkNwqyZOT/EHt EIBV9s0kX1/jH+Pb44utmYwxWH0/GMNG6LMNSZ6Z5Odrh+yHJ8Tv8fvq4iT/keS9ST6Q5GNJPt+2 4z0r+U5KabZm8nnLaUnulOTMTN6Q7FSolTs5yb2T7KodAiTxHLM/Lkvy9iTvSfL+JB9N8rm2Ha/o jbulNJuTHJ/k1EyeW+6W5K5JjljV2tnxuBg2rrpSmtvEr8mVcsIlQA8ZNgLsnScmuW3tCIBpNrd5 Idu/94x88zX/kaWrHBTYAS8aDEevW9y181u1QwD202VJXpbktW07XlzPH7iUZluS45Ick+QWmQww SpI7ZPIi2dx69kyRM0tpBuv97xNYVc8spXlx246vrB2yj55SO6BnPpnkr5O8Icn723a8e3+/w7Yd X5HkQ8uPP0v+//PuMJNbVx6V5ND9/XFmyFNi2Ahd4TlmZT6X5K+SvDHJu1Y6Yrwhyx+ffHL58U/f /uulNLdO8qAkj05yVnw+t7ceXkqzuccf93WVkd7KnVZKc2jbji+sHQLA3jNsBLgZg+FoU5JfrN0B MAvmjzgwWx/W5PK/fl/tFCbvTN+Z5OW1QwD2w0VJzmnb8Udq/OBtO748ySeWH9dTSrM9yT2S3D/J fZPcMV4YW4knJvmF2hGsmk8k+f0k70pyfiZXBta2I5OTV7dkcoXe8UlOSXKbJE0m1+Gy745I8vgk f1w7ZKVKaW6V5M61O3rgmkyGJq9K8vb1uOZ4+Xn3TUneVErzw0kemuSHMxk7ctMeWUqzdXkwClRS SnNKktNrd/TA7kzG8qMk/7bSU3/3VduO/zvJfyd5RSnNsUl+KMnTM/k4kRt3UCbPxf9YO2TKuIZ6 5eYyGSX/Xe0QAPaeYSPAzXtmkpNqRwDMio2nHZPNXzo1V777k7VTSH52MBz93uKune4HB/rqObVG jTenbceXJXnL8iOlNMdkcu3ckzI51ZGb9tgYNk6LlyX5idU4wW29lNLMZ3IC670zGSffL8n2qlH9 9NT0cNiYyUmA3Lirk7wmyS+37fjztSLadnxVkv+b5P+W0jRJXpTJSY7csO1JHpDkbyp3wKx7dO2A jrsmyR8k+ZW2HX+uZkjbjr+U5H+W0vxKJlct/2zc+nVTHhXDxtVm2LhvzolhI0CvzNcOAOiy5dMa f6J2B8Cs2XKf07LhmENqZ5AcluQ5tSMA9tFXk/xF7Yi91bbjL7ft+DfadnyHJHfKZBRyVeWsLrt1 Kc2gdgT77e+SvKBPo8YkadvxnrYdf7xtx6O2HT8yk9MHH5vkH5Ksy4lBU+KcUpqTakfsg0fUDuiw v09yu7YdP6vmqPE7te143LbjRyQ5M4nrAW6cQRXUZzx/4/4pye2Xn2Oqjhqvq23H17Tt+HVJbp/J CY7nVU7qqgfUDpgmy2+MPLl2R0/ds3YAACtj2Ahw034oyXG1IwBmzvxctj3yzpnb5IDxDnjBYDg6 oHYEwD54Z9uOr6kdsS+WBxhPzeSFit/N5GQSvtvDawew3168HtfTrrW2HV/RtuO/bNvxQ5KcmuSV Sb5VOasvvr92wEosXzt5t9odHfS1JI9t2/FD23a8WDvmxrTt+N1J7p7kx5K4cvm7PbSUZmPtCJhV nmNu1NeTfH/bjh+0fBV0Jy2/8eUPk9w6yatq93TQ8aU0t6odMUWM8/bdnUppttWOAGDvGTYC3Ijl 0xp/pnYHwKyaP3R7ttz/9rUzcGoj0F9frh2wv5ZPcXxWJldTv6V2Twc9rHYA++XCTOHJaW07/kzb jn8kyS2TjOIEx5vzxNoBK/TQ2gEd9B9J7ti247+sHbI3locnr8jkdOQPV87pmh0xlICa7l87oIP+ I8kd2nb8+tohe6ttx5e27fiHk9wvyfm1ezrGr/HVc3btgB7bmOSM2hEA7D3DRoAb90NJjq8dATDL NjUnZuNtj6mdgVMbgX66unbAalm+8vb+SZ6S5NLaPR1yj1KarbUj2GefmobTGm9M246/0rbjZ2cy nnpP7Z4Ou3Upza1rR6zA/WoHdMyrkgzbdty7NxO07fjjmZyM9n9rt3TMfWoHwAzz39/1jdLT55gk advxW5OcnuQdlVO65L61A6bIObUDes7PH0CPGDYC3ACnNQJ0x9YH3SFzWzfVzph1hyV5Zu0IgFnX tuM/StIkeX/llK7YGNf19dnltQPWQ9uOP5TkrCQ/FdfK35henIJYSjOf5NzaHR3yE207/uG2He+u HbKv2nZ8eZLHJHlF5ZQuMTqBevz3d60XtO342X1+jkmSth2fl8lg9S9qt3TE3WsHTINSmh2Z3OrA vjNsBOgRw0aAG/akOK0RoBPmtm/OlvvdrnYGk1Mbt9SOAJh1bTv+dCZfhH9d7ZaOcGUmnde2491t O35JJr9ev1S7p4P6cq38HTJ5ww/Js9t2/Ou1I1ZD246X2nb8Y0leUrulI+68PJgA1lEpze2THFW7 oyOe3bbjl9aOWC1tO74yyfcl+Z3aLR1wVCnNibUjpsA9kszVjui5e5TSLNSOAGDvGDYCfIfBcDSf 5IW1OwC41qY7npCFk4+onTHrjk7y5NoRACRtO/5WkicmmZoX/PaDkxbojbYdvyvJXZP8Z+2Wjjm7 lObg2hF7wRWhEy9s2/GodsRqa9vxTyX5zdodHTCf5F61I2AGnV07oCN+bEqfY/YkeXaSP6jd0gFO 3N9/3ty3/7ZnclU8AD1g2Ajw3R6Z5Fa1IwC4vq0PuWPmFjbUzph1L1x+AwAAlS2fMPWCOGHqTrUD YCXadvyVTEZD/1K7pUM2pB+DDi/EJ69s2/Fv1I5YQz+W5P/WjuiAM2sHwAy6a+2ADvjNth2/onbE Wmnb8VKSZyZ5U+2Wys6oHTAF+vBxcx/4eQToCS9KAny3n6gdAMB3mz9kezadeWrtjFl3SpLH1I4A 4FrLJ0z9Vu2Oig4tpTmudgSsRNuOL0vy4CT/WLulQ/pw+updagdU9q9Jnlc7Yi0tj06emOTDtVsq m/Vf61DDrI/n35rkx2tHrLW2He/O5FrqWX6eOb12QJ+V0myJIfRq6cPnHwDEsBHgegbD0b3jHWMA nbX5rEHmD9xSO2PW/WTtAAC+y48l+fvaERXdoXYArFTbjq/K5A0j/1G7pSM6/cJiKc0RSU6u3VHR V5M8YXmQMdXadnx5ku9NclntloruWkozVzsCZkUpzfYkt63dUdF5Sb5/Fp5jkqRtx99M8tgkl9du qeQ2tQN67owkm2pHTIlOf/4BwLUMGwGuz2mNAB02t3FDtgxPq50x6+40GI7uVzsCgGstvwj4A0k+ U7ulEsNGeml5QPXwJB+p3dIBdy2l2Vw74ibM+gl2z2zb8Xm1I9ZL244/ntl+Q9dBSW5dOwJmyJ0y 26/XPq1tx1+tHbGe2nb8sczua1HHltIcVDuix1yfvHqOKKUxtAXogVn+QBngegbD0WlJHli7A4Cb tvEOx2fDMYfUzph1z6sdAMD1te344kyuz9xTOaWGU2sHwL5q2/ElSR6a5MLaLZVtTNLldzCdXjug ov/TtuO/qR1RwauSvK12REWn1w6AGTLLpzX+WduOZ/Xk+Vl+npnlX/P76561A6aMoShADxg2Alzr ubUDANg7W+7b5dc8Z8KDBsPRrWpHAHB9bTt+R5Lfrt1RwUm1A2B/tO34s0kel2Spckptd6wdcBNm 9TSXy5P8eO2IGtp2vJTkRzObbxhIZvfXPNQwqyOvy5K8sHZELTP+PONU4H1QSrMhyZm1O6aM66gB esCwESDJYDg6NJPTTQDogYUTD8/CiYfXzphlc5l88RWA7vn5JF+vHbHOTq4dAPurbcdvTfIrtTsq M2zsnt9o2/GXakfU0rbjDyb5k9odlczq0Apq8Bwzo5afZ15bu6OC42sH9NQdkrjGe3U5sRGgBwwb ASaekWRr7QgA9t7mc2f1676d8YOD4WhH7QgArm/5WtsX1+5YZyeU0vgaF9PgF5N8qHZERaV2wE2Y xU8+Lkny8toRHfCiJFfXjqhgFn/NQy2zOCS+OMkrKjd0xYuT7K4dsc4MG/eN0wVX3y1LaY6pHQHA TfNFX2DmDYajhSTPqd0BwMosnHBYFk45snbGLNue5Gm1IwC4Qa/ObJ3auJDksNoRsL/adnx1kqdk 9l7c/rZTagfckFKaW2Q2T8d5ZduOL64dUVvbjj+f5PW1Oyq4VSnNXO0ImHalNBuTnFC7o4JXeY6Z aNvxJ5P8Ze2OdWbYuG8MG9fGPWsHAHDTDBsBkkclObZ2BAArt/nsW9VOmHU/PBiOfE4B0DFtO748 k3HjLDm0dgCshrYdj5OMandUcnwpzULtiBtwYu2ACq5K8sraER3y0toBFWxJclTtCJgBxySZtRHx 1Ul+q3ZEx/xm7YB1dlztgJ4ybFwbrqMG6DgvQgIkO2sHALBvFk44LBuO2VE7Y5adlOSBtSMAuEG/ XztgnTmxkWnyokyuAZ41G9LNF7pn8VShN7Tt+LzaEV3RtuM2yTtqd1Qwi7/2Yb3N4hWof+c55vra dvzuJB+p3bGODOdXqJTm1Ph5WysGowAdZ9gIzLTBcHTrJOfW7gBg320+89TaCbPOGwQAOqhtx59O 8p7aHevIiY1MjbYdX5jk12t3VHJS7YAbMIujkz+oHdBBr6kdUEEXh8YwbWbxGupZewPW3npt7YB1 dEjtgB4yvls7pZTm4NoRANw4w0Zg1hljAPTcxtsek/kd22pnzLIHD4ajWfxCPEAfvKl2wDryQgTT 5rczm6c2Hl074AbM2rjrgiS7akd00F9nckX3LJnFUS+st1l7jrkoyVtrR3TUX9UOWEebSmm21o7o GcPGtTOX5KzaEQDcOMNGYGYNhqNtSZ5UuwOA/TQ3l013vWXtilk2n+TptSMAuEH/VjtgHW2sHQCr qW3HF2c2TzTq4umrszY6+b9tO95dO6Jr2nZ8SZI31+5YZ66ihrV3WO2AdfbGth1fXTuii9p2/KnM 1nXUTm1cGcPGtXXP2gEA3DjDRmCWPTY+eQKYCpvueHyywYe2FT19MBwZlAB0z3uTXFE7Yp34QIBp NEqyVDtinXVx4LGjdsA6e2PtgA6bpZOQk9n7tQ817KgdsM5m7ffRlXpL7YB15LW5vVRKc3SSU2t3 TLmzawcAcON80ReYZU+rHQDA6pjbuikbb32L2hmz7KgkD6kdAcD1te34qiQfrN2xTg6qHQCrbfnk nn+v3bHODq8dcAN21A5YR1dm9n7NrcQ/1g5YZ0YnsPZm6b+zPXEN9c3519oB68gbpPee0d3au2sp zZbaEQDcMMNGYCYNhqNbJTmrdgcAq2fTnU+qnTDrfqh2AAA3aLF2ALBfXlc7YJ0dXDvgBszS6OTd bTu+vHZEV7Xt+PNJPlW7Yx3tqB0AM2BH7YB19MG2HV9SO6Lj3l07YB1trR3QI66hXnubkpxROwKA G2bYCMyqp9QOAGB1LZx0eOZ3bKudMcseNBiOjq4dAcB3+WTtAGC//G1m7zrqrtlRO2Advb12QA/M 0s/RjtoBMANmaTz/ztoBXde2468m+VztjnWyuXZAjxg2rg8nYwJ0lGEjMHMGw9GGJE+q3QHA6tt4 ++NqJ8yyhSQ/UDsCgO9i2Ag9tvwC9/tqd6yjHbUDbsABtQPW0Sz9WttXs/RztKN2AMyAWbr6dFw7 oCfa2gF0RynNQUnuWLtjRtyzdgAAN8ywEZhF909yTO0IAFbfxtsdWzth1jkRGaB7XPcG/feO2gEz bnvtgHVkTHHzPlw7YB05TQtYTZ5j9s7HagesE9fu7J17xJ5jvZxZSrOhdgQA380TITCLjC4AptSG Iw/K/OGzdKBK55w2GI7OqB0BwPVcXjsA2G+ubmQ9XJbks7UjesAwB1hNszLuWkry0doRPfGF2gHr ZFPtgJ5wPfL6OSjJHWpHAPDdDBuBmTIYjg5O8rDaHQCsnY23dWpjZa6jBuiWi2sHAPvNsLGSUpqF 2g3r6GNtO95TO6Lr2nZ8YZKv1O5YJ1trB8AMmJVx16fbdnxZ7Yie+GLtADrlnNoBM8bPN0AHGTYC s+aRSbbUjgBg7Wy87TG1E2bd4wbDkWs7AABWSduOv5zkgtodM2qWjoN3EuHem5VTx1xFDayWT9YO 6BHDRpIkpTSbktytdseMcUImQAcZNgKz5vtqBwCwtjYcdVDmD7Rhr+jIJPepHQEAMGU+UzuAqffl 2gE9MivXhAKslvNqB/SI5xi+7a7xJoP1ds/aAQB8N8NGYGYMhqOjkty3dgcAa2/hlCNrJ8y6J9QO AACYMp+uHcDU+1LtgB4x0AFYma/UDuiRS2sH0BmuRV5/R5XSnFo7AoDrM2wEZsnj4vc9gJmwcOpR tRNm3SMHw9HW2hEAAFPks7UDmHrn1w7oEadbAqyM8fxeatvx5bUb6AzDxjr8vAN0jIEPMEucHgUw IxZueUQyP1c7Y5YdlOTBtSMAAKbIV2sHMPWM9faeESjAyvh9c2WurB1AXaU080nuUbtjRhk2AnSM YSMwEwbD0fFJ7la7A4D1Mbd5YzYcfXDtjFn3vbUDAACmyLdqBzD1Lqgd0CMGOgArc0ntgJ7xcR+3 T7KjdsSMMmwE6BjDRmBWPKJ2AADra+G4Q2snzLoHD4ajzbUjAACmxBW1A5h6l9UO6BEDHYCVuap2 QM94Tsa4rp5TS2mOrh0BwLUMG4FZ8djaAQCsrw3HH1Y7YdYdmOT+tSMAAKaEIRVrzelQAKyVy2sH 9MzVtQOozrCxrrNrBwBwLcNGYOoNhqMjk9yjdgcA62vhBCc2dsCjawcAAEyJpdoBTL0rawf0yMW1 AwB6xomNsDKGjXX5+QfoEMNGYBY8Kn6/A5g5cwdsyfzB22pnzLqHD4ajjbUjAACAm9a2Y9edA7BW PMfAXiqlOTnJMbU7ZpxhI0CHGPoAs+BRtQMAqGPD0QfXTph1hyQ5t3YEAABwk1x5uTKX1g4A6Bmn AsPeM6qr746lNAfVjgBgwrARmGqD4eiAJPeq3QFAHfNH+fpDBzy0dgAAAHCTLq8d0DN7agcAAFPL sLG++ST3qB0BwIRhIzDt7pdkU+0IAOrYcKRhYwc8rHYAAAAAAEAPGDZ2w9m1AwCYMGwEpp0xBcAM M2zshJMHw9FptSMAAAAAALqqlOaIJLeu3UESA1OAzjBsBKbWYDiaT/Lg2h0A1DN/6PZkgw95O8B1 1AAAAAAAN84pgd1xt1IaNwICdIBXeYFpdpckR9WOAKCiubnM79hWu4LkIbUDAGbYgbUDAAAAgJvl lMDu2JzkrrUjADBsBKab0xoBMGzshrMHw9GO2hEAM8oTIQAAAHSfYWO3+PcB0AGGjcA0u3/tAADq M2zshPkkw9oRADNqR+0AAAAAuI6l2gFdU0pzQJKmdgfX42pwgA4wbASm0mA4OjjJGbU7AKjPsLEz 7lc7AGBGnVI7AAAAgL12de2AdXBR7YAOOjPJhtoRXM9ZpTT2NACV+Y0YmFbD+AQAgCTzB22tncCE k5QB6jBsBAAA6I+v1A5YB1+uHdBBrj3unh1Jbl87AmDWGTYC0+q+tQMA6Ia5bZtqJzBxy8FwdMva EQAzaFA7AAAAgL32ttoBa+z8th1/snZEB7n2uJsMTgEqM2wEppVToQBIksxtNWzsEG88AFhHpTSb ktyldgewKrbUDgAAYF38XpKrakesoVfWDuiaUpqNSe5eu4MbZNgIUJlhIzB1BsPRSUlOrd0BQDfM bdtcO4FreeMBwPo6I8nW2hHr5LLaAbDGDBsBAGZA244/m+QZSfZUTlkLb0nyktoRHXTnzM7n7n1j 2AhQmWEjMI18kAnA/+cq6k7xHA2wvu5dO2AdXV07ANbYjtoBAACsj7Yd/3EmVxP/Q5IrKuesho8m eV6SB7ft2Odu383XTLvrmFKak2tHAMyyhdoBAGvgXrUDAOiOuY0baidwrSMHw9FtFnft/HjtEIAZ 8ZjaAevo8toBsMac2AgAMEPadvyuJA9Zvqb4FkkOSTJXt2rFLkvy1bYdX1I7pOMMG7vtnCSfqR0B MKsMG4FpZNgIwPXMbd6YpSu9Gbgjzk1i2Aiwxkpp7pjkDrU71tGFtQNgjZ1QOwAAgPW3fMLh55cf TJlSmrkkZ9XuWCUXJfneJB9K8swkL66bs2rOSfIntSMAZpWrqIGpMhiOjk5yau0OADqmb+9lnm5n 1w4AmBFPrB2wzgwbmXauPwMAgOlzWpJDa0eskl9r2/G/tO34a207/l9JPlA7aJU4UROgIsNGYNqc WzsAgA5a8GFvh5xbOwBg2pXSHJDkqbU71tn5tQNgjd2ydgAAALDqpmk09w/f8ed/X6Vi9d26lOaI 2hEAs8orvMC0uWftAAC6Z25hQ+0ErnXsYDg6qXYEwJR7TpIdtSPW0TVJzqsdAWullGZjkpNqdwAA AKtuWoaNlyT58Hf8tbfXCFkjbiECqMSwEZg2Z9QOAABu1pm1AwCmVSnNIUleWLtjnX2xbce7a0fA GmqSbKodAQAArLppGTa+s23He77zryX5zr/WV9Py7wmgdwwbgakxGI62Jjm9dgcAcLPuVjsAYIq9 OMmhtSPW2WdqB8Aa86YQAACYMqU0JyQ5vnbHKnnbd/6Fth1/M8kH1z9lTRg2AlRi2AhMkzsncdco AHSfF+cB1kApzTlJdtbuqOA7r7uCaXOP2gEAAMCqm6ax3Dtu5K9Py3XUTSnNAbUjAGaRYSMwTe5e OwAA2CunD4ajzbUjAKZJKc3BSf4wyVztlgo+WjsA1kopzXySYe2OdXRZ7QAAAFgn0zJsvDrJe2/k f7uxwWPfbIg36wNUYdgITBPXWgJAP2xK0tSOAJgWpTRzSV6T5JTaLZV8qHYArKG7Jzm8dsQ6urp2 AAAArJNpGTa+v23H37qR/+27rqjusWn59wXQK4aNwDRxYiMA9McZtQMApsj/SPKo2hGVXJXkA7Uj YA09vnbAOjNsBABg6pXSHJbktNodq+RGx4ttO/5Kkk+vY8taOrt2AMAsMmwEpsJgODoiyXG1OwCA vXbn2gEA06CU5hlJfr52R0UfaNvxlbUjYC2U0mzK7A0bL6wdAAAA62CaRnJv38//vS/uXkqzsXYE wKxZqB0AsEpcZwkrsP3Kq3PARZflgG9ckQOuuCpbr96drbv3ZNvSnmxeSjbNJZvm5rJhbvL3b94w n7m6yb22J0u5avdSkmT3UnLl0lKuXkq+NZdcPjeXb23YkMs2LeSyrZvyjYO25rId23P5Jh+mMfU8 dwPsp1KaJycZ1e6obFpeIIEb8qgkR9SOWGdfqx0AAADrYJqGje+4mf/97UmetB4ha2xrJm/Wf3ft EIBZ4hVzYFoYR8ANOOCyK3P4+RfniEsuzyFXXZPDspTDNi9kYf47Zoob55KNG5JsqNI5C7be3Edd S7uTy6+YPM67MFft3pOvX7U7F2YuX9+8MV/bsT1fP3pHLtviDYFMjdMGw9HmxV07nbIFsA9KaZ6X 5OW1Ozrgn2sHwBp6Xu2ACs6vHQAAAOvgnNoBq+RjbTu+uVPXp+kNiefEsBFgXRk2AtPCsHGKLV2z u3ZCLyzsWcpRX74wR3/tGznmyqtyzMb5bF1YHipuyF4s6+iSTRvmc4ut87lFkmQpufSbyaXfzGVX 786Xr9mTL2/ZnK8ceVAuOHpHds85T5Ne2pCkJHl/7RCAPlm+9ujlSX64dksHXJHpeoEE/r9SmnOT 3K1yRg0X1A4AAIC1VEqzLZOT/6bB2/bi7/l4kq8nOWyNW9bDOUl+vXYEwCyxcACmhWHjNNu9p3ZB Zx15wSU5/ksX5cQrr8qxmxeyYX4umU+y1al+02r7xg0ZbNyQQfYkF1yca86/KF+48pp8bsvmfOH4 w/L1Qw+onQgr0cSwEWCvldLcMsmfJjmzdktHvLVtx9+qHQFr5H/VDqjEsBEAgGl390zPTuNm32zY tuOlUpp3JHn4OvSstbNKaebadrxUOwRgVkzLEyYwwwbD0QFJBrU7YD1sWFrK8Z+9ILe84NKcsmEy cjNknG0L83M5eevGnJw9yRcvyCWf/ko+vTSfT95iR7587GFZcphjkmTpymtqJ3DDvDEBWEtT8yxY SrMhyc4kv5LEuxiu9Ze1A2AtlNI8Osk9andU8qnaAQAAsMam5RrqZO9vUXh7pmPYeGiS05J8pHYI wKwwbASmwW0zRS9a8t2WrprtQdLcUnL8F76WW593UU5dmM/mhflky4baWXTUwZsW0iRpLrw0l59/ UT6xJ1k85rB86dhDaqfV5eTXrrp97QBgqh1ZO2A1lNLcN8mvxRj8O12V5G9rR8BqW76W7mW1Oyq5 sG3HF9WOAACANXZ27YBV8uW2HX9mL//evbmyui/OiWEjwLoxbASmwe1qB7C2ZnXYeMjFl+U2nzo/ t8ueHLBxQ7LF0zYrs23jhpye5PSvX5yLv/y1fGTjQj5+6tH5xgFba6etu1n9faQHDBuBtXSX2gH7 qpRmPskDk/xUpuskh9X0xrYdX1I7AtbALyc5oXZEJZ+sHQAAAGuplGYhyZm1O1bJ3p7WmCQfSHJF kml4ceKcJL9TOwJgVszXDgBYBYaN0+6q3bUL1s380lJO+dR5eeR7PpEnf/6rudvGucmoEfbTjs0L OWs+eeqnz8tD3/OJnPi5C2bmqNulK6+uncCNO2QwHB1dOwKYWqeW0pxVO2IlSmlOKKX5qSSfSPL3 MWq8Kb9bOwBWWynNvZL8aO2OigwbAQCYdk2S7bUjVsleDxvbdnxVkvetYct68rUagHXk6CdgGpxW O4C1tXTVNZNrZDdM7x5/89XX5LSPfSl3uurqHLhpQ7J1Y+0kptipWzfm1Eu+mQvfd3E+sG1LPn7b 43LN/PTOHJe+ZdjYcbdNcl7tCGBq/U4pzT3advyN2iE3pJRmYyYnNdw/yQOS3DmZmfce7I9PJ9lV OwJWUynN4Ulel9n+PeCjtQMAAGCNTdMobiUnNn7777/nWoSss+NLaU5s2/HnaocAzALDRmAaOLFx Buy5/KrMH7ildsaq23bFVbnjx76YO80tZeOG+WST0xlZP4duXsh9d1+Tsz746Xxgfj7/dbvjc+XG 6fvwcOmyq2oncNNOS/KvtSOAqXX7JO8upXlu247fWiti+WrpI5OcnKQkuUOSO2a6TmpYT7/ZtuOl 2hGwWpavo/s/SY6t3VLZf9YOAACANTYtw8ZvJPmvFf4zb1uLkErOTmLYCLAOpu+Va2CmDIajA5Kc WLuDtbd02ZXJFA0bt11xVe700S/k9A1zWViYy2wfykFtWxfmc1aSu7Sfywfm5/PBKRs4Ll1+Ze0E bpqTl4G1dlqSt5TSnJfkA0m+lmQtR3EHZPL1lgOX//i4JEcl8Q6W1XFhktfUjoBV9ltJhrUjOuD9 tQMAAGCNnV07YJW8s23Hu1f4z7wryZ4k03A92zmZnLgPwBqbnlesgVk1qB3A+li6bDqGSZuvvibN h7+QO2dPNm6chs/dmCabF+ZzZpI7tZ/LuxcW0t7+hKm4onrPN6fj948pdpvaAcDMODrJg2tHsN9e 2bbjb9aOgNVSSvPzSZ5Vu6MDPtO246/VjgAAgLVSSnObJIfX7lglK72GOm07vqSUps3kBou+m5aT NwE6z6IC6LtTawewPvZccnnthP0yv7SU8pEv5gfbz+XuGzK5dho6avPCfO6VPXnyBz6VW3/iK7Vz 9lvff/+YAZ7LAdhbFyd5ee0IWC2lND+e5Jdqd3SE0xoBAJh20zSGe8c6/3Ndc1opzWG1IwBmgVUF 0Hen1A5gfey55IraCfvsuC98PU943ydzn91XZ+uCp17648BNG/Kgb30rj3vvJ3LU+RfXztlnS5f2 9/ePGXH8YDjaXDsCgF54SduOL64dAauhlOYnk/xG7Y4O+dfaAQAAsMamZdh4TZL37OM/+7bVDKls Wq4VB+g0V1EDfecq6hnRxxPXtl1xVc5pP5/bbtmQbPGUS3/dYsvGfN/5F+WDX/h63nWHE3Plpn79 et5zcf9+/5gxc0lOTvLx2iEAdNoXk/xm7QjYX6U0G5K8NMlza7d0zFtqBwAAwBqblmHjf7bteF+/ 6L7iK6w77Owkb6wdATDtHBsF9J3rK2fEnq99s3bCipz28S/lyR/7wmTUCFPi9E3zeVL72ZzyqfNq p6zIngsvq53AzfNGBQBuzvPbduwYZnqtlObQJH8fo8bv9Lm2HX+ydgQAAKyVUprjkpxUu2OV7PM4 sW3HX0zyuVVsqWlahqoAnWbYCPTdLWsHsD72XNiPYeNBl16RR753Mfe/6qpsdu00U2j7xg152GVX 5IHvXczWb11VO+dmLV29O3tcRd0H3qgAwE15a9uO/7J2BOyPUpp7JvlQkgfUbumgt9YOAACANTZN 1xbv76mL03Jq451LabbVjgCYdhYXQG8NhqPNSY6r3cH6WLrymix981u1M27Sbf77y3nip76cE107 zQy4zZaFPOkjn8/Jn/lq7ZSb1LfTXmfYybUDAOisy5M8u3YEa2Jr7YD1UEpzUCnNK5P8W3wN48a4 vg0AgGk3Taf7vWM///lpGTYuJLl77QiAaWfYCPTZCbUDWF+7z7+0dsIN2nzVNXngexfzwCuvzMYN nlqZHVs3bsj3fOOynPv+T2Xj7j21c27Q7q9eUjuBveM5HYAb8xNtO16sHcGamOrn/1KahVKapyZZ TPLDSeYqJ3XVpUneXDsCAADW2LQMG/+7bccX7Of3MS3DxmR6/r0CdJb1BdBnTjqYMbvP795A6cjz L84T/uszuY1TGplhp2+az+P+81M55KLLaqd8lz0dHUTzXY6vHQBAJ/1LklfVjmDNHF1Kc1rtiNVW SrOllOZpST6e5PeTHFk5qev+tm3HV9aOAACAtVJKc0iS29fuWCWrMUr8aJKLVuH76YJpumIcoJMM G4E+M4KYMV07sbF89It5/HkX5uBNRo1w+JaFPOGz52Xwya/UTrme3ed1bxDNDfKcDsB3uiDJD7Tt eKl2CGvqJ2oHrJZSmlJK8xtJPp/k95KcUjmpL/6idgAAAKyxszI9J7jv97Cxbcd7krxzFVq64MxS Gi8SAqwhw0agz4wgZszuL3XjDVwLS0u57/s+mftcc3Xm56blc1HYfxs3zOchl38rZ33gM5nrwgRh aSm7v3Jx7Qr2zhGD4WhL7QgAOmMpk1HjebVDWHNPLqX5sdoR+6KUZlspzX1LaX6tlObjSf4ryY8n OaJyWp9ckOSfa0cAAMAam6ZT/VbrGulpuY56e5KmdgTANLMeB/rMsHHG7LnosixdfmXmtm2u1rD9 8ivz0PZzucXWjdUaoOvuupAc/r7F/NPpJ+fKiiea7r7gG1m66ppqPz4rdnySxdoRAHTCz7Tt+M21 I1g3LyuleWgmpxy+I8lXa19NXEqzIcmBSQ5IsiXJ0UlumckpjLdMcockt0uyoVbjlPj9th1fVTsC AADW2Dm1A1bJ+W07/uQqfV9vW6XvpwvOSfK+2hEA08qwEeizE2sHsP52f+miLAyOrvJjH/a1b+QR nz0/Bxo1ws06ectCHvvBz+SNtzkulx60tUrD7i9eWOXHZZ+dEMNGAJLXJ3lJ7QjW3XD5kSQpxYEX M2Apye/XjgAAgLVUSrMlyV1rd6yS1Rwjvj/JlUnqnWSyes5J8rLaEQDTylXUQJ8dWTuA9XfN575e 5cc9/vNfy+O+8NUcuMmBHLC3DtuykMctfilHnn9xlR//ms8bNvaM53UA3pHkqW07XqodAqy5N7ft +NO1IwAAYI3dLcm0nJbxjtX6jpZP6X//an1/lZ1dSjNXOwJgWhk2An12i9oBrL9rPvu1df8xB4tf ySMvujSbNnjahJXavnFDHvuVC3P8F9b/v91rPnPBuv+Y7Jc6x/EC0BUfTvLQth1/q3YIsC5eUTsA AADWwbRcQ50kb+/491fL4UluXTsCYFq5ihros8NrB7D+dp93SZauvDpzm9fnDW63/9gXc9+rr07m vNkK9tXC/FweeeGl/4+9O4+z7Czo/P+tXrJDEiRsgoLYiAwHuYAihERsoqCO+4LrDOM4aDnqOO6i MzrujI7j+mtGFBUVVNxRZEkugSRsAgc4EBJuIPuedHrvrq7t98etQBLSSS/33uecc9/v16teCZBU fUK661bV/d7nyb8cXsnHnzib7dranfuyvs8uomMeWToAgGKuS/IVTVPvKh0CzMQHkrypdAQAwN2q anBukvOTPDbJ6YVz+uRgktsyPulv2DT1SuGeEp5XOmBC9mf8dfwkXZLkJyf8Pks5L8kVpSMA+siw Eeikbdt3fEb6c3Q7x2J9PSufuD1bP/8xU/9Qz2iuy/nrq1P/ODAPNi0s5N/vO5g3jG7OaNv0D9xd +cRtU/8YTNw5pQMAKOLGJC9omvqG0iHAzPyyK+cBgDaoqsG2JK9J8qzSLXPg6qoafFfT1BO7zrjt qmqwOclzS3dMyDunMEx9R5L1JH04WeS8JK8sHQHQR+7UBLrK+GGOrYxunfrHMGqEyVtYSL7ywKF8 /pU3Tf1jLc/g8wQTN/3FKwBtc2OS5zdNfVXpEGBmPprk70pHAABU1eCcJG+NUeOsPCHJm6tq8NTS ITP0BUkeUjpiQiZ+bXTT1Hcl+cik328hfbpyHKBVDBuBrnJd5Rxb/vh0B0tGjTA9CwvJC5eW8uQp jhvXV1azcu0dU3v/TM3DSwcAMFM3J/lio0aYOz/fNPVa6QgAgCQ/nuQzS0fMmdOS/GrpiBnq09ht Widt9uUEz8dX1eCxpSMA+siwEegq44c5tr5vKas33jWV9/3Uj95g1Agz8MJDS3nix2+Zyvteueq2 ZMVzpR3kNGaA+fJ/XT8Nc+ddSV5XOgIAYMM3lg6YU19RVYPTS0fMSF+GjasZfy0/DZdM6f2W8LzS AQB9ZNgIdNVZpQMoa/nyyZ/29nkfuzkXLC9P/P0Cn25hIfmqfQfyWdfePvH3vXzF9K+6ZirOKh0A wEwNSgcAM/cjTVOvl44AANgY1n1O6Y45tTnJ55eOmJG+DN3qpqn3Tel9T/yK64L6MmQFaBXDRqCr zi4dQFnLV9480ff3uOvuyAsPHpzo+wQe2KaFhXzNXXvziFt3Te6drq5l5WPTva6eqTmrdAAAM/Vt VTV4dVUNfG8H8+Gvm6Z+Z+kIAIANvg8p62GlA6atqgZPSvLI0h0TMrXxYdPU1ybpy20Oho0AU2DY CHTVWaUDKGvtrv0Tu476nNt252vu3J1NCwsTeX/A0duyaSFfd8MdOXP3gYm8v+Wrbs36kpNXu2rb 9h1nlW4AYKa+K8kVVTX49tIhwFTtTfLjpSMAAO5hS+mAOXda6YAZ6Mtpjcn0T1Xsy6mNT/XiTYDJ M2wEuuqs0gGUd/hD15/w+zh9/1K+9rrbs3Wzh0Qo5bStm/O1V96Yk5dXTvh9LU/g8wJFnVU6AICZ e0SSv6iqwRuravCE0jHAVLysaerrSkcAAMAM9en0vmkPDy+Z8vuflYUk55aOAOgbKw6gq84qHUB5 y5fflKytHfffv2V1LV/9ketyxkmbJ1gFHI+HnbIlX1FfnU3r68f9PtYPLWd55BrqjjurdAAAxbww SVNVg5eUDgEm6rIk/1/pCAAAmLG+DBuvapp62j90v2zK73+W+nRSJ0ArGDYCXfXQ0gGUt35gKcsf O/7vpy5438fzqFPcOAFt8fhTtuTc+urj/vuXmxuS1eMfO9MKZ5UOAKCo05P8cVUN/rKqBmeVjgFO 2OEk39M0tS/SAQCYG1U1eFSSJ5bumJBZXBPdJNkzg48zC+eXDgDoG8NGoKsMG0mSHH7fNcf19z39 w9fnyUaN0DrP3LKQbVfdfFx/7+H3XzPZGEo4vXQAAK3w4iR1VQ0GpUOAE/KjTVNfUToCAABmrE/j tqkPGzdeCPWOaX+cGXlWVQ1OKR0B0CeGjUBXnVw6gHZYufr2rO06cEx/z2Nu3JkvWV2ZUhFwor58 74E87M59x/T3rN54V1Zv68uLOufaSaUDAGiNxye5tKoG31Q6BDgu/5jk90tHAABAAX26jngWJzYm ySUz+jjTtjXJs0tHAPSJYSPQVaeWDqAl1tdz+N+O/uraU5dW8pU378zCwhSbgBOydfOmfNXHb87W Y7hWeuk9n5hiETN0ZukAAFrltCSvq6rBz1fVwFfw0B03JPnupqnXS4cAAEAB55UOmJDbm6a+ckYf a1YDylnoy79/gFYwbAS66iGlA2iPwx+4NuvLq0f1117wwatzxkmbp1wEnKjPOGVLzquPbrS8tvdQ lj9605SLmBEnMgNwf34uyauqauALeWi/5STf2jT1ztIhAAAwa1U1ODPJ00p3TMhlM/xY/5bx9xJ9 0KcTOwGKM2wEuspVlXzS+qHlLH/wugf966qP3JAnnrJlBkXAJDztpE154sdvfdC/7vB7r06O4XRH Ws2JzAAcyUuS/F1VDXwvCO32X5umnuUToAAA0CbPSX82GDM7RbFp6oNJ3jerjzdl53phJsDk9OVB FZg/TmzkXpbeeVWyfuRbrs7etT9fsnx4hkXAJFywe19OO3jk37vrh1fGw0b64ozSAQC02tck+Rvj Rmit326a+pWlIwAAoKDzSwdM0Kyvh75kxh9vWs5I8gWlIwD6wrARgF5Y23Ugyx++8X7/t03r6/my K2/Mlk0LM64CTtSpWzZle3PtEf/3w++7JuuH+nJDBUkcqwvAg/nqJK91+gG0zpuT/GjpCAAAKKwv 1xCXOEFx1kPKaTqvdABAXxg2Al11SukA2ufQZR+73//+Cz58fR5z6tYZ1wCT8rmnbMmTRjd/+v+w spald3189kEAQGnfkOQVpSOAT3p/km9pmnq1dAgAAJRSVYOTk3xR6Y4JeVfT1Csz/piXzfjjTZNh I8CEGDYCXXVy6QDaZ+32vVn+yL1PbXzongM5d3XW33sBk/b8PftzyuF7/15eeu/VWd93qFARU+LE RgCO1vdU1eBnSkcA+ViSFzVNvbt0CAAAFPaF6c/zlzMfGTZNfWeSj876405JX07uBCjOsBGAXjl0 8UeT9fVP/ucvvcIV1NAHp23dnHM/eM0n//P68mqWjnBKK512RukAADrlF6tq8JWlI2CO3ZDkBU1T 3146BAAAWqBPY7ZS10L35TrqR1bV4EmlIwD6wLARgF5Z27k/hz9wXZLkiZ+4NU84xeFf0BfVyZvz 6JvvSpIcftdVWT9wuHARAFDYQpK/qKrB55YOgTl0Y8ajxhtKhwAAQEucXzpgQtaSvKPQx+7LsDFx HTXARBg2AtA7hy6+IpsPLef8nXtKpwAT9vzrb0/2L2XpHVeVTgEA2uGsJH9fVYNTSofAHLkxyfOb pnaEOgAAJKmqwaYk55bumJAPNk29t9DH7tOwsU8neAIUY9gIQO+s7zuUx7+lyZknOa0R+uaRp2zN I9/UZP3wSukUAKA9nprkl0tHwJz4eJLnNk3tlUYAAPApVZKHlo6YkGLjwqapP5Hk5lIff8Kc2Agw AYaNAPTO5i2bc/tSsufQcukUYMJu3buUvYfXs7BpoXQKANAu/72qBp40gOm6MuOTGq8rHQIAAC3T p+9HS5+aeEnhjz8pT6yqwaNKRwB0nWEjAL3zkHPOzGqSd9yyv3QKMGHvvP1gFrZszhmf0ZcXvwIA E7KQ5NVVNTi9dAj01KUZn9R4Q+kQAABooT5dO1x62HhZ4Y8/SeeXDgDoOsNGAHply0lbctpZ4+cy rz+8nmvuOli4CJiUj9y2L7evrCdJznjYQ7Jpsy9lAYB7eXySny4dAT302iQvaJp6Z+kQAABoqb4M 2K5umvqmwg2lh5WT1KeTPAGK8GwwAL3ykHPOvNd/fuedS1lZXStUA0zKgcOred+eT10vv7BpIWc8 3KmNPbSvdAAAnfdjVTV4QukI6JFfSfIdTVMfLh0CAABtVFWDJyZ5dOmOCWnDqPCD6c/Pift0kidA EYaNQFctlQ6gfbacvDWnPvS0e/13+9bW866b9xYqAiblspv3Zuk+G+XTzz4jm7dsLhPEtKyUDgCg 805O8n9KR0APHEjy7U1T/0zT1OulYwAAoMX6NF4rPmxsmno1yTtKd0zI06pqcOaD/2UAHIlhI9BV h0oH0D4P+Yz7P73tigNruWmPXzLQVR/feSDXLH36c6kLCws5/WEPKVAEALTc11fV4ItLR0CHXZXk 2U1Tv7Z0CAAAdECfrhu+pHTAhuIDywnZlOQ5pSMAusywEYBe2Lx1S04987T7/d/Wk1xy+0FXUkMH HVxezTt3HvnWu9PPPiObNvuStkec2AjApPx86QDoqH9M8qymqT9cOgQAADqiLyc27kxyRemIDX0Z NibJ+aUDALrMs8BAV7lbmHs54zMe+NS2PavJO27yywa65m037s3BtSPffLewaSGnn33GDIuYsn2l AwDojRdW1WBQOgI65ueSfH3T1LtLhwAAQBdU1eARST6vdMeEXNY09ZF/GD9b706yWjpiQvp0oifA zBk2Al115OO7mDubNm/KaWee/qB/3ZUH1/KJnQdmUARMwodv3ZfrDz/4z1FOO/uMLCwszKCIGThY OgCAXvkfpQOgI9aSfFfT1L/QoicyAQCgC/o0WmvNKYlNUx9I8r7SHRPyhVU1OLl0BEBXGTYCXeXo PT7ptDNPz8Kmoxs1XbpzKfuW3HQKbXfn/sP5t71H93t185bNOeUhp065iBlZKh0AQK98bVUNHlc6 AjrgJ5um/vPSEQAA0EF9uYY6SS4pHXAfrRlanqCTk3xh6QiArjJsBLrKiU580ukPO/praJfWkotu 3Jv1dYdQQFstr67lolsOZOUBrqC+r9Mf9sDX0dMZrj0EYJI2JfkvpSOg5d6a5P+UjgAAgI7qy4mN h9K+ExL7MmxM+jWABZipLaUDAI6TE51Ikpx8+inZvPXYHs5uW0kuvWFPznvcmVOqAk7EW2/Yk92r xzY+PunUk7L15K1ZXlqeUhUzcrh0ANBra0k+lmRnkjY8YJyU5LQkp2y8PXLjj0zW91TV4BeapnZs O9y/n3X9NAAAHLuqGpyR5OmlOybkPU1Tt+1ns30aNp6f5NdKRwB0kWEj0FV7SgfQDqefffSnNd7T FQfX8sg79udJDz99wkXAifjALXtz7dLxPa962tlnZPctd024iBnbXzoA6KXbk/zPJK9pmrrV30dU 1eDsJJ+Z5LFJnpzxEySDJE+Jn+Ecr0cneVGSfy4dAi10bdPU7ygdAQAAHfXcJJtLR0zIZaUD7qtp 6turavCxJE8q3TIB51bVYFPT1GulQwC6xg/Fga5q9ROSzMamzZty8hnHf6jNZXct58yTl/LIh5w8 wSrgeF1718G8b+/xH6Z06kNPy55bd7lqvtt2lQ4AeufGJM9tmvq60iFHo2nqu5LcleTDSd54939f VYNTkpyb5CuSfHmSqkhgd704ho1wf5rSAQAA0GF9uYY6SS4pHXAEl6Yfw8aHJnlakg8U7gDonE2l AwCO067SAZR36kNPy8LCwnH//Svr67nw1gPZt+RWOiht54HDufjOQ1k7gU3iiY6daYVdpQOA3vm+ rowaH0jT1Ieapr6oaeofa5r6aUmekORnklxVOK0rvrqqBltLR0AL7SsdAAAAHdaXYeN6krae5N6n 66ifVzoAoIsMG4Gu2lU6gPJOPfPEr5E+sJa86ca9WV51+juUcuDwat5884EcnsBvw9Mm8HmBonaV DgB65cYk/1I6Yhqapr6maepfyfjUghcluahwUtudmeQFpSOghZ5QOgAAALqoqgYnJfmi0h0T0jRN vbt0xBEYNgLMOcNGoKt2lQ6grC0nbclJp540kfe1cyV503W7s+b6Wpi5ldW1vPGGPdm7Opnffyef cUo2bfIlbleNhou7SjcAvfKupql7/QVe09TrTVO/qWnqC5I8N+29OqoNvrZ0ALTQM6pqcEbpCAAA 6KBnJDm1dMSEtHY82DT1KMmtpTsm5PzSAQBd5FlfoKvuKh1AWaecMdnvF29eTobXtfUFadBPa2vr edN1e3LnBG+DX1hYyMkPcR11R+0qHQD0zi2lA2apaep3Nk19fpJvS3Jz6Z4W+tLSAdBCW+PJNQAA OB59+jq6tcPGDW3vO1qPrqrBE0tHAHSNYSPQVbtKB1DWKQ89beLv8+ql9Vxs3Agzsb6evOW63blp efIHaZ36kMl/fmAmdpUOAHpngtP57mia+i+TPCXJa0u3tMznVdXgsaUjoIVc0w4AAMfuvNIBE9T2 4eBlpQMmqE+/bgBmwrAR6Ko7SgdQzqYtmyd2DfV9jQ6t5R037JnK+wY+ZXjdrlx3eDq3g558xilZ WFiYyvtmqm4vHQDQF01T72qa+tuT/Ockh0r3tMjzSwdACxk2AgDAMaiqwaYk55bumJDrmqa+vnTE g2j78PJYPK90AEDXGDYCXXVr6QDKOeX06V4z+5EDq8aNMCXr68lF1+3OJ5amM2pMxtdRn3TayVN7 /0yNFy0ATFjT1K/KeMzn+6cxTyDAp/uCqhqcUzoCAAA65ClJzi4dMSFdGA3WSfaXjpgQP5cAOEaG jUBXOdVpjp3ykFOn/jGMG2Hy1teTC6/bnU8cWpv6xzrljOl/nmDibi4dANBHTVO/O+MfnF9duqUF nlk6AFpqe+kAAADokD6N0y4pHfBgmqZeSfKu0h0T8nlVNXhE6QiALjFsBDppNFy8M8ly6Q7KOOn0 2ZzE9pEDq3nbdbtn8rGg79bW1vPma3flmqXpjxqT8XXUdI4XLQBMSdPUVyU5P8m1pVsKe2pVDbaU joAWch01AAAcvfNLB0xQF05sTLrTeTTOKx0A0CWGjUCXubJyDm095aRs2jS7h6+PHVrLm6/dlbW1 6V2bC323srqWN1y7O9cdnt3voy0nbcnmLZtn9vGYCNekAkxR09Q3JLkg8z0kPyXJ55eOgBYybAQA 5s1S6QA6rS/DtF1JLi8dcZQuKx0wQX359QMwE4aNQJe5snIOnTyj0xrv6dql9bzh2t05vDKbk+ag T/YfXsk/Xbs7Ny/Pfhw8q9NdmZhbSgcA9N3GyY1fn/k+/f5ppQOghT6nqgaPLx0BADBDdyXxA3+O 2cbXzY8t3TEh72iauiu/D96ZZLV0xIT06SpzgKkzbAS67LbSAczeSaeVGSrdvLyef7x2T/YeWiny 8aGL7tx/OP943d7cWei3zcmFPl9w3DyuA8xA09SXJfmR0h0FfU7pAGipC0oHAADMStPUh5J8qHQH ndSnUdolpQOOVtPU+5J8oHTHhAyqanBG6QiArjBsBLrs2tIBzN5Jp5YbKu1aXc8/3rAvN+85VKwB uuKauw7mn2/en/0FX++5teDnC47LdaUDAOZF09S/l+QNpTsKMWxsp39L8tIkVZJHJDm74NvjM76a +X8kuXKK/8xt4zpqAGDe/HHpADqpT8PGS0sHHKOu9R7JpiTPLR0B0BVbSgcAnIDrSwcwW1tO2pJN m8tu8g+uredfbz2ULz60kqc8wguq4P68/+a9ef/elcz+8ul723ry1ixsWsj6WukSjpLHdYDZemmS K5LM2xe1ho3t83NJfrFp6rZ80bYr4xdSDqtq8CtJ/nOS305yasmoGXhBVQ0WWvTvAQBg2l6R5MUx MOLYnF86YEKWkry3dMQxujTJfysdMSHnJXlz6QiALnBiI9BlN5QOYLa2nnJS6YQkyer6ei7btZy3 X787awZT8EnLq2t587W78r4WjBrv1pbPGzyo20fDRcfhAsxQ09Q3JvnF0h0FPKF0APfyV01T/0Jb x3RNU681Tf3KJC9Mcrh0z5Sdk/GJmQAAc6Fp6sNJvjzJ7ybxcykeVFUNHp7k80t3TMj7Nq5k75K+ nNiYjIeNABwFJzYCXebKyjnTtoHSlQfXcsc1u3LBY87IQ0/ZWjoHirpj/+EMb9mf3aulS+5t6ykn 5fCBpdIZPDinNQKU8dtJfiDJ40qHzNAjSgdwL79WOuBoNE19SVUNfj7Jr5RumbLtST5UOgIAYFaa pt6f5IeqavDTSb4wyWMzm+fPNyc5e+PjfUmSp8/gY3Li+nQN9SWlA45V09S3VNXg40meWLplAr6o qgYnbQysAXgAho1Alzmxcc5sbeF48M6V5O9v2JfnnHVSnvTw00vnQBEfunVv3rdnNSstPGenjZ83 uF+GjQAFNE29VFWDX0vy+6VbZujkqhqcvvEEJmXd3jT1B0pHHIPfSfJjSR5WOmSKLkjyW6UjAABm beP7g4tLffyqGjw/yaszXy8666I+DRu7evrhpenHsPHUJM9M8s7SIQBt5ypqoMuc2DhntpzczoHS 4bXkbTsP56Lrdmd5da10DszMweXVvOGaXXn37pWsrLdw1Zhka0s/b/BpPKYDlPMnSXaWjpixh5cO IElydemAY7HxZPfrS3dM2ZdU1cAL4QEAZqxp6ouTfGmS3YVTeGB9uT54Pck7Skccp64OMu9PX349 AUyVYSPQWaPh4lKc2jg3FjZtyuYtm0tnPKBPHFrL667enWvvOlg6BabuY3fsz+uu3ZMbD7dz0Hi3 LScZNnZEp4YNAH3SNPWBjE8GmSfnlA4gSdLFb5zeXDpgys5I8uzSEQAA86hp6o8n+b+lO7h/VTU4 LeMT9vrg8qapu/oCR8NGgDlj2Ah03SdKBzAbW07qxqER+9eSN99+KMPrdmdpxemN9M/+wyt50zW7 8radh7PUgV/iC5sWsnlru0fRJEmuKh0AMOf+pHTAjJ1ROoDOuqh0wAy8oHQAAMAce13pAI7oOUn6 8oPmzo4Dm6a+IskdpTsm5NyqGtjrADwInyiBrjOEmBNbTu7GsPFuHz+0ltddsydX3r6/dApMzIdu 3Zu/uW5vrmv5KY33tWVrtz5/zKlR6QCAedY09QczXy8aO7V0AN3UNPWtST5SumPKDBsBAMr5aJLl 0hHcrz6drndJ6YAT1Nlh5n2cneQppSMA2s6wEeg6w8Y5sbmDw6SDa+t5+12H8/qrd+WO/YdL58Bx u3nPofzdx3fl3btXcrgDpzTe1+aOnPg6x9bjKmqANvjX0gEzdHLpADrtwtIBU/acjWv2AACYsaap 15PcVbqD+/W80gETdFnpgBPU9f576tNgFmAqDBuBrjNsnBObt3T3hP9bltfzjzftz9uu252Dy6ul c+Co7VtayYXX7so/33Iwd65265TGe+ry5485cf1ouLhUOgKA3px4ANPW9+uotyY5v3QEAMAcO1g6 gHurqsGWjK+i7oMbm6a+pnTECerTzy987wXwIBxfA3SdYeOc6PpVsmvryccOreXqa/bkKadtzuBR Z2TrZq8voJ2WVtby3lv25mMH17Oy3t1B4926eOLrnPFYDtAOby8dMENnlQ6g096WZDVJn189c0GS N5aOAACAlnhGkr6cat6HUeD7Mh4An1o6ZAL6dBIowFRYVABdNyodwGxs2tKPh6zl9eSD+1fzV1fv SX3z3qysdX80Rn8srazmPTfuyWuv3p3LD6z1YtSYOLGxA64oHQBA0jT1TUmuL90Bbdc09Z4k7ynd MWXbSwcAAECL9Om64EtKB5yopqmXk7y7dMeEPLaqBo8vHQHQZv1YiQBzazRc3Jfk2tIdTN+mng2T Dq6t5717V/KXn9id9960J4dX1konMccOLq/mXTfuyWuv3pMP7l/Ncj/2jJ+0yemobXd56QAAPskp unB0hqUDpuzpVTX4jNIRAADQEn0aNvbhxMakP/8ciVMbAR6QZ3mBPvhI6QCmr6/DpINr66n3reY1 V+/Opdfvzt5DK6WTmCN3HTict123O395zd40PRw03q0vJ772mGEjQHt8onQAdMSFpQOmbCHJl5aO AACA0qpqsJDk3NIdE7InyYdLR0zIZaUDJqhPw1mAidtSOgBgAi5P8pWlI5iehU0LWVhYKJ0xVcvr yUcPruXK6/fmsVsX8vlnnZzPOuvU0ln01CfuPJAr9h7OTYfX09Mt470s9HQY3SMfLR0AwCd9vHQA dMQ7kxxM0udv2i5I8jelIwAAoLAnJ3l46YgJeWfT1KulIybkHUnW0o+DvM4vHQDQZn34RA/gxMae W9g0Pw9Xa+vJdYfX86bbDuWvPn5X3nvTnuxbcoojJ273weW868Y9ec1Vd+WiO5dy45yMGpNk0xx9 Dumgu0bDxVtKRwDwSTeXDoAuaJp6Kf26+uz+XFA6AAAAWqBPp+ldUjpgUpqm3pPkQ6U7JuTJVTXo y3gWYOKc2Aj0gWFjz23a1O/TGo9kz2pS71vNB/btzaO2Jk88fWs+52Gn5WTX6nKUDhxezVU7D+Tq A6u5bWVeZoz3b2HTQtbX5vv/g5bqy9UnAH1xsHQAdMiFSb6sdMQUPbGqBp/dNPW1pUMAAKCgPg0b +/birEuTPL10xIQ8L8k/lI4AaCPDRqAPPppkPcl8rt/mwMKcDhvvtp7k5uXk5l3Leefu3XnkloV8 9mlb8oSzT8npJ3ko5972HFrO1bsO5bqDq7l1eX5OZXwwCwsL8f9GKxk2ArSLYSMcvWHpgBl4QZJX lY4AAICC+jJsXE7yntIRE3Zpkh8oHTEhho0AR2ANAXTeaLi4b9v2HaMkTyrdAtO2up7ctLyem3Yv 5527l/MZW5JHnbQpjzvjpDzmoadk85yPQOfRyupabth9KDfsX85Nh9eze9V47/4sbNqUrK6VzuDT 1aUDALiXPaUDoEPen+SuJGeXDpmi7TFsBABgTlXV4LFJPrt0x4S8r2nqvr2YsTdXa6c/A1qAiTNs BPqijmFjby0sGOsdyZ0ryZ0ra/nIgUPZcvtSHrYlOWfrQh592tY86iEn59Stm0snMmH7D6/kpj1L ufXgSm5fXs/O1fW4YZkOM2wEADqpaeq1qhq8Nck3lG6ZogtKBwAAQEF9Gpv17RrqNE19U1UNrkny +MIpk/DMqhqc3jT1/tIhAG1j2Aj0RZ3kxaUjmA7DxqOzsr6e25aT25bX85EDS8kdSzl980LO2rSe h23dlLNO3pyzT9mah522NVs3byqdy4M4vLKWnQcOZ+ehlew6vJqdy+vZtZYcdCIj/bGapCkdAQBw Ai5Kv4eNj6yqwVObpv5w6RAAACjg/NIBE9S7YeOGS9OPYePmJM9JcmHpEIC2MWwE+sKJT3A/9q+u Z/9qcuPyWnJgLclykuTUzQs5bSE5bdN6Tt+8KadsWsgpWxZy6pZNOXnzppy0eVO2bl7I5o1R6Ulb NmWTgelxW1tfz+GV8TXIqxt/vry2nkMrazm4spZDq+s5uLqeA2t3vy3kkGMY6b/LR8PFpdIRAAAn YB6edHpBEsNGAADm0fNKB0zQZaUDpuTSJN9ZOmJCnpf5+B4T4JgYNgJ9YdgIx+Dg6noOJrkzSbJW Nob7YdTIXPDYDQB0WtPUH6uqwY1JPrN0yxS9IMlvl44AAIBZqqrBw5L8u9IdE3JF09R3lI6YkktK B0xQn4a0ABPjHkqgF0bDxduT3FC6AwA4au8rHQAAMAF9P1HjS6pq4MXxAADMm+cm6cs1Vn0a/93X R5PsLB0xIc/xvRfApzNsBPrkXaUDAICj9p7SAQAAE3BR6YApe2iSLywdwdR5AhUA4N7OKx0wQX29 hjpNU68neUfpjgk5LckzS0cAtI1hI9An7y4dAAAclcNxFTUA0A99HzYm4+uo6bfTSwd0zBmlAwA6 pi+n3jFfzi8dMEEfKB0wZX06+KZPg1qAiTBsBPqkT1+4AkCffWA0XFwqHQEAcKKapr4p4+vP+uyC 0gFMX1UNNpdu6BAnXAIcmzNLB8CxqKrBqenXyXm7SwdM2RWlAyboeaUDANrGsBHok/clWS0dAQA8 KC9GAAD6ZFg6YMq+uKoGp5WOYOoeUjqgQ5xwCQD99uwkW0tHTNDnlg6YskeWDpigc6tq4JRbgHsw bAR6YzRcPJj+H6cOAH1g2AgA9MmFpQOm7OQk55aOYOo8V3D0+jR0AJiFs0oHwDHq26l5P9/XFypV 1eDhSX6odMcEPTzJk0tHALSJKxOAvnlP+nU8PAD00TtLBwAATNDFSdbS72HYBUneUjqCqXpokp2l Izqil8MAAFrD1d3lnVc6YMLOTfKhqhr8ZZKPJdlTuOdEbc54MP3UJN+Z8RiwT85P8tHSEQBtYdgI 9M3bkyyWjgCgXdbX10sn8Ck3joaL15SOAACYlKapd1XV4H1JvrB0yxS9oHQAU3dW6YAOObt0AEDH nFU6oGNcQ1tQVQ02p5+nlT8xyc+UjuConJfk/5WOAGiLPr+KGJhPF5cOAKCFDBvb5OLSAQAAU9D3 66ifUVWDh5WOYKoeXTqgQz6zdABAx5xTOqBjHlo6YM49PcnppSOYa327Ch3ghBg2Ar0yGi7ekuSq 0h0AtIxdY5tcWjoAAGAKhqUDpmwhyZeWjmCqDBuP3iNLBwB0jM+bx8aJjWX17Rpquuezq2rw2NIR AG1h2Aj00dtKBwDQLmtra6UT+JSLSwcAcESnlA6ADrs0yVLpiClzHXW/GZ0cvceUDgDoGCfdHqWq GjitsTyn5dEGBrYAGwwbgT4ybATgk9bXHNfYIreNhotXlI4A4IgMG+E4NU19KMllpTumzLCx34xO jp7TLQGOjc+bR+/hpQMwKKMVzi8dANAWho1AH11SOgCA9lhbdVpji3iMBmi3s0oHQMddVDpgyp40 h1ei9f0Uznv6vNIBHTIv/195lSAwKY8rHdAhjyodMM+qavB5SR5RugNiYAvwSYaNQO+MhovXJLmq dAcA7bC2ulo6gU95c+kAAB7Q6aUDoOMuLB0wAxeUDpilpqkPlm6YoaeWDuiCqhqclGRb6Y4Z2V06 AObAvAyIP7+qBptLR3TEvL2IpG2MyWiLp1TV4GGlIwDawLAR6CvDCQCSOLGxZebhyX6ALvuc0gHQ ce9Lsqd0xJS5jrq/HuXJ06PylCTGOcCkzMuA+NT4XuNozctpgW0d9T6vdABsWEhybukIgDYwbAT6 ynACgCSGjS3yidFw8ROlIwB4QJ5shBPQNPVqkreW7piyeRw2LpcOmKGnlQ7ogH9XOmCG2jo6Abqp Kh3QEfPyPVlbR72GjbSJX48AMWwE+muYxN2jAGR1eaV0AmNOUwZovyeWDoAeuKh0wJQ9uqoGTykd MWN7SwfM0NNLB3TAoHTADO0qHQBzYJ6ewzCePzoGoIVU1eDR8T0x7XJ+6QCANjBsBHppNFzcneQ9 pTsAKG91eZ5+RtxqbykdAMCRVdXglCRPLt0BPdD3YWMyf6c27iodMEOuu3tw83Ryzq7SATAHdpUO mKEvLh3QEfMybGzjqcBGZLTNM6tqcFrpCIDSDBuBPnMyFABZOezExhZYy/g0ZQDa64uSbC0dMSNr pQPor6apL09yc+mOKTNs7K/zq2qwUDqirapqcHqSZ5TumKG7SgfAHJin32fPrarB5tIRbVZVg3OS PLJ0x4y08Srq80oHwH1szfhnNQBzzbAR6LM3lA4AoDxXUbfCpaPh4q7SEQA8oHl6EmdP6QB6r+8v 6PjSORsm7CodMEOPSPIFpSNa7AWZnxcBJPP1ax9K2VU6YIYeEgOdBzMoHTDn5ulUZrpjnn5WA3C/ DBuBPntvkltLRwBQlquoW+FfSgcA8KCeXzoAeuTC0gFT9tAkzywdMUO7SgfM2FeWDmixF5UOmLFd pQNgDuwqHTBjX1E6oOXm6SrkVp3YWFWDMzM/14DTLQa3wNwzbAR6azRcXItTGwHm2srhlayvr5fO IPnn0gEAHFlVDR6W+Ro2HiwdQO9dVDpgBi4oHTBDt5QOmLFvLB3QRlU12JTk60p3zJgXjMP0zdNV 1Eny9aUDWm6eho27Sgfcx3NjN0E7nTtnp+UDfBoP0EDfvb50AADlrCwtl04guXo0XLy8dAQAD+ib kmwpHTFDh0oH0G9NU1+fZFS6Y8peUDpghm4oHTBjz6iqwbbSES10fpJHl46YsetKB8AcuKl0wIw9 taoGTy4d0UZVNTg7ybmlO2alaeq2jXrnaVRKt5we19QDc86wEei7tyQ5XDoCgDKWD3kIaAEvMgBo v+8pHTBjd5YOYC70/Trqc6tqcErpiBmZt2FjkrykdEALfXfpgALm8dc+zNo8/j57SemAlvr3mZ/n 7XeVDrgf55UOgAfgOmpgrs3LF0jAnBoNF/cleVvpDgDKWHZiYxu4hhqgxapq8NwkX1i6Y8Z2lg5g LgxLB0zZyZmfJ9huLB1QwH+qqsHW0hFtsXGK1jeV7ihg3k6SgxKuLx1QwEs8xtyvF5cOmKE7Sgfc 08aLdZ5VugMegOEtMNcMG4F58HelAwAoY/mQYWNhdyW5uHQEAA/op0oHFODERmZhmGS9dMSUzct1 1PM4Onl0km8pHdEiL01yaumIGVvPfJ4kB7M2j48xj8x8jfgeVFUNHpXkhaU7Zujm0gH38ayMX7QD bWXYCMw1w0ZgHvxdkrXSEQDM1urKalaXV0pnzLt/Gg0XrUsBWmrjtMavLt0xY/ubpl4qHUH/NU29 M0ldumPKLigdMCPXJJnHbyx+vKoGC6UjSquqwalJfrh0RwHXeryE6Wuaen/m8zRxjzH39t1JtpSO mKG2nYZtNEbbnVNVg88rHQFQimEj0Huj4eJtSd5RugOA2Tp8wHMwLfC3pQMAuH9VNdiU5LdLdxRw TekA5spFpQOm7BlVNTirdMS0NU29nOSq0h0FfEGSrysd0QLfm+RRpSMK+GjpAJgjV5QOKOBp8RiT JKmqwUlJ/mvpjhm7rnTAfZxfOgCOggEuMLcMG4F58delAwCYrcMHD5dOmHd7k7y5dAQAR/RDGV+5 NW+uKR3AXLmwdMCUbUry/NIRMzKPo5Mk+bWqGmwtHVFKVQ3OTPKy0h2FXFk6AObIvP5++5WqGszT KYVH8h+TPKZ0xIzdUDrgblU12JzkuaU74Cg8r3QAQCmGjcC8+IfSAQDM1uGDTmws7A2j4aJ/CQAt VFWDJyf5ldIdhVxTOoC5cmmS5dIRUzYv11HP67DxSUl+sHREQT+X5JzSEYU4sRFm5/LSAYU8OfP9 GJOqGpya5H+U7ijg6tIB91AleWjpCDgKTmwE5pZhIzAXRsPF65O8u3QHALOxtraW5UNObCzsdaUD APh0VTU4PcnfJjm1dEshbXoSjZ5rmvpAkneU7piyF5QOmJEPlw4o6BeqavCE0hGzVlWDZ2V8uvG8 +kjpAJgj8zqeT5L/VVWDzyodUdCPJHlc6YgC2jTmNRajKz6nqgbzdrorQBLDRmC+vKZ0AACzcXj/ UrJeumKu7UnyhtIRANzbxjVbf5HkKaVbCprncRJlXFQ6YMqeXFWDzywdMQPvLR1Q0OlJXlVVg7l5 LmHjBK0/TbK5dEshq0neXzoC5khdOqCghyT5o6oaLJQOmbWqGnxOkp8t3VHAUtp1ir7rfekSQ1xg Ls3NDyMAkvxVkrXSEQBM36F9B0snzLu/Hw0X/UsAaJGNJwt/L8nXlm4p7EOlA5g7fR82JvNxauPH Mn7xzrx6fpKXlY6Yof+b+X4RQNM0te/nYEaapr4xyc2lOwq6IMlPlY6YpY0XnL06ySmlWwq4omnq Nj1Pd37pADgGho3AXDJsBObGaLh4a5ILS3cAMH1L+w6VTph3TkkGaJGNUePvJvm+0i2F3d409Tw/ aUwZ70myt3TElPV+2Ng09XqSfyvdUdj/qqrBV5WOmLaqGrw0yfeW7ihs3n+tQwnz/vvul6pq8MLS ETP080nOLR1RyEdLB9ytqgafm+RRpTvgGDhhFJhLho3AvHlt6QAApmt5aTmrK6ulM+bZbZmPk4kA OqGqBicleVWS/1q6pQU+WDqA+dM09UqSt5fumLLeDxs3zPN11Mn4uYTXVtXg6aVDpqWqBhdkfLrx vJv3gRWU8J7SAYVtSvLXVTV4WumQaauqwTdmPq+gvlubvp4yEqNrnlZVgzNLRwDMmmEjMG/+Polj vAB67NCeA6UT5t1fjYaLlqUALVBVg3OSvCnJSwqntMVlpQOYW32/PeIzq2rw5NIRM3Bx6YAWeEiS t1TV4EmlQyatqgbPTvJPSbaWbmmBt5YOgDn0ztIBLfDQJBdunKLXS1U1OC/Jn5fuKOzdpQPuwbW+ dM1C5ve0V2COGTYCc2U0XNyd5PWlOwCYnoN7DpZOmHfz/gNagFaoqsH5Seokzy+c0iaXlA5gbs3D adbzcGrjJUmWS0e0wMOTXFpVg6p0yKRU1WB7kjcnObV0Swtc1zT1VaUjYA69I8lS6YgWOCfJ2/r0 GHO3qhp8aZJ/TnJK6ZaCVjP+HrUtnNhIF51fOgBg1gwbgXn0x6UDAJiOlaXlrBz2XGNBl4+Gi/N+ fRJAUVU1OL2qBv8n45PFPrNwTpssx0k4lPPhJLeVjpiy3g8bm6ben3adMlTSOUnevjHS6LSqGrw4 yb9kfFIY8zHE7qKHlA5gupqmPpTk0tIdLfGYJBdX1eD5hTsmpqoG3xCPNUny4Y2vp4qrqsEjk/Tu BGrmgkEuMHcMG4F59OYkN5WOAGDyDrqGujQvHgDaZK6eNKqqwUJVDb41yRVJfiTjK4r4lPc2Te0L BYpomno9/R8LPb+qBptLR8xA3/89HouzkrypqgY/UDrkeFTVYHNVDX4pyV9mvk/Pui+/xtvpYVU1 eHjpCKbO779PeViSN3f1MeZuVTXYVFWDn0vyujgVOEneXjrgHlxDTVc9q6oGvnYF5ophIzB3RsPF 1SSvLt0BwOQd2G2vUNBKXEMNtMtTSwfMwsaTZd+Q5P1JXpvksYWT2uqfSwcw94alA6bs7CSD0hEz 8MbSAS2zNcnvVtXg76pqcE7pmKNVVYMnJHlrkp8p3dIyaxm/IJx2+orSAUzdW0oHtMzdjzF/26XH mLttPNZclOTn4/n4u11YOuAenHpHV52c5AtLRwDMki+kgHnlRCmAnlnafyiryyulM+bZv46Gi7eU jgC4h2dW1eCzS0dMS1UNzqmqwY8kuTLJ3yZ5etmi1nt96QDmXpueyJ2WC0oHzMC74xaQ+/P1SS6v qsF3VNWgtScGV9Vga1UNfjRJEyc13Z+3N019e+kIjuhlVTU4rXQEU/W+JDeWjmihb8j4MeY72/wY c7eqGpxUVYOfyPix5vmFc9pkNcnFpSPuwdcBdJlfv8BcMWwE5tJouPixJJeV7gBgcg7s2l86Yd69 qnQAwH1sSvLrpSMmqaoGn1NVg++vqsEbMh7W/J8kn1s4qwuubZq6KR3BfGua+poknyjdMWW9HzZu XCv+d6U7WurhGZ/gfmlVDZ5fNuXeNk43/tYkH07yG0lOL5zUVn5tt9uTk/xtVQ3OLh3CdGw8xvx9 6Y6WeniSP0vyzrY9xtytqgZbqmrwkiSXJ3l5PNbc17ubpt5TOiJJqmpwRrwwkG47v3QAwCxtKR0A UNAfJjm3dAQAJ25tdS2H9h4snTHPbk3yL6UjAO7HN1fV4A+T/PemqfeWjjkWGyfyVBlf7fr0JNuT bCvZ1GGGGrTFRUk+p3TEFJ1bVYNTmqY+VDpkyv4hyQ+Ujmix5yZ5a1UN3p7xAP+fm6ZeKxGy8Vj6 HUn+e5LPL9HQMQZV7feiJJ+oqsGfJnl7xi906fvn3BO1nOSuJDdvDAfb7u/iMeaBPDvjx5hLk/xm kn9qmnq1ZFBVDR6V5D9m/O/tsSVbWu6NpQPu4dw4/Ilue05VDTaX/vwHMCuGjcA8++uMv/n1KleA jjuwe3/W17vw8+neeuVouLhcOgLgCP5zkm+qqsE/ZXy9251J9pVNypYkZyQ5KclpSU5Jck6Sz0zy uCSPSfJZ8WTLpPxZ6QDYcGGS/1I6YopOSfKcJG8tHTJlFye5LckjCne03fkbb9dX1eDPkvxV09Qf mvYHrarB1oyv5/vWJC9O8tBpf8yeeGfT1DeUjuConJXkv228cfR2VtXg9Ul+sWnqj5eOeQBvT3J7 xt8bcGTP23i7qaoGf57kr5LUsxqvVtXgnCRfk+Trk7wwnm8/Gq8rHXAPrvGl6x6a8QthP1C4A2Am fKEFzK3RcPHAtu07Xh0/BALovP07S+9T5tpakleWjgB4EGcm+a6NN+bLh5umrktHwIa+D/6S5AXp +T9n09SrGyOKHynd0hGPS/KyJC+rqsE1Sd6c8Tj0PZMYF1XV4OQkT8v4FK/nZ3zCsRcxH7tXlQ6A KXtYxqfqfX1VDV7UNPU7Swfdn43HmL9M8oOlWzriMUl+YuPthqoavCXjr0P+LcnHJnFi8MZg/vOT PDPj0/TPS/IFSRZO9H3PkQ83TX1F6Yh7eF7pAJiA82LYCMwJw0Zg3u2IYSNApx3ccyCryyulM+bZ G0bDxetKRwDAEby6dADcrWnq26tq8MGMnwzvqwuS/GzpiBn44xg2Ho/HJ3npxluqarA7yUeTjJLc kOTGJPuT7M34et39STYneUiS05OcnOThGQ9ZPjvJk5JsS7J1hv8MfXQg49POYB48NMlrq2rwpKap D5eOOYI/imHj8Xhskv+08ZYk+6pqcGWSjyW5LuOr2/dk/NiytPHnyfgxZnPGp6GelPEp+o/JeJj/ 2IwfZ06ayT9Bf/196YC7VdXgpIxfDAFdd16S3y0dATALho3AXBsNF6/ctn3HxRm/ohuADtq3c2/p hHm3o3QAABzBUpI/LR0B93FR+j1s/MKqGpzZNPXu0iHT1DT1h6tq8N4kzyrd0nFnJvnijTfK+Zum qX1jzTz57CT/PsnflQ65P01Tf7CqBu9P8ozSLR13RsanLD6zdAh5bemAe3hWklNKR8AEnF86AGBW NpUOAGgBgwyAjjp8YCnLB9v6Avu5cE2SN5aOAIAjeE3T1LeVjoD7uKh0wJRtyvy8ePQPSwfAhPxB 6QAooO2DkD8uHQAT8o6mqT9aOuIezisdABPyyKoafG7pCIBZMGwEGL8y88bSEQAcu7137nnwv4hp +v3RcHGtdAQAHMFvlQ6A+/H2JMulI6bsBaUDZuTPkuwsHQEn6L1NU19WOgIKeHTpgAfxp/nUVcnQ ZW17IYhhI33yvNIBALNg2AjMvdFwcSXJ75XuAODYHD6wlKV9h0pnzLP9ad8PJwHgbsOmqT9UOgLu q2nqfUneU7pjyuZi2Ng09YEkryjdASfoN0oHQCEnlw54IBvXw7+ydAecoL1J/rp0xN2qarApyXNL d8AEGeoCc8GwEWDsD5IcLB0BwNHbe/vu0gnz7k9Gw8VdpSMA4Ah+sXQAPIALSwdM2VOqatD2k7Am 5ffS/xM46a/rkvxt6QjgiH47yWrpCDgBr26aen/piHv4d0nOLh0BE2TYCMwFw0aAJKPh4s6MrxAC oAMOH1jK0oGl0hnzbD3J75aOAIAjeHPT1BeXjoAHcFHpgBmYl1Mbb07y56U74Dj9ZtPUK6UjgPvX NPX1Sf6qdAccp7Ukv1k64j6MwOibbVU1eFTpCIBpM2wE+JTfLh0AwNHZc9uu0gnz7l9Hw8UrS0cA wBH8XOkAeBDvTtKm02umYS6GjRv+V5zaSPdcn+T/lY4AHtQvZzwQg67526apP1E64j4MG+mj55UO AJg2w0aADaPh4uVJ3li6A4AHdnD3gRw+eLh0xrz7rdIBAHAEf9c09btKR8ADaZr6cJK3l+6YsrkZ NjZNfW2SV5XugGP0K01THyodATywpqkvj5um6KZfLx1wPwwb6SO/roHeM2wEuLf/XToAgCNbX1t3 WmN57x8NF99SOgIA7sehJD9aOgKO0rB0wJQ9rqoG20pHzNAvZvw5CLrg40n+sHQEcNR+MU4Gplve 0DT1v5WOuKeqGjw+yWeW7oApcGIj0HuGjQD3MBouvjXJe0p3AHD/9t25J6srq6Uz5t3LSwcAwBG8 vGnqa0pHwFG6sHTADFxQOmBWmqa+McnvlO6Ao/QzTVOvlI4Ajk7T1B9P8srSHXCU1pP8TOmI++FU O/rq6VU1eEjpCIBp2lI6AKCF/neSvykdAcC9rS6vZN+de0tnzLuPx2MkAO10VYzv6ZYPJbkjycNL h0zRC5LsKB0xQ7+U5LuSPLp0CDyAtzZN/VelI4Bj9j+TfFuSs0uHwIN4bdPUHygdcT/mZdh4U5I3 J7k8ye1Jdmc8Np0nZyd5TJLnJHlh+r+H2ZTk3CRvLB0CMC19/0QOcDz+PsnHkjypdAgAn7Lr5ruy vj5vP4dpnV8fDRfXSkcAwH2sJ/nupqkPlg6Bo9U09VpVDd6a5JtLt0zR9qoabGqaei6+fmyaem9V DX48yZ+XboEjWE3yg6UjgGPXNPWdVTV4WebrBQN0z+EkP1c64gj6Pmy8OckPJ/nbpqldd7Shqgaf meQ3k3xL6ZYpe14MG4EecxU1wH1sDDZ+vXQHAJ9yYPf+LO0/VDpj3t2S5E9LRwDA/fidpqkvKR0B x6Hv11GfnWRQOmLGXpPkstIRcAS/0zT1R0pHAMftD5K8v3QEPIDfaJr6qtIR91VVg3OSPLl0xxRd leQZTVP/tVHjvTVNfWPT1C9O8j9Kt0xZ34e7wJwzbAS4f69Ocn3pCACStZXV7Ll1V+kMkv8zGi5a lwLQNqMkLysdAcdpWDpgBraXDpilpqnXk3xPkqXSLXAf12R8lS3QURsnIH9vxqevQttck+SXSkcc wbmlA6ZoPcl3NU19S+mQNmua+peS/EXpjin6oqoanFQ6AmBaDBsB7sdouHg4ya+U7gAg2XXLXVlb nYvb69rsziSvKB0BAPdxKMk3N019oHQIHI+NE22uLd0xZReUDpi1pqmvSP9PhaFb1pP8h6ap95UO AU5M09TvTfLy0h1wP36gaeqDpSOOoM+n2b2paep3lY7oiB9Ksrt0xJSckuRZpSMApsWwEeDIXhWn NgIUdWDX/hza29afic2V3xgNFz0JBkDb/GDT1B8sHQEn6KLSAVN23pyeHvKbSd5dOgI2/E7T1JeU jgAm5heS+BqYNvnrpqn/pXTEA+jzsPFvSgd0RdPUO5P8bumOKTq/dADAtBg2AhyBUxsBylo5vJLd t95VOoPxaY2/VzoCAO7jT5um/sPSETABfR82nprkuaUjZq1p6tUk/zHJ/tItzL3Lk7ysdAQwOU1T LyV5SZLlwimQJDclWSwdcSRVNTgjyTNKd0zRe0oHdMwflQ6YoueVDgCYFsNGgAf2qiQ3lI4AmDvr ya6b7sz62nrpEpzWCED7vCPJ95WOgAnp+7AxSV5QOqCEpqmvTPK9pTuYa/uTfFPT1AdKhwCT1TT1 B5L8SOkOSPKSjZPw2uqLk2wuHTEldyX5SOmILmma+pokV5XumJJzq2pg+wP0kk9uAA9g49TG/126 A2De7LltVw4fPFw6A6c1AtA+1yT5+qapD5UOgUlomvrW9P8JybkcNiZJ09R/keT/le5gbr20aeqP lo4ApqNp6t9L8lelO5hrv9U09VtKRzyIPp9i9/amqddKR3TQpaUDpuSsJE8tHQEwDYaNAA/u/2X8 5BkAM3Bwz4Hs27m3dAZjv+y0RgBaZHeSr2ya+rbSITBhF5YOmLIvqqrBQ0tHFPTDST5QuIH5s6Np 6teUjgCm7r8kubJ0BHPpsiQ/WTriKJxXOmCKLi4d0FF9HTYm/R7yAnPMsBHgQWyc2vjzpTsA5sHK 0nJ23dzm20vmyvVJdpSOAIANB5O8yMlT9FTfr6PenORLSkeUsnHC7NcmuaV0C3NjmPGgFui5pqn3 Jvn6jF8ABLNyS5Jvbpq61dftVNVgS5LnlO6YootLB3TUZaUDpuj80gEA02DYCHB0/iyJJ9AApmh9 bS07b7gj62vrpVMY+1+j4aJrPgFog4NJ/n3T1O8qHQJT8rYkq6Ujpmxur6NOkqapr0vy1Rl/PoNp uiLJN7Z9bAJMzsYLf74+yXLpFubCcpJvapr65tIhR+FZSU4tHTEldyX5UOmILmqa+ookd5TumBIn NgK9ZNgIcBRGw8W1JC8r3QHQW+vJzhvuzMrhldIljH0syZ+WjgCAjJ84e3HT1MPSITAtTVPvSfKe 0h1TNtfDxiRpmvq9Sb6zdAe9dnuSr2yaelfpEGC2mqZ+a5KXlu5gLnx309RdOfGuzyOvtzdNvVY6 osP6eh31Z1bV4AmlIwAmzbAR4Oj9Y/r/RANAEbtu2Zml/Q4HbJGfHQ0XrUwBKO1gkq9pmvr1pUNg Bvo+3n1qVQ0eWTqitKap/y7JD5TuoJf2ZHy68dWlQ4Aymqb+kyS/WLqDXvvJpqn/vHTEMejzsPHi 0gEd19dhY5KcVzoAYNIMGwGO0mi4uJ7kx0p3APTNvjv35MCu/aUz+JT3JPmb0hEAzL09Sb68aeo3 lg6BGbmwdMAMzP2pjUnSNPXvJ/np0h30ysEkX9E0tRdkw5xrmvp/Jnl56Q566Xeapv7fpSOOVlUN FmLYyJF15dTR49HnX/fAnDJsBDgGo+HiJUn+oXQHQF8c3H0ge27bXTqDe/vRjTE/AJRyW5IvbZq6 z6cowH29M+NxUp8ZNm5omvrXkvxq6Q564WDGJzW+o3QI0Bo/neQVpSPolVck+eHSEcfo85N8RumI KbkryYdKR3Tc+9Lf773OLx0AMGmGjQDH7ieTLJeOAOi6Q3sP5q6b7iydwb397Wi4aEQCQEkfSfLs pqnfXzoEZqlp6qX0+0q0xLDxXpqmflmcqsWJOZjka5um7vtV9sAxaJp6Pcn3x7iRyXhFku/f+HXV JX0ed729aeq10hFd1jT1cpJ3l+6Yks+rqsE5pSMAJsmwEeAYjYaLH0uyo3QHQJct7TuUu240amyZ 5YzH+wBQyhuTPLdp6mtKh0Ahfb+O+rOravC5pSPapGnqn0rystIddNKeJBc0Tf2W0iFA+9xj3Pgb pVvotK6OGpN+X8d7cemAnujzi8r6/OsfmEOGjQDH5xeS7CodAdBFSweWsvPGO7K+3sWfifXa746G ix8vHQHA3PqtjK/S3FM6BAqah1PXnNp4H01T/2rG4xM4WrclOc/108ADaZp6vWnqH48BPcfnf6e7 o8ak38Oui0sH9MRlpQOm6LzSAQCTZNgIcBxGw8U7Mx43AnAMlvYfys7rb8/6Wld/JtZbdyT5pdIR AMylPUm+qWnq/9409WrpGCjs/UnuKh0xZReUDmijpql3JHlxkqXSLbTelRmfbvyh0iFAN2wM6P9L El9rczTWkvy3pql/squjxqoaPC7JZ5fumJK7kvgaYDLekfGv9z4ybAR6xbAR4Pj9bpLLS0cAdMWh fQez8/o7jBrb6WWj4WLfn0QHoH0+lORZTVP/bekQaIOmqdeSvLV0x5Q9v6oGfiZ9P5qm/uskz8/4 ND64PxcleU7T1E7aB45J09R/mORFcQsVD+xQkhc3Tf07pUNOUJ9HXW/f+J6BE7RxW0RfR6KDqhqc UToCYFL8EAngOI2GiytJfrB0B0AXHNxzYDxqdP10G70vyR+VjgBgrqxnfPX0s5umHhVugba5qHTA lD08ydNKR7RV09TvSvJFST5cuoXWeUWSFzVN7QVpwHFpmvrCJF+cxNff3J/rkjyvaeq/KR0yAeeX Dpiii0sH9Exfr6PenPHne4BeMGwEOAGj4eIwSR++0QOYmn079+auG+8sncGR/cBouOiVvgDMyvVJ XrBx9fSh0jHQQheWDpgB11E/gKapr03y3CSvK91CKywleWnT1ItNU6+UjgG6rWnqKzMeu7yxdAut MkzyzKap31c6ZEKeVzpgii4uHdAzl5YOmKI+n1wKzBnDRoAT96NJDpaOAGij3bfclT237iqdwZH9 yWi4+K7SEQDMjT9KUjVN3ferduG4NU39sSQ3lu6YsheUDmi7pqn3Nk39LUl+KMly6R6KuSrJFzdN /crSIUB/NE29M8lXJvnpJKuFcyhrPcn/TvLlTVPfUTpmEqpq8LAkTyndMSV3pb9XJ5dySemAKTJs BHrDsBHgBI2Gi9cl+eXSHQBtsr62np3X35H9d+0rncKR7U7yU6UjAJgLlyc5r2nq72maenfpGOiA vp/aeH5VDU4qHdEFTVP/bsanDl1buoWZ+5skz2ia+gOlQ4D+aZp6vWnqX0vy/CQ3F86hjJszHjT+ ZNPUfRq4nptkoXTElLy9aWq37kxQ09Q3JrmmdMeUfHFVDbaWjgCYBMNGgMn49SQfLR0B0AYrh1dy xzW35tA+h9m23E+Nhou3lo4AoNf2J3lZkqc3Td3nK55g0i4qHTBlp2V8DSZHoWnq9yR5WpI/Lt3C TOxO8p1NU39z09R7S8cA/bbxNXqV5LWlW5ipf0rytKap+/himj6fUndx6YCeuqx0wJScmuSZpSMA JsGwEWACRsPFw0m+t3QHQGmH9h3MHdfcmuUlt6W13DuT/EHpCAB6ay3ja6e3NU39q01T+8IAjk3f h42J66iPSdPUe5qm/u4kX5PEi5P6641J/l3T1H9ROgSYH01T39k09bcn+ZYkvbiOmCPameQ/NE39 tX25evp+nF86YIouLh3QU31+EebzSgcATIJhI8CEjIaLl8Sr54E5tvf23dl5/R1ZW3UjRsutJvne 0XDRvygApuFfMz6h8XuapnatHRyHpqlvSv9vhTBsPA5NU78+yVOT/GnpFibqziTfneQrN65EBJi5 pqlfl/FjzF+VbmEq/jLJk5um/rPSIdNSVYPTkjyjdMeU3JXkQ6UjeuqS0gFT1OcTTIE5YtgIMFk/ Hq9qBObM6spq7rz2tuy9Y0/pFI7Ob46Gi03pCAB6501JntM09Vc2Te1xBk5c309tfHZVDc4oHdFF TVPf0TT1S5J8SZLLC+dwYtaTvDLJk5qm/uOmqddLBwHzrWnqW5um/tYkX5bkytI9TMTHknxV09Tf 1jT17aVjpuzZSbaWjpiStzdN7UXq03F5xsPRPnpeVQ0WSkcAnCjDRoAJGg0X70zyo6U7AGbl0N6D uf0Tt2TpwFLpFI7ONUl+vnADAP3yhowHjS9qmvpdpWOgR/o+bNyS8TCP49Q09duTPD3JTyTZXbaG 4/BvSZ7bNPVLm6beWToG4J6apr4wydOSvCzJ/sI5HJ/dGT9X9dSmqd9QOmZG+nzt7sWlA/pq44Ul 7yjdMSUPS/KU0hEAJ8qwEWDCRsPFV2f85B5Ab62vrWfXzTuz8wZXT3fM94yGiwdKRwDQeQeSvCLJ 5zdN/VUGjTAVFyfp+xfarqM+QU1TLzdN/etJPjfJbydZLpzEg7sqybckebbHT6DNmqY+3DT1ryb5 nCS/H48xXbGc5HczPg34N5umnqd/b32+dvfi0gE9d2npgCnq8+8LYE4YNgJMx2KSvaUjAKbh0N6D ue3jN+fALi/Y7pg/HA0X+37yDwDTNcr4ZLDHNU292DT1FaWDoK+apt6V5H2lO6bs2aUD+mLjeuof TvLkJK/N+Ipj2uWWJD+Q5ClNU7/OtdNAVzRNfVvT1D+Q8alffxmPMW21kuT/Jfncpql/qGnq20oH zVJVDbYkeW7pjim5K8mHSkf03CWlA6aozyeZAnPCsBFgCkbDxeviSmqgZ9ZWVnPXjXdm5w13ZHVl tXQOx+b6eFwC4PgcSPInSc5P8nlNU/+6KzNhZi4sHTBl/650QN80Tf2Jpqm/PcmTMv7cPU+nNLXV 1Rm/APqzm6b+/Tk7OQvokaapr2qa+tsyHjj+acZDOso7lOSVGZ+m/31NU19XOqiQpyU5vXTElLy9 aeq+n+Re2vuSLJWOmJJzSwcAnCjDRoDp+cMkw9IRAJOwf+e+3PaJW3Jwj1uMO2pxNFzcUzoCgM44 lOTvknxbkkc2Tf2fmqa+xOlSTJgnwx/cW0oHTNmZVTXo6xPQRW2MT/5TxldU/36SfYWT5tEHk/yH jK8CfUXT1IdLB/WYr09ghpqmvqJp6pckeWLGjzGudCnjziS/kOSzmqZ+adPUV5UOKuyppQOm6K2l A/quaepDSd5dumNKHl9VgzNKRwCciC2lAwD6ajRcXN+2fcf3JGnS31eKAT23tP9Qdt+6KytLDpXo sD8dDRf/pXQE0CqGztyfXUnenOSfkvxj09RGMGXtLh0wA3eVDuiAtye5Pck5pUOmyM+np2jj1KYf qKrBy5K8JMn3J/m8olH9tpzxCwN+r2nqS0vHzBGPJxwPX+ueoPt5jFlM8uSiUfPhnRkfqvHapqkP lo5pkceUDpiS9Yy/tmD6/ibjmyr66DFJPlY6AuB4ObERYIpGw8Wrk/xI6Q6AY7WytJyd19+RO6+7 3aix265P8sOlI4B22bjC6BOlOyhuLePrln45yXlJHt409Yubpv4Lo8ZWmIcnHUalA9quaerVJH9c umOK9jRNPQ8j3uKapt7TNPXvJPn8JF+e5LVJjCEm54okP5PxddPfatQ4cx5POB7z8LXWTNzjMeYp Sb4sHmOm4a4kv5fkaU1TP7dp6lcZNX6avaUDpuSfmqa+vnTEnPiL9PcFhodKBwCcCK+IBZiy0XDx D7Zt3/E1Sb6qdAvAg1k5vJK9t+925XR/vGQ0XNxVOgJopX9N8l9LRzBThzIeMl6S5G1J3tE0tdM7 2+uNSb6pdMSUvaF0QEf8ZpKXJjmrcMc0vLF0wLxpmno94yvO31JVg4cm+caMr0v+kiQLJds66PYk f5Xk1U1T/1vpmDn3xiQ/UTqCzvnX0gF9s/EYc2GSC6tq8JCMH2O+K8mXxmPM8diX5B8yfqx5U9PU Xnn+wN5ZOmAKDiT56dIR86Jp6p1VNfhfGX//1Se3JrmhdATAiVhYX18v3QBwzBYWuvV98LbtOx6V 8ZXUDy/d0kUnn3ZyPuOzH1E6A3pt5fBK9t2xJwf27B9fcEEf/NZouPjfS0cA7VRVgyck+VCSM0q3 MBV3Jflokg9kPGZ8b5LLm6ZeKRnF0auqwSkZ/x7dVrplSi5qmvqC0hFdUVWDb8n4Se0+OZjkWU1T X146hKSqBo9K8jVJvi7JC5KcVDSova7JeGTyD0ku3ThVlRaoqsHFGQ904Wi8oWlqhxDMSFUNHpnk q/Opx5hTiga1260Zv/jn9Une6FTGY1NVg79M8uLSHROynOQ7m6b+69Ih86SqBgtJXp3kO0u3TND3 N029wyYI6DLDRqCTujZsTJJt23d8Q5K/Ld3RRYaNMD2HDy5l3517c2ivn5P1zEeTPGM0XHTNBHBE VTV4QZLXJTm7dAvH5fYk1268XZfxdXpXJPlo09S3lgxjMqpq8KSMn9R8UumWCXtHkq9rmvr20iFd UlWD70jyivRjkH5Dku9omvrtpUP4dBsnOX55xteJviDJE8sWFXUoyaUZn0D2pqapP1A2hyOpqsEj kvxjki8u3ULrvS3JNzZNfWfpkHlUVYMzMn58+bIkF6S/L+I5WstJ3pPx48y/JHnvxsmXHIeNF4f9 n4xPO+/yrZWjJC9tmvri0iHzaGPc+ONJfj7JqWVrTsiBJD/bNPX/TRKbIKDLDBuBTurisDFJtm3f 8SdJ/mPpjq4xbITJWl9fz6G9B7N/594cPni4dA6Tt5zk2aPhYl06BGi/qhqcneQlSZ6f5HEZjxy7 +cV29+xLcs8TFPdm/Dl8z8af79t425nkjoxP77h948+vb5raeH0OVNXgpCTfluRFGY+Lzk6ytWjU sVvK+BTRy5P8U5J/app6rWxSN1XV4NEZ/0xhkORhST4jyaaN//mh9/jzttmd8eeyK5MMM/414HNY R1TV4PEZj0+el+TZSZ5cNGi69iZ5d5J3JXlrknf4tdodVTXYlORrMz4Z7ikZP2aeXDSKNjiU8dch H87465B/8XVIe1TV4LEZP8acl/Ew+fPT7+9H92R8mv4lSd6e5F1NUx8om9Q/G6eEfkOSZyX5nIwf Dx6SZHPJrgewJ+OvlZsk/5rxiymcCl3Yxs/LXpzx56cnJjkr7T1xdi3jX0e7Mh7GvivJ65qm3nP3 X2ATBHSZYSPQSR0eNj4kyfuTfG7pli4xbITJWDm8kgO79uXA7gNZW/GzkR778dFw8TdKRwAAAP1T VYOzMh44flGSpyWpMv45V1vHAkdyV5IPJflIxj+re2eSKwyeAMqpqsFDcu/HmKcm+bx08/S9WzN+ Yc8Hkrxv4+1jHmeAEmyCgC4zbAQ6qavDxiTZtn3HMzP+YWnXTtkoxrARjt/a6loO7T2YA7v35/CB pdI5TN+bknzFaLjoi3wAAGAmNq5+fHLGp+R9zsbbEzb++NiUO010T5JPJLn6Hn/8WJIPN019c6Em AI5BVQ22ZjxufErGQ/rH51OPM5+VcqPH9SQ3JbkmybUbbx9PckWSjzRNvatQF8CnsQkCusywEeik Lg8bk2Tb9h0/msRpWkfJsBGOzd1jxoN7D+Tw/iXftM6PW5M8bTRcvK10CAAAQPLJ64HPSfKIJI++ x5+fmfEV6g/Z+OPJG//d3T/0OynJaUlWM74i+m4HM77iftfGf783n7p679YktyS5LcnNrvcE6L+q GpyT8WPLozN+fDknn7p6+O6303Lvq4g3b/znJNmd8Ugx+dR1rgeS7Nt427Px19yW5I6MH2tuS3J7 09TLU/xHA5gYzxEBXWbYCHRSD4aNC0n+NckLS7d0gWEjPLjlQ4dzaN+hLO0/lMMHlz714zjmyQtH w8U3l44AAAAAAADawSYI6DLDRqCTuj5sTJJt23c8IskHMn4lIQ/AsBE+3fKh5Rw+uJTDB5aydGAp ayurpZMo6+Wj4eJPlY4AAAAAAADawyYI6LItpQMA5tVouHjbtu07vi3JRfnUFQgA97aeLB9ezsqh 5SwvHf7koHF9zTeifNIlSX62dAQAAAAAAADApDixEeikPpzYeLdt23f8RJKXl+5oMyc20mfr6+tZ W1nL2upqVpdXs7q8kpW7/3h4JauHV7yajgdya5JnjIaLN5UOAQAAAAAA2sVzTECXObERoLxfT3Ju kq8pHdJWy0vL2XnDHaUz4Litr68nGycsrq2tJ1nP2upa1lbWfEPJiVhL8u1GjQAAAAAAAEDfOLER 6KQ+ndiYJNu27zg7yfuSPKF0CwCd8TOj4eKvlI4AAAAAAADaySYI6LJNpQMASEbDxbuSfFOSQ6Vb AOiEf0nyq6UjAAAAAAAAAKbBsBGgJUbDxfcn+S+lOwBovSszvoLayywBAAAAAACAXjJsBGiR0XDx z5P8ZukOAFprb5KvGw0X95QOAQAAAAAAAJgWw0aA9vmJJMPSEQC0znqS7xgNF68oHQIAAAAAAAAw TYaNAC0zGi6uJvmWJFeXbgGgVX5uNFx8fekIAAAAAAAAgGkzbARoodFw8c4kX5tkX+kWAFrhdUl+ qXQEAAAAAAAAwCwYNgK01Gi42CT51iRrpVsAKOrfkrxkNFxcLx0CAAAAAAAAMAuGjQAtNhou/kuS HyndAUAx1yf5mtFw8UDpEAAAAAAAAIBZMWwEaLnRcPG3k7yidAcAM7c/41HjLaVDAAAAAAAAAGbJ sBGgG34wyVtKRwAwM2tJvm00XPxA6RAAAAAAAACAWTNsBOiA0XBxJck3J/lg6RYAZuKHRsPF15eO AAAAAAAAACjBsBGgI0bDxd1JvirJ9aVbAJiqXxsNF3+/dAQAAAAAAABAKYaNAB0yGi7emORFSXYV TgFgOv48yctKRwAAAAAAAACUtLC+vl66AeCYLSwslE4oatv2HecleUuSk0u3ADAxFyb5qtFw8XDp EAAAAAAAoPtsgoAuc2IjQAeNhouXJPnOJGulWwCYiDrJNxk1AgAAAAAAABg2AnTWaLj4N0leWroD gBM2SvLC0XBxd+kQAAAAAAAAgDYwbATosNFw8Y+S/HjpDgCO241Jto+Gi7eXDgEAAAAAAABoC8NG gI4bDRd/I8mvlu4A4JjdkeQFo+HiDaVDAAAAAAAAANrEsBGgH34myStKRwBw1PYkedFouHhl6RAA AAAAAACAtllYX18v3QBwzBYWFkontM627TsWkrw6yXeWbgHgAe1N8mWj4eK7S4cAAAAAAAD9ZRME dJkTGwF6YjRcXE/ykiSvKZwCwJEdTPJ1Ro0AAAAAAAAAR2bYCNAjo+HiapL/kOSvSrcA8GkOJvn3 o+HisHQIAAAAAAAAQJsZNgL0zD3Gja8v3QLAJy1nfFKjUSMAAAAAAADAgzBsBOih0XDxcJJvinEj QBscTPKNo+Him0uHAAAAAAAAAHSBYSNAT91j3PjXpVsA5tjd108bmgMAAAAAAAAcJcNGgB7bGDd+ e5LXlG4BmEN3jxpdPw0AAAAAAABwDAwbAXpuNFxcTfIfYtwIMEt7krzQqBEAAAAAAADg2Bk2AsyB e4wbX1G6BWAO7Ery5aPh4iWlQwAAAAAAAAC6yLARYE5sjBu/P8nLS7cA9NjNSc4fDRffXToEAAAA AAAAoKsW1tfXSzcAHLOFhYXSCZ22bfuOn4iBI8CkfSLj66evKh0CAAAAAABgEwR0mWEj0EmGjSdu 2/YdL02yI07vBZiEDyf5itFw8YbSIQAAAAAAAIlhI9Btho1AJxk2Tsa27Tu+JcmfJ9laugWgw96Z 5KtHw8U7S4cAAAAAAADczSYI6DKndAHMsdFw8a+TfFmS3aVbADrqH5NcYNQIAAAAAAAAMDmGjQBz bjRcfFuSc5O4PhXg2LwiyTeOhosHSocAAAAAAAAA9ImrqIFOchX15G3bvuOxSd6QpCrdAtABPzsa Lv5y6QgAAAAAAIAjsQkCusywEegkw8bp2LZ9x5lJ/i7J9tItAC21nOR7RsPFV5cOAQAAAAAAeCA2 QUCXuYoagE8aDRd3J3lRkleWbgFooZ1JLjBqBAAAAAAAAJguJzYCneTExunbtn3HjyV5eYzgAZLk yiT/fjRcvKp0CAAAAAAAwNGwCQK6zLAR6CTDxtnYtn3H1yR5TZLTS7cAFDRM8k2j4eJdpUMAAAAA AACOlk0Q0GVO4QLgiEbDxX9K8rwk15VuASjkFUleZNQIAAAAAAAAMDtObAQ6yYmNs7Vt+45zkvx1 kucXTgGYleUkPzAaLv5B6RAAAAAAAIDjYRMEdJkTGwF4UKPh4u1JvizJ75VuAZiBW5M836gRAAAA AAAAoAwnNgKd5MTGcrZt3/GSJP8vyUmFUwCm4T1JvmE0XLyxdAgAAAAAAMCJsAkCusyJjQAck9Fw 8U+SnJfkusIpAJP2yiRfYtQIAAAAAAAAUJYTG4FOcmJjedu273hYkr9I8qLSLQAn6ECS7x8NF/+0 dAgAAAAAAMCk2AQBXebERgCOy2i4uDPJVyb5n0nWCucAHK9Rki82agQAAAAAAABoDyc2Ap3kxMZ2 2bZ9xwVJXpPknNItAMfgb5P8p9FwcW/pEAAAAAAAgEmzCQK6zLAR6CTDxvbZtn3Ho5P8WZIXlG4B eBBLSf77aLi4o3QIAAAAAADAtNgEAV3mKmoAJmI0XLw5yZcneVmS1cI5AEdyeZIvNGoEAAAAAAAA aC8nNgKd5MTGdtu2fcdzMr6a+vGFUwDu6ZVJ/ttouHiwdAgAAAAAAMC02QQBXWbYCHSSYWP7bdu+ 48wkr0jyraVbgLm3M8n3jYaLrysdAgAAAAAAMCs2QUCXGTYCnWTY2B3btu/41iQ7kpxVOAWYT29K 8p9Hw8UbS4cAAAAAAADMkk0Q0GWbSgcA0G+j4eJfJnlqkgtLtwBz5WCS/5rkK4waAQAAAAAAALrF iY1AJzmxsXu2bd+xkOQHkrw8yamFc4B++7ck3zUaLl5ZOgQAAAAAAKAUmyCgywwbgU4ybOyubdt3 bEvyqiTPK90C9M5Skp9P8huj4eJK4RYAAAAAAICibIKALjNsBDrJsLHbtm3fsSnJDyb55SSnF84B +uHdSV4yGi5eUToEAAAAAACgDWyCgC4zbAQ6ybCxH7Zt3/GEjE9vfH7hFKC7Dib5mSS/MxourpaO AQAAAAAAaAubIKDLDBuBTjJs7I9t23csJPkvSV6e5KyyNUDHXJTk+0bDxatKhwAAAAAAALSNTRDQ ZYaNQCcZNvbPtu07Hpnk/yb5ttItQOvdnuRHRsPFPy8dAgAAAAAA0FY2QUCXGTYCnWTY2F/btu/4 8iQ7knxO6Raglf4oyU+Mhos7S4cAAAAAAAC0mU0Q0GWGjUAnGTb227btO05N8rNJfizJSYVzgHb4 SJLF0XDxktIhAAAAAAAAXWATBHSZYSPQSYaN82Hb9h1PTPLbSb6qdAtQzO4k/zPJ/zcaLq6UjgEA AAAAAOgKmyCgywwbgU4ybJwv27bv+KqMB45PLN0CzMx6kj9J8lOj4eJthVsAAAAAAAA6xyYI6DLD RqCTDBvnz7btO05O8qNJfjrJGYVzgOl6T5IfGg0X3106BAAAAAAAoKtsgoAuM2wEOsmwcX5t277j UUl+Icl/TrKpcA4wWddmPF7+y9Fw0RepAAAAAAAAJ8AmCOgyw0agkwwb2bZ9R5Xk15O8sHQLcML2 JPmVJL89Gi4eKh0DAAAAAADQBzZBQJcZNgKdZNjI3bZt3/GiJC9P8rTSLcAxW07yyiQ/Pxou3l46 BgAAAAAAoE9sgoAuM2wEOsmwkXvatn3HpiTfmvEV1U8snAM8uPUkf5HxoPHjpWMAAAAAAAD6yCYI 6DLDRqCTDBu5P9u279ia5D8n+bkkjyqcA9y/1yf5mdFwsSkdAgAAAAAA0Gc2QUCXGTYCnWTYyAPZ tn3HqUl+KMmPJ/mMwjnA2JsyPqHxXaVDAAAAAAAA5oFNENBlho1AJxk2cjS2bd9xRpIfSPJjMXCE UgwaAQAAAAAACrAJArrMsBHoJMNGjsXGCY7fm+Qn44pqmBWDRgAAAAAAgIJsgoAuM2wEOsmwkeOx MXD8noxPcPyswjnQR+tJ/iHJy0fDxXcXbgEAAAAAAJhrNkFAlxk2Ap1k2MiJ2LZ9x5Yk35rxCY5P LZwDfbCc5M+S/PpouHhF6RgAAAAAAAAMG4FuM2wEOsmwkUnYtn3HQpKvynjg+LzCOdBFe5O8Mslv joaLN5aOAQAAAAAA4FNsgoAuM2wEOsmwkUnbtn3HM5P8cJIXJ9latgZa7+okv5PkVaPh4p7SMQAA AAAAAHw6myCgywwbgU4ybGRatm3f8egk35/k+5I8vHAOtM3bkvxWkn8aDRfXCrcAAAAAAADwAGyC gC4zbAQ6ybCRadu2fccpSb41yWKSLyqcAyXtS/KaJP/faLj4wdIxAAAAAAAAHB2bIKDLDBuBTjJs ZJa2bd8xyHjg+B1JTiucA7Py4SQ7kvy566YBAAAAAAC6xyYI6DLDRqCTDBspYdv2HQ9N8h+SfHeS QeEcmIaDSf4myR+MhouXlo4BAAAAAADg+NkEAV1m2Ah0kmEjpW3bvuPpGQ8cvz3JZ5StgRP2ziSv SvLXTmcEAAAAAADoB5sgoMsMG4FOMmykLbZt33Fykq9O8p+SfHmSLWWL4KjdlOTPk/zxaLh4RekY AAAAAAAAJssmCOgyw0agkwwbaaNt23eck+Sbk3xHkucWzoH7syvjq6Zfk+Rto+HiWtkcAAAAAAAA psUmCOgyw0agkwwbabtt23c8Psm3ZjxyfGrZGubcgST/kvGY8V9Hw8Wlwj0AAAAAAADMgE0Q0GWG jUAnGTbSJdu279iW5BszPs3xGYVzmA97Mh4z/m2SN4yGiwcL9wAAAAAAADBjNkFAlxk2Ap1k2EhX bdu+47MyHjh+XcbXVW8qGkSf3JHk9Un+PsmbncwIAAAAAAAw32yCgC4zbAQ6ybCRPti2fcdnJHlR kq/e+OOZZYvooA8l+eeNt3ePhotrhXsAAAAAAABoCZsgoMsMG4FOMmykb7Zt37ElyfOSfFWSC5I8 vWgQbbUnyVuTvCnJP4+Gi9cX7gEAAAAAAKClbIKALjNsBDrJsJG+27Z9xyOSfFnGI8cvT/KYskUU sprk3UnesvH27tFwcaVsEgAAAAAAAF1gEwR0mWEj0EmGjcybbdt3PDnJ8zM+1fH5ST6zZA9Ts5rk vUkuTvL2JJeNhou7ixYBAAAAAADQSTZBQJcZNgKdZNjIvNu2fccTk5y38facJE9O4jdG9+xN8p4k 70zytiTvGA0XD5RNAgAAAAAAoA9sgoAuM2wEOsmwEe5t2/YdZyZ5dpIvynjo+EVJHl40ivtaS/LR jEeM797440dHw8W1olUAAAAAAAD0kk0Q0GWGjUAnGTbCg9u2fcfjkgzu8faMJI8rGjU/DiX5cJI6 yfuTfCDJB0fDxYMlowAAAAAAAJgfNkFAlxk2Ap1k2AjHZ9v2HWcnqZI8ZePtqRt/fGTJrg5bTnJF xicxfjTJR5JcnuTK0XBxpWQYAAAAAAAA880mCOgyw0agkwwbYbK2bd/xsCRPSvK5SZ648ce73+b9 SuuVJNckGSX5eJKrNt5GST5hwAgAAAAAAEAb2QQBXWbYCHSSYSPMzrbtO87I+Arrz9p4e+zGHz8z yaOTPCLj8eOmUo0n4GCSW5LcluTmJNcluX7j7bqNt1tGw8XVYoUAAAAAAABwHGyCgC4zbAQ6ybAR 2mXb9h2bkpyz8fboJGdvvJ11j7ezkzwkyekbbyclOXPjj6dtvKvTk2w5ig+5P+OTFNeT7E6ylPFI cV+Sw0n2JNl1j7e77vHH2zfebh4NF/cfxz8uAAAAAAAAtJ5NENBlho0AAAAAAAAAAABAa3TxykgA AAAAAAAAAACgpwwbAQAAAAAAAAAAgNYwbAQAAAAAAAAAAABaw7ARAAAAAAAAAAAAaA3DRgAAAAAA AAAAAKA1DBsBAAAAAAAAAACA1jBsBAAAAAAAAAAAAFrDsBEAAAAAAAAAAABoDcNGAAAAAAAAAAAA oDUMGwEAAAAAAAAAAIDWMGwEAAAAAAAAAAAAWsOwEQAAAAAAAAAAAGgNw0YAAAAAAAAAAACgNQwb AQAAAAAAAAAAgNYwbAQAAAAAAAAAAABaw7ARAAAAAAAAAAAAaA3DRgAAAAAAAAAAAKA1DBsBAAAA AAAAAACA1jBsBAAAAAAAAAAAAFrDsBEAAAAAAAAAAABoDcNGAAAAAAAAAAAAoDUMGwEAAAAAAAAA AIDWMGwEAAAAAAAAAAAAWsOwEQAAAAAAAAAAAGgNw0YAAAAAAAAAAACgNQwbAQAAAAAAAAAAgNYw bAQAAAAAAAAAAABaw7ARAAAAAAAAAAAAaA3DRgAAAAAAAAAAAKA1DBsBAAAAAAAAAACA1jBsBAAA AAAAAAAAAFrDsBEAAAAAAAAAAABoDcNGAAAAAAAAAAAAoDUMGwEAAAAAAAAAAIDWMGwEAAAAAAAA AAAAWsOwEQAAAAAAAAAAAGgNw0YAAAAAAAAAAACgNQwbAQAAAAAAAAAAgNYwbAQAAAAAAAAAAABa w7ARAAAAAAAAAAAAaA3DRgAAAAAAAAAAAKA1DBsBAAAAAAAAAACA1jBsBAAAAAAAAAAAAFrDsBEA AAAAAAAAAABoDcNGAAAAAAAAAAAAoDUMGwEAAAAAAAAAAIDWMGwEAAAAAAAAAAAAWsOwEQAAAAAA AAAAAGgNw0YAAAAAAAAAAACgNQwbAQAAAAAAAAAAgNYwbAQAAAAAAAAAAABaw7ARAAAAAAAAAAAA aA3DRgAAAAAAAAAAAKA1DBsBAAAAAAAAAACA1jBsBAAAAAAAAAAAAFrDsBEAAAAAAAAAAABoDcNG AAAAAAAAAAAAoDUMGwEAAAAAAAAAAIDWMGwEAAAAAAAAAAAAWsOwEQAAAAAAAAAAAGgNw0YAAAAA AAAAAACgNQwbAQAAAAAAAAAAgNYwbAQAAAAAAAAAAABaw7ARAAAAAAAAAAAAaA3DRgAAAAAAAAAA AKA1DBsBAAAAAAAAAACA1jBsBAAAAAAAAAAAAFrDsBEAAAAAAAAAAABoDcNGAAAAAAAAAAAAoDUM GwEAAAAAAAAAAIDWMGwEAAAAAAAAAAAAWsOwEQAAAAAAAAAAAGgNw0YAAAAAAAAAAACgNQwbAQAA AAAAAAAAgNYwbAQAAAAAAAAAAABaw7ARAAAAAAAAAAAAaA3DRgAAAAAAAAAAAKA1DBsBAAAAAAAA AACA1jBsBAAAAAAAAAAAAFrDsBEAAAAAAAAAAABoDcNGAAAAAAAAAAAAoDUMGwEAAAAAAAAAAIDW MGwEAAAAAAAAAAAAWsOwEQAAAAAAAAAAAGgNw0YAAAAAAAAAAACgNQwbAQAAAAAAAAAAgNYwbAQA AAAAAAAAAABaw7ARAAAAAAAAAAAAaA3DRgAAAAAAAAAAAKA1DBsBAAAAAAAAAACA1jBsBAAAAAAA AAAAAFrDsBEAAAAAAAAAAABoDcNGAAAAAAAAAAAAoDUMGwEAAAAAAAAAAIDWMGwEAAAAAAAAAAAA WsOwEQAAAAAAAAAAAGgNw0YAAAAAAAAAAACgNQwbAQAAAAAAAAAAgNYwbAQAAAAAAAAAAABaw7AR AAAAAAAAAAAAaA3DRgAAAAAAAAAAAKA1DBsBAAAAAAAAAACA1jBsBAAAAAAAAAAAAFrDsBEAAAAA AAAAAABoDcNGAAAAAAAAAAAAoDUMGwEAAAAAAAAAAIDWMGwEAAAAAAAAAAAAWsOwEQAAAAAAAAAA AGgNw0YAAAAAAAAAAACgNQwbAQAAAAAAAAAAgNYwbAQAAAAAAAAAAABaw7ARAAAAAAAAAAAAaA3D RgAAAAAAAAAAAKA1DBsBAAAAAAAAAACA1jBsBAAAAAAAAAAAAFrDsBEAAAAAAAAAAABoDcNGAAAA AAAAAAAAoDUMGwEAAAAAAAAAAIDWMGwEAAAAAAAAAAAAWsOwEQAAAAAAAAAAAGgNw0YAAAAAAAAA AACgNQwbAQAAAAAAAAAAgNYwbAQAAAAAAAAAAABaw7ARAAAAAAAAAAAAaA3DRgAAAAAAAAAAAKA1 DBsBAAAAAAAAAACA1jBsBAAAAAAAAAAAAFrDsBEAAAAAAAAAAABoDcPG/79dOxYAAAAAGORvPY0d xREAAAAAAAAAAACwITYCAAAAAAAAAAAAG2IjAAAAAAAAAAAAsCE2AgAAAAAAAAAAABtiIwAAAAAA AAAAALAhNgIAAAAAAAAAAAAbYiMAAAAAAAAAAACwITYCAAAAAAAAAAAAG2IjAAAAAAAAAAAAsCE2 AgAAAAAAAAAAABtiIwAAAAAAAAAAALAhNgIAAAAAAAAAAAAbYiMAAAAAAAAAAACwITYCAAAAAAAA AAAAG2IjAAAAAAAAAAAAsCE2AgAAAAAAAAAAABtiIwAAAAAAAAAAALAhNgIAAAAAAAAAAAAbYiMA AAAAAAAAAACwITYCAAAAAAAAAAAAG2IjAAAAAAAAAAAAsCE2AgAAAAAAAAAAABtiIwAAAAAAAAAA ALAhNgIAAAAAAAAAAAAbYiMAAAAAAAAAAACwITYCAAAAAAAAAAAAG2IjAAAAAAAAAAAAsCE2AgAA AAAAAAAAABtiIwAAAAAAAAAAALAhNgIAAAAAAAAAAAAbYiMAAAAAAAAAAACwITYCAAAAAAAAAAAA G2IjAAAAAAAAAAAAsCE2AgAAAAAAAAAAABtiIwAAAAAAAAAAALAhNgIAAAAAAAAAAAAbYiMAAAAA AAAAAACwITYCAAAAAAAAAAAAG2IjAAAAAAAAAAAAsCE2AgAAAAAAAAAAABtiIwAAAAAAAAAAALAh NgIAAAAAAAAAAAAbYiMAAAAAAAAAAACwITYCAAAAAAAAAAAAG2IjAAAAAAAAAAAAsCE2AgAAAAAA AAAAABtiIwAAAAAAAAAAALAhNgIAAAAAAAAAAAAbYiMAAAAAAAAAAACwITYCAAAAAAAAAAAAG2Ij AAAAAAAAAAAAsCE2AgAAAAAAAAAAABtiIwAAAAAAAAAAALAhNgIAAAAAAAAAAAAbYiMAAAAAAAAA AACwITYCAAAAAAAAAAAAG2IjAAAAAAAAAAAAsCE2AgAAAAAAAAAAABtiIwAAAAAAAAAAALAhNgIA AAAAAAAAAAAbYiMAAAAAAAAAAACwITYCAAAAAAAAAAAAG2IjAAAAAAAAAAAAsCE2AgAAAAAAAAAA ABtiIwAAAAAAAAAAALAhNgIAAAAAAAAAAAAbYiMAAAAAAAAAAACwITYCAAAAAAAAAAAAG2IjAAAA AAAAAAAAsCE2AgAAAAAAAAAAABtiIwAAAAAAAAAAALAhNgIAAAAAAAAAAAAbYiMAAAAAAAAAAACw ITYCAAAAAAAAAAAAG2IjAAAAAAAAAAAAsCE2AgAAAAAAAAAAABtiIwAAAAAAAAAAALAhNgIAAAAA AAAAAAAbYiMAAAAAAAAAAACwEYqfd7IzTKj+AAAAAElFTkSuQmCC"
          id="image1"
          x={-9.862}
          y={36.456}
        />
        <text
          x={442.873}
          y={112.457}
          fill="#000"
          fontFamily="Helvetica"
          fontSize={3.627}
          textAnchor="middle"
          id="ftr103_text-9-5"
          style={{
            strokeWidth: 0.229842
          }}
        >
          {'Atmospheric Pressure'}
        </text>
        <text
          x={443.611}
          y={130.849}
          fill="#000"
          fontFamily="Helvetica"
          fontSize={2.627}
          textAnchor="middle"
          id="ttr101_body"
          style={{
            strokeWidth: 0.229842
          }}
          className={clsttr101_body}
        >
          {ttr101_value}
        </text>
        <text
          x={442.719}
          y={143.981}
          fill="#000"
          fontFamily="Helvetica"
          fontSize={2.627}
          textAnchor="middle"
          id="dsw101_body"
          style={{
            strokeWidth: 0.229842
          }}
          className={clsdsw101_body}
        >
          {dsw101_value}
        </text>
        <text
          x={442.517}
          y={157.716}
          fill="#000"
          fontFamily="Helvetica"
          fontSize={2.627}
          textAnchor="middle"
          id="acp101_power_body"
          style={{
            strokeWidth: 0.229842
          }}
          className={clsacp101_body}
        >
          {acp101_value}
        </text>
        <text
          x={443.333}
          y={117.592}
          fill="#000"
          fontFamily="Helvetica"
          fontSize={2.627}
          textAnchor="middle"
          id="ptc109_pressure_body"
          style={{
            strokeWidth: 0.229842
          }}
          className={clsptc109_body}
        >
          {ptc109_value}
        </text>
        <text
          x={443.198}
          y={126.112}
          fill="#000"
          fontFamily="Helvetica"
          fontSize={3.627}
          textAnchor="middle"
          id="ftr103_text-9-5-8"
          style={{
            strokeWidth: 0.229842
          }}
        >
          {'Enclosure Air Temperature '}
        </text>
        <text
          x={442.899}
          y={138.963}
          fill="#000"
          fontFamily="Helvetica"
          fontSize={3.627}
          textAnchor="middle"
          id="ftr103_text-9-5-8-1"
          style={{
            strokeWidth: 0.229842
          }}
        >
          {'Enclosure Doors State'}
        </text>
        <text
          x={443.243}
          y={152.14}
          fill="#000"
          fontFamily="Helvetica"
          fontSize={3.627}
          textAnchor="middle"
          id="ftr103_text-9-5-2"
          style={{
            strokeWidth: 0.229842
          }}
        >
          {'System Input Power Consumption'}
        </text>
        <path
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: '.162665px',
            strokeLinecap: 'butt',
            strokeLinejoin: 'miter',
            strokeOpacity: 1
          }}
          d="m146.674 98.731 5.423.026"
          id="tnk102_line_2"
          className={clstnk102_line_2}
        />
        <path
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: '.173538px',
            strokeLinecap: 'butt',
            strokeLinejoin: 'miter',
            strokeOpacity: 1
          }}
          d="m153.394 98.74 8.297.018"
          id="tnk102_line_2-1"
          className={clstnk102_line_2}
        />
        <path
          d="m161.776 106.22-.07-7.38"
          style={{
            strokeWidth: 0.168456
          }}
          id="tnk104_line_3"
          className={clstnk104_line_3}
          fill="none"
          strokeMiterlimit={10}
          pointerEvents="none"
          stroke="#000"
        />
        <text
          x={142.355}
          y={126.417}
          id="ptc103_value"
          style={{
            fontSize: '4.23333px',
            textAnchor: 'middle',
            strokeWidth: 0.352777
          }}
          className={clsshow_sensor}
        >
          <tspan
            fontFamily="Calibri"
            fontSize={2.117}
            fill="#000"
            fillOpacity={1}
            strokeOpacity={1}
            id="tspan121-3-2-64"
            style={{
              strokeWidth: 0.352777
            }}
          >
            {ptc103_value}
          </tspan>
        </text>
        <text
          x={175.187}
          y={62.134}
          id="ppc101_value"
          style={{
            fontSize: '4.23333px',
            textAnchor: 'middle',
            strokeWidth: 0.352777
          }}
          className={clsshow_sensor}
        >
          <tspan
            fontFamily="Calibri"
            fontSize={2.117}
            fill="#000"
            fillOpacity={1}
            strokeOpacity={1}
            id="tspan121-3-2-85"
            style={{
              strokeWidth: 0.352777
            }}
          >
            {ppc101_value}
          </tspan>
        </text>
        <text
          x={188.928}
          y={95.915}
          id="tnk104_value"
          style={{
            fontSize: '4.23333px',
            textAnchor: 'middle',
            strokeWidth: 0.352777
          }}
          className={clsshow_sensor}
        >
          <tspan
            fontFamily="Calibri"
            fontSize={2.117}
            fill="#000"
            fillOpacity={1}
            strokeOpacity={1}
            id="tspan121-3-2-0"
            style={{
              strokeWidth: 0.352777
            }}
          >
            {tnk104_value}
          </tspan>
        </text>
        <text
          x={163.009}
          y={113.553}
          id="vbl119_value"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
          className={clsshow_sensor}
        >
          <tspan
            fontFamily="Calibri"
            fontSize={2.117}
            fill="#000"
            fillOpacity={1}
            strokeOpacity={1}
            id="tspan121-3-2-1-0-7"
            style={{
              strokeWidth: 0.352777
            }}
          >
            {vbl119_value}
          </tspan>
        </text>
        <text
          x={162.809}
          y={134.139}
          id="vbl118_value"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
          className={clsshow_sensor}
        >
          <tspan
            fontFamily="Calibri"
            fontSize={2.117}
            fill="#000"
            fillOpacity={1}
            strokeOpacity={1}
            id="tspan121-3-2-1-0-7-5"
            style={{
              strokeWidth: 0.352777
            }}
          >
            {vbl118_value}
          </tspan>
        </text>
        <text
          x={173.083}
          y={129.627}
          id="ppf101_value"
          style={{
            fontSize: '4.23333px',
            textAnchor: 'middle',
            strokeWidth: 0.352777
          }}
          className={clsshow_sensor}
        >
          <tspan
            fontFamily="Calibri"
            fontSize={2.117}
            fill="#000"
            fillOpacity={1}
            strokeOpacity={1}
            id="tspan121-3-2-6-6"
            style={{
              strokeWidth: 0.352777
            }}
          >
            {ppf101_value}
          </tspan>
        </text>
        <text
          x={182.84}
          y={108.397}
          id="ptc102_value"
          style={{
            fontSize: '4.23333px',
            textAnchor: 'middle',
            strokeWidth: 0.352777
          }}
          className={clsshow_sensor}
        >
          <tspan
            fontFamily="Calibri"
            fontSize={2.117}
            fill="#000"
            fillOpacity={1}
            strokeOpacity={1}
            id="tspan121-3-2-6-6-4"
            style={{
              strokeWidth: 0.352777
            }}
          >
            {ptc102_value}
          </tspan>
        </text>
        <text
          x={197.845}
          y={108.407}
          id="ftr102_value"
          style={{
            fontSize: '4.23333px',
            textAnchor: 'middle',
            strokeWidth: 0.352777
          }}
          className={clsshow_sensor}
        >
          <tspan
            fontFamily="Calibri"
            fontSize={2.117}
            fill="#000"
            fillOpacity={1}
            strokeOpacity={1}
            id="tspan121-3-2-6-6-4-2"
            style={{
              strokeWidth: 0.352777
            }}
          >
            {ftr102_value}
          </tspan>
        </text>
        <path
          d="M176.882 121.304h29.683"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.17,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="input_line_7"
          className={clsinput_line_7}
        />
        <text
          x={156.638}
          y={160.023}
          id="text75-9"
          transform="scale(1.35514 .73793)"
          style={{
            fontSize: '5.73673px',
            strokeWidth: 0.478061
          }}
        />
        <text
          x={205.844}
          y={162.088}
          id="vbl105_value"
          style={{
            fontSize: '4.23333px',
            textAnchor: 'middle',
            strokeWidth: 0.352777
          }}
          className={clsshow_sensor}
        >
          <tspan
            fontFamily="Calibri"
            fontSize={2.117}
            fill="#000"
            fillOpacity={1}
            strokeOpacity={1}
            id="tspan121-3-2-6-6-4-0"
            style={{
              strokeWidth: 0.352777
            }}
          >
            {vbl105_value}
          </tspan>
        </text>
        <path
          d="M215.515 191.82h21.293"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.17,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="path28-4-3"
          className={clswaste1_line_2}
        />
        <text
          x={220.405}
          y={121.398}
          id="ptc104_value"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
          className={clsshow_sensor}
        >
          <tspan
            fontFamily="Calibri"
            fontSize={2.117}
            fill="#000"
            fillOpacity={1}
            strokeOpacity={1}
            id="tspan121-3-2-6-6-4-1"
            style={{
              strokeWidth: 0.352777
            }}
          >
            {ptc104_value}
          </tspan>
        </text>
        <text
          x={238.478}
          y={161.923}
          id="vbl106_value"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
          className={clsshow_sensor}
        >
          <tspan
            fontFamily="Calibri"
            fontSize={2.117}
            fill="#000"
            fillOpacity={1}
            strokeOpacity={1}
            id="tspan121-3-2-1-0-7-5-1"
            style={{
              strokeWidth: 0.352777
            }}
          >
            {vbl106_value}
          </tspan>
        </text>
        <path
          d="M236.786 191.828h38.918"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.17,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="path28-4-3-1"
          className={clswaste1_line_3}
        />
        <text
          x={250.849}
          y={139.635}
          id="vbl108_value"
          style={{
            fontSize: '4.23333px',
            textAnchor: 'middle',
            strokeWidth: 0.352777
          }}
          className={clsshow_sensor}
        >
          <tspan
            fontFamily="Calibri"
            fontSize={2.117}
            fill="#000"
            fillOpacity={1}
            strokeOpacity={1}
            id="tspan121-3-2-6-6-4-0-2"
            style={{
              strokeWidth: 0.352777
            }}
          >
            {vbl108_value}
          </tspan>
        </text>
        <path
          d="M254.714 133.412h21"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.17,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="path75-0"
          className={clsinput_line_11}
        />
        <text
          x={236.691}
          y={154.049}
          id="text75-2"
          transform="scale(1.18323 .84514)"
          style={{
            fontSize: '5.00901px',
            strokeWidth: 0.417418
          }}
        />
        <g id="g16">
          <path
            d="M275.759 133.45v20.852"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.207972,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="input_line_13"
            className={clsinput_line_13}
          />
        </g>
        <text
          x={262.642}
          y={120.606}
          id="ptc107_value"
          style={{
            fontSize: '4.23333px',
            textAnchor: 'middle',
            strokeWidth: 0.352777
          }}
          className={clsshow_sensor}
        >
          <tspan
            fontFamily="Calibri"
            fontSize={2.117}
            fill="#000"
            fillOpacity={1}
            strokeOpacity={1}
            id="tspan121-3-2-6-6-4-25"
            style={{
              strokeWidth: 0.352777
            }}
          >
            {ptc107_value}
          </tspan>
        </text>
        <text
          x={266.286}
          y={162.247}
          id="vbl110_value"
          style={{
            fontSize: '4.23333px',
            textAnchor: 'middle',
            strokeWidth: 0.352777
          }}
          className={clsshow_sensor}
        >
          <tspan
            fontFamily="Calibri"
            fontSize={2.117}
            fill="#000"
            fillOpacity={1}
            strokeOpacity={1}
            id="tspan121-3-2-6-6-4-0-2-8"
            style={{
              strokeWidth: 0.352777
            }}
          >
            {vbl110_value}
          </tspan>
        </text>
        <path
          d="M275.781 163.292v28.51"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.171952,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="vbl110_line"
          className={clsvbl110_line}
        />
        <path
          d="M293.676 163.432v28.404"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.171634,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="vbl107_line"
          className={clsvbl107_line}
        />
        <g id="g4">
          <path
            d="M275.757 191.87h17.98"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.136552,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="path8"
            className={clswaste1_line_4}
          />
        </g>
        <text
          x={275.534}
          y={57.737}
          id="ptc110_value"
          style={{
            fontSize: '4.23333px',
            textAnchor: 'middle',
            strokeWidth: 0.352777
          }}
          className={clsshow_sensor}
        >
          <tspan
            fontFamily="Calibri"
            fontSize={2.117}
            fill="#000"
            fillOpacity={1}
            strokeOpacity={1}
            id="tspan121-3-2-6-6-4-25-7"
            style={{
              strokeWidth: 0.352777
            }}
          >
            {ptc110_value}
          </tspan>
        </text>
        <text
          x={291.069}
          y={57.487}
          id="ctr102_value"
          style={{
            fontSize: '4.23333px',
            textAnchor: 'middle',
            strokeWidth: 0.352777
          }}
          className={clsshow_sensor}
        >
          <tspan
            fontFamily="Calibri"
            fontSize={2.117}
            fill="#000"
            fillOpacity={1}
            strokeOpacity={1}
            id="tspan121-3-2-6-6-4-25-7-3"
            style={{
              strokeWidth: 0.352777
            }}
          >
            {ctr102_value}
          </tspan>
        </text>
        <text
          x={306.357}
          y={62.664}
          id="vbl109_value"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
          className={clsshow_sensor}
        >
          <tspan
            fontFamily="Calibri"
            fontSize={2.117}
            fill="#000"
            fillOpacity={1}
            strokeOpacity={1}
            id="tspan121-3-2-1-0-7-5-1-5"
            style={{
              strokeWidth: 0.352777
            }}
          >
            {vbl109_value}
          </tspan>
        </text>
        <text
          x={313.809}
          y={76.794}
          id="vbl112_value"
          style={{
            fontSize: '4.23333px',
            textAnchor: 'middle',
            strokeWidth: 0.352777
          }}
          className={clsshow_sensor}
        >
          <tspan
            fontFamily="Calibri"
            fontSize={2.117}
            fill="#000"
            fillOpacity={1}
            strokeOpacity={1}
            id="tspan121-3-2-6-6-4-0-2-5"
            style={{
              strokeWidth: 0.352777
            }}
          >
            {vbl112_value}
          </tspan>
        </text>
        <text
          x={334.372}
          y={131.92}
          id="ppa102_value"
          style={{
            fontSize: '4.23333px',
            textAnchor: 'middle',
            strokeWidth: 0.352777
          }}
          className={clsshow_sensor}
        >
          <tspan
            fontFamily="Calibri"
            fontSize={2.117}
            fill="#000"
            fillOpacity={1}
            strokeOpacity={1}
            id="tspan121-3-2-6-6-4-0-2-5-1"
            style={{
              strokeWidth: 0.352777
            }}
          >
            {ppa102_value}
          </tspan>
        </text>
        <text
          x={284.368}
          y={162.185}
          id="vbl107_value"
          style={{
            fontSize: '4.23333px',
            textAnchor: 'middle',
            strokeWidth: 0.352777
          }}
          className={clsshow_sensor}
        >
          <tspan
            fontFamily="Calibri"
            fontSize={2.117}
            fill="#000"
            fillOpacity={1}
            strokeOpacity={1}
            id="tspan121-3-2-6-6-4-0-2-8-8"
            style={{
              strokeWidth: 0.352777
            }}
          >
            {vbl107_value}
          </tspan>
        </text>
        <text
          x={307.972}
          y={161.602}
          id="vbl111_value"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
          className={clsshow_sensor}
        >
          <tspan
            fontFamily="Calibri"
            fontSize={2.117}
            fill="#000"
            fillOpacity={1}
            strokeOpacity={1}
            id="tspan121-3-2-1-0-7-5-1-3"
            style={{
              strokeWidth: 0.352777
            }}
          >
            {vbl111_value}
          </tspan>
        </text>
        <g id="g5">
          <path
            d="M293.708 191.851h122.883"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.136773,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="waste1_line_5"
            className={clswaste1_line_5}
          />
        </g>
        <text
          x={187.775}
          y={-173.725}
          id="text56-9"
          transform="scale(.94174 -1.06186)"
          style={{
            fontSize: '3.99006px',
            strokeWidth: 0.332505
          }}
        />
        <path
          d="M151.204 172.287v4.58"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.17,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="path28-4-1-74"
        />
        <path
          d="M214.694 176.787h-63.311"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.17,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="path28-4-1-74-7"
        />
        <path
          d="M216.323 176.76h19.207"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.17,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="path28-4-3-3"
        />
        <path
          d="M238.083 176.751h36.904"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.17,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="path28-4-3-3-4"
        />
        <path
          d="M276.466 176.822h16.617"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.17,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="path28-4-3-3-3"
        />
        <path
          d="M294.172 176.813h11.607"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.17,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="path28-4-3-3-6"
        />
        <g id="g31">
          <path
            d="m401.764 172.125.027 4.659"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.15718,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="vbl115_line"
            className={clsvbl115_line}
          />
        </g>
        <text
          x={360.778}
          y={195.64}
          id="text177-5"
          transform="scale(1.12221 .8911)"
          style={{
            fontSize: '3.77231px',
            strokeWidth: 0.314359
          }}
        />
        <path
          d="M401.863 176.785h14.867"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.176389,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="waste2_line_3"
          className={clswaste2_line_3}
        />
        <text
          x={419.834}
          y={173.567}
          id="text75-8"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        />
        <text
          x={438.779}
          y={171.467}
          id="ptc114_value"
          style={{
            fontSize: '4.23333px',
            textAnchor: 'middle',
            strokeWidth: 0.352777
          }}
          className={clsshow_sensor}
        >
          <tspan
            fontFamily="Calibri"
            fontSize={2.117}
            fill="#000"
            fillOpacity={1}
            strokeOpacity={1}
            id="tspan121-3-2-6-6-4-25-7-2"
            style={{
              strokeWidth: 0.352777
            }}
          >
            {ptc114_value}
          </tspan>
        </text>
        <path
          d="M368.717 64.257v5.985"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.143842,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="recirc_line_2"
          className={clsrecirc_line_2}
        />
        <text
          x={370.04}
          y={62.403}
          id="vbl113_value"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
          className={clsshow_sensor}
        >
          <tspan
            fontFamily="Calibri"
            fontSize={2.117}
            fill="#000"
            fillOpacity={1}
            strokeOpacity={1}
            id="tspan121-3-2-1-0-7-5-1-6"
            style={{
              strokeWidth: 0.352777
            }}
          >
            {vbl113_value}
          </tspan>
        </text>
        <text
          x={390.381}
          y={81.362}
          id="uvi101_value"
          style={{
            fontSize: '4.23333px',
            textAnchor: 'middle',
            strokeWidth: 0.352777
          }}
          className={clsshow_sensor}
        >
          <tspan
            fontFamily="Calibri"
            fontSize={2.117}
            fill="#000"
            fillOpacity={1}
            strokeOpacity={1}
            id="tspan121-3-2-6-6-4-0-2-5-3"
            style={{
              strokeWidth: 0.352777
            }}
          >
            {uvi101_value}
          </tspan>
        </text>
        <text
          x={390.742}
          y={57.542}
          id="ptc111_value"
          style={{
            fontSize: '4.23333px',
            textAnchor: 'middle',
            strokeWidth: 0.352777
          }}
          className={clsshow_sensor}
        >
          <tspan
            fontFamily="Calibri"
            fontSize={2.117}
            fill="#000"
            fillOpacity={1}
            strokeOpacity={1}
            id="tspan121-3-2-6-6-4-25-7-1"
            style={{
              strokeWidth: 0.352777
            }}
          >
            {ptc111_value}
          </tspan>
        </text>
        <g id="g25">
          <path
            d="M401.719 70.221v84.139"
            style={{
              fill: 'none',
              stroke: '#000',
              strokeWidth: 0.164277,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeDasharray: 'none'
            }}
            id="output_line_12"
            className={clsoutput_line_12}
          />
        </g>
        <text
          x={405.67}
          y={63.445}
          id="vbl114_value"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
          className={clsshow_sensor}
        >
          <tspan
            fontFamily="Calibri"
            fontSize={2.117}
            fill="#000"
            fillOpacity={1}
            strokeOpacity={1}
            id="tspan121-3-2-1-0-7-5-1-6-8"
            style={{
              strokeWidth: 0.352777
            }}
          >
            {vbl114_value}
          </tspan>
        </text>
        <text
          x={425.395}
          y={57.402}
          id="ftr103_value"
          style={{
            fontSize: '4.23333px',
            textAnchor: 'middle',
            strokeWidth: 0.352777
          }}
          className={clsshow_sensor}
        >
          <tspan
            fontFamily="Calibri"
            fontSize={2.117}
            fill="#000"
            fillOpacity={1}
            strokeOpacity={1}
            id="tspan121-3-2-6-6-4-25-7-1-9"
            style={{
              strokeWidth: 0.352777
            }}
          >
            {ftr103_value}
          </tspan>
        </text>
        <text
          x={436.962}
          y={76.951}
          id="vbl116_value"
          style={{
            fontSize: '4.23333px',
            textAnchor: 'middle',
            strokeWidth: 0.352777
          }}
          className={clsshow_sensor}
        >
          <tspan
            fontFamily="Calibri"
            fontSize={2.117}
            fill="#000"
            fillOpacity={1}
            strokeOpacity={1}
            id="tspan121-3-2-6-6-4-0-2-8-8-6"
            style={{
              strokeWidth: 0.352777
            }}
          >
            {vbl116_value}
          </tspan>
        </text>
        <text
          x={402.9}
          y={161.82}
          id="vbl115_value"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
          className={clsshow_sensor}
        >
          <tspan
            fontFamily="Calibri"
            fontSize={2.117}
            fill="#000"
            fillOpacity={1}
            strokeOpacity={1}
            id="tspan121-3-2-1-0-7-5-1-6-0"
            style={{
              strokeWidth: 0.352777
            }}
          >
            {vbl115_value}
          </tspan>
        </text>
        <text
          x={320.771}
          y={57.582}
          id="vbl109_value-8"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
          className={clsshow_sensor}
        />
        <text
          x={327.713}
          y={57.667}
          id="trb102_value"
          style={{
            fontSize: '4.23333px',
            textAnchor: 'middle',
            strokeWidth: 0.352777
          }}
          className={clsshow_sensor}
        >
          <tspan
            fontFamily="Calibri"
            fontSize={2.117}
            fill="#000"
            fillOpacity={1}
            strokeOpacity={1}
            id="tspan121-3-2-6-6-4-25-7-3-6"
            style={{
              strokeWidth: 0.352777
            }}
          >
            {trb102_value}
          </tspan>
        </text>
        <path
          d="M314.7 122.799h-3v-7.5l-.019.053"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.176389,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="dit_line_3_id"
          className={clsdit_line_3}
        />
        <text
          x={316.976}
          y={-134.02}
          id="text99-9"
          transform="scale(1 -1)"
          style={{
            fontSize: '4.23333px',
            strokeWidth: 0.352777
          }}
        />
        <path
          d="M305.84 176.788h95.967"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.17,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="waste2_line_2"
          className={clswaste2_line_2}
        />
        <path
          d="m401.768 64.252-.02 5.925"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.176183,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="path140-5"
          className={clsoutput_line_8}
        />
        <path
          d="m38.849 133.38 49.875.133"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.176389,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="air_line_2_1"
          className={clsaair_line_2}
        />
        <path
          d="m90.633 133.423 19.404-.113"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.176389,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="air_line_2_2"
          className={clsaair_line_2}
        />
        <path
          d="M23.757 133.37h5.902"
          style={{
            fill: 'none',
            stroke: '#000',
            strokeWidth: 0.153054,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: 'none'
          }}
          id="path6"
          className={clsaair_line_1}
        />
        <g>{gatewayUnit}</g>
      </g>

      <defs id="defs1">
        <marker
          id="endMarker1"
          markerUnits="strokeWidth"
          orient="auto"
          markerWidth={8}
          markerHeight={6}
          viewBox="0 0 10 10"
          refX={1}
          refY={5}
        >
          <path fill="solid" id="polyline7" d="m0 0 10 5-10 5 1-5" />
        </marker>
        <marker
          id="endMarker2"
          markerUnits="strokeWidth"
          orient="auto"
          markerWidth={8}
          markerHeight={6}
          viewBox="0 0 10 10"
          refX={1}
          refY={5}
        >
          <path fill="solid" id="polyline24" d="m0 0 10 5-10 5 1-5" />
        </marker>
        <marker
          id="endMarker3"
          markerUnits="strokeWidth"
          orient="auto"
          markerWidth={8}
          markerHeight={6}
          viewBox="0 0 10 10"
          refX={1}
          refY={5}
        >
          <path fill="solid" id="polyline39" d="m0 0 10 5-10 5 1-5" />
        </marker>
        <marker
          id="endMarker4"
          markerUnits="strokeWidth"
          orient="auto"
          markerWidth={8}
          markerHeight={6}
          viewBox="0 0 10 10"
          refX={1}
          refY={5}
        >
          <path fill="solid" id="polyline48" d="m0 0 10 5-10 5 1-5" />
        </marker>
        <marker
          id="endMarker5"
          markerUnits="strokeWidth"
          orient="auto"
          markerWidth={8}
          markerHeight={6}
          viewBox="0 0 10 10"
          refX={1}
          refY={5}
        >
          <path fill="solid" id="polyline53" d="m0 0 10 5-10 5 1-5" />
        </marker>
        <marker
          id="startMarker1"
          markerUnits="strokeWidth"
          orient="auto"
          markerWidth={8}
          markerHeight={6}
          viewBox="0 0 10 10"
          refX={9}
          refY={5}
        >
          <path fill="solid" id="polyline93" d="M10 0 0 5l10 5-1-5" />
        </marker>
        <marker
          id="endMarker6"
          markerUnits="strokeWidth"
          orient="auto"
          markerWidth={8}
          markerHeight={6}
          viewBox="0 0 10 10"
          refX={1}
          refY={5}
        >
          <path fill="solid" id="polyline100" d="m0 0 10 5-10 5 1-5" />
        </marker>
        <marker
          id="endMarker7"
          markerUnits="strokeWidth"
          orient="auto"
          markerWidth={8}
          markerHeight={6}
          viewBox="0 0 10 10"
          refX={1}
          refY={5}
        >
          <path fill="solid" id="polyline104" d="m0 0 10 5-10 5 1-5" />
        </marker>
        <marker
          id="endMarker8"
          markerUnits="strokeWidth"
          orient="auto"
          markerWidth={8}
          markerHeight={6}
          viewBox="0 0 10 10"
          refX={1}
          refY={5}
        >
          <path fill="solid" id="polyline155" d="m0 0 10 5-10 5 1-5" />
        </marker>
        <marker
          id="endMarker9"
          markerUnits="strokeWidth"
          orient="auto"
          markerWidth={8}
          markerHeight={6}
          viewBox="0 0 10 10"
          refX={1}
          refY={5}
        >
          <path fill="solid" id="polyline157" d="m0 0 10 5-10 5 1-5" />
        </marker>
        <marker
          id="endMarker10"
          markerUnits="strokeWidth"
          orient="auto"
          markerWidth={8}
          markerHeight={6}
          viewBox="0 0 10 10"
          refX={1}
          refY={5}
        >
          <path fill="solid" id="polyline180" d="m0 0 10 5-10 5 1-5" />
        </marker>
        <marker
          id="endMarker3-9"
          markerUnits="strokeWidth"
          orient="auto"
          markerWidth={8}
          markerHeight={6}
          viewBox="0 0 10 10"
          refX={1}
          refY={5}
        >
          <path fill="solid" id="polyline39-0" d="m0 0 10 5-10 5 1-5" />
        </marker>
        <defs id="defs39">
          <marker
            id="marker3"
            markerUnits="strokeWidth"
            orient="auto"
            markerWidth={8}
            markerHeight={6}
            viewBox="0 0 10 10"
            refX={1}
            refY={5}
          >
            <path fill="solid" id="polyline3" d="m0 0 10 5-10 5 1-5" />
          </marker>
        </defs>
        <defs id="defs100">
          <marker
            id="marker8"
            markerUnits="strokeWidth"
            orient="auto"
            markerWidth={8}
            markerHeight={6}
            viewBox="0 0 10 10"
            refX={1}
            refY={5}
          >
            <path fill="solid" id="polyline8" d="m0 0 10 5-10 5 1-5" />
          </marker>
        </defs>
        <defs id="defs104">
          <marker
            id="marker9"
            markerUnits="strokeWidth"
            orient="auto"
            markerWidth={8}
            markerHeight={6}
            viewBox="0 0 10 10"
            refX={1}
            refY={5}
          >
            <path fill="solid" id="polyline9" d="m0 0 10 5-10 5 1-5" />
          </marker>
        </defs>
      </defs>
    </svg>
  );
};

export default DeviceSchematicAlpha2SvgVer3;
